import { CurrencyType } from '../../config/common/currency';

const common = {
  CountryList: {
    "Afghanistan": "阿富汗",
    "ÅlandIslands": "奧蘭群島",
    "Albania": "阿爾巴尼亞",
    "Algeria": "阿爾及利亞",
    "AmericanSamoa": "美屬薩摩亞",
    "Andorra": "安道爾",
    "Angola": "安哥拉",
    "Anguilla": "安圭拉",
    "Antarctica": "南極洲",
    "AntiguaandBarbuda": "安地卡及巴布達",
    "Argentina": "阿根廷",
    "Armenia": "亞美尼亞",
    "Aruba": "阿魯巴",
    "Australia": "澳洲",
    "Austria": "奧地利",
    "Azerbaijan": "亞塞拜然",
    "Bahamas": "巴哈馬",
    "Bahrain": "巴林",
    "Bangladesh": "孟加拉",
    "Barbados": "巴貝多",
    "Belarus": "白俄羅斯",
    "Belgium": "比利時",
    "Belize": "貝里斯",
    "Benin": "貝南",
    "Bermuda": "百慕達",
    "Bhutan": "不丹",
    "Bolivia": "玻利維亞",
    "BosniaandHerzegovina": "波士尼亞與赫塞哥維納",
    "Botswana": "波札那",
    "BouvetIsland": "布威島",
    "Brazil": "巴西",
    "BritishIndianOceanTerritory": "英屬印度洋領地",
    "BruneiDarussalam": "汶萊",
    "Bulgaria": "保加利亞",
    "BurkinaFaso": "布吉納法索",
    "Burundi": "蒲隆地",
    "Cambodia": "柬埔寨",
    "Cameroon": "喀麥隆",
    "Canada": "加拿大",
    "CapeVerde": "維德角",
    "CaymanIslands": "開曼群島",
    "CentralAfricanRepublic": "中非共和國",
    "Chad": "查德",
    "Chile": "智利",
    "China": "中國",
    "ChristmasIsland": "聖誕島",
    "CocosKeelingIslands": "科科斯（基林）群島",
    "Colombia": "哥倫比亞",
    "Comoros": "葛摩",
    "Congo": "剛果",
    "CongoTheDemocraticRepublicofthe": "剛果民主共和國",
    "CookIslands": "庫克群島",
    "CostaRica": "哥斯大黎加",
    "CoteDIvoire": "象牙海岸",
    "Croatia": "克羅埃西亞",
    "Cuba": "古巴",
    "Cyprus": "賽普勒斯",
    "CzechRepublic": "捷克共和國",
    "Denmark": "丹麥",
    "Djibouti": "吉布地",
    "Dominica": "多米尼克",
    "DominicanRepublic": "多明尼加共和國",
    "Ecuador": "厄瓜多",
    "Egypt": "埃及",
    "ElSalvador": "薩爾瓦多",
    "EquatorialGuinea": "赤道幾內亞",
    "Eritrea": "厄利垂亞",
    "Estonia": "愛沙尼亞",
    "Ethiopia": "衣索比亞",
    "FalklandIslandsMalvinas": "福克蘭群島（馬爾維納斯群島）",
    "FaroeIslands": "法羅群島",
    "Fiji": "斐濟",
    "Finland": "芬蘭",
    "France": "法國",
    "FrenchGuiana": "法屬圭亞那",
    "FrenchPolynesia": "法屬玻里尼西亞",
    "FrenchSouthernTerritories": "法屬南部領地",
    "Gabon": "加彭",
    "Gambia": "甘比亞",
    "Georgia": "喬治亞",
    "Germany": "德國",
    "Ghana": "迦納",
    "Gibraltar": "直布羅陀",
    "Greece": "希臘",
    "Greenland": "格陵蘭",
    "Grenada": "格瑞那達",
    "Guadeloupe": "瓜地洛普",
    "Guam": "關島",
    "Guatemala": "瓜地馬拉",
    "Guernsey": "根西島",
    "Guinea": "幾內亞",
    "GuineaBissau": "幾內亞比索",
    "Guyana": "蓋亞那",
    "Haiti": "海地",
    "HeardIslandandMcDonaldIslands": "赫德島和麥唐納群島",
    "VaticanCityState": "梵蒂岡",
    "Honduras": "宏都拉斯",
    "HongKong": "香港",
    "Hungary": "匈牙利",
    "Iceland": "冰島",
    "India": "印度",
    "Indonesia": "印尼",
    "IranIslamicRepublicOf": "伊朗",
    "Iraq": "伊拉克",
    "Ireland": "愛爾蘭",
    "IsleofMan": "曼島",
    "Israel": "以色列",
    "Italy": "義大利",
    "Jamaica": "牙買加",
    "Japan": "日本",
    "Jersey": "澤西島",
    "Jordan": "約旦",
    "Kazakhstan": "哈薩克",
    "Kenya": "肯亞",
    "Kiribati": "吉里巴斯",
    "KoreaDemocraticPeopleRepublicof": "北韓",
    "KoreaRepublicof": "南韓",
    "Kuwait": "科威特",
    "Kyrgyzstan": "吉爾吉斯",
    "LaoPeopleDemocraticRepublic": "寮國",
    "Latvia": "拉脫維亞",
    "Lebanon": "黎巴嫩",
    "Lesotho": "賴索托",
    "Liberia": "賴比瑞亞",
    "LibyanArabJamahiriya": "利比亞",
    "Liechtenstein": "列支敦斯登",
    "Lithuania": "立陶宛",
    "Luxembourg": "盧森堡",
    "Macao": "澳門",
    "MacedoniaTheFormerYugoslavRepublicof": "北馬其頓",
    "Madagascar": "馬達加斯加",
    "Malawi": "馬拉威",
    "Malaysia": "馬來西亞",
    "Maldives": "馬爾地夫",
    "Mali": "馬利",
    "Malta": "馬爾他",
    "MarshalIslands": "馬紹爾群島",
    "Martinique": "馬丁尼克",
    "Mauritania": "茅利塔尼亞",
    "Mauritius": "模里西斯",
    "Mayotte": "馬約特",
    "Mexico": "墨西哥",
    "MicronesiaFederatedStatesof": "密克羅尼西亞聯邦",
    "MoldovaRepublicof": "摩爾多瓦",
    "Monaco": "摩納哥",
    "Mongolia": "蒙古",
    "Montserrat": "蒙哲臘",
    "Morocco": "摩洛哥",
    "Mozambique": "莫三比克",
    "Myanmar": "緬甸",
    "Namibia": "納米比亞",
    "Nauru": "諾魯",
    "Nepal": "尼泊爾",
    "Netherlands": "荷蘭",
    "NetherlandsAntilles": "荷屬安地列斯",
    "NewCaledonia": "新喀里多尼亞",
    "NewZealand": "紐西蘭",
    "Nicaragua": "尼加拉瓜",
    "Niger": "尼日",
    "Nigeria": "奈及利亞",
    "Niue": "紐埃",
    "NorfolkIsland": "諾福克島",
    "NorthernMarianaIslands": "北馬里亞納群島",
    "Norway": "挪威",
    "Oman": "阿曼",
    "Pakistan": "巴基斯坦",
    "Palau": "帛琉",
    "PalestinianTerritoryOccupied": "巴勒斯坦領土",
    "Panama": "巴拿馬",
    "PapuaNewGuinea": "巴布亞紐幾內亞",
    "Paraguay": "巴拉圭",
    "Peru": "秘魯",
    "Philippines": "菲律賓",
    "Pitcairn": "皮特肯群島",
    "Poland": "波蘭",
    "Portugal": "葡萄牙",
    "PuertoRico": "波多黎各",
    "Qatar": "卡達",
    "Reunion": "留尼旺",
    "Romania": "羅馬尼亞",
    "RussianFederation": "俄羅斯",
    "Rwanda": "盧安達",
    "SaintHelena": "聖赫勒拿島",
    "SaintKittsandNevis": "聖克里斯多福及尼維斯",
    "SaintLucia": "聖露西亞",
    "SaintPierreandMiquelon": "聖皮耶與密克隆群島",
    "SaintVincentandtheGrenadines": "聖文森及格瑞那丁",
    "Samoa": "薩摩亞",
    "SanMarino": "聖馬利諾",
    "SaoTomeandPrincipe": "聖多美普林西比",
    "SaudiArabia": "沙烏地阿拉伯",
    "Senegal": "塞內加爾",
    "SerbiaandMontenegro": "塞爾維亞與蒙特內哥羅",
    "Seychelles": "塞席爾",
    "SierraLeone": "獅子山",
    "Singapore": "新加坡",
    "Slovakia": "斯洛伐克",
    "Slovenia": "斯洛維尼亞",
    "SolomonIslands": "索羅門群島",
    "Somalia": "索馬利亞",
    "SouthAfrica": "南非",
    "SouthGeorgiaandtheSouthSandwichIslands": "南喬治亞與南桑威奇群島",
    "Spain": "西班牙",
    "SriLanka": "斯里蘭卡",
    "Sudan": "蘇丹",
    "Suriname": "蘇利南",
    "SvalbardandJanMayen": "斯瓦巴與揚馬延",
    "Swaziland": "史瓦帝尼",
    "Sweden": "瑞典",
    "Switzerland": "瑞士",
    "SyrianArabRepublic": "敘利亞",
    "TaiwanProvinceofChina": "台灣",
    "Tajikistan": "塔吉克",
    "TanzaniaUnitedRepublicof": "坦尚尼亞",
    "Thailand": "泰國",
    "TimorLeste": "東帝汶",
    "Togo": "多哥",
    "Tokelau": "托克勞",
    "Tonga": "東加",
    "TrinidadandTobago": "千里達及托巴哥",
    "Tunisia": "突尼西亞",
    "Turkey": "土耳其",
    "Turkmenistan": "土庫曼",
    "TurksandCaicosIslands": "土克斯及開科斯群島",
    "Tuvalu": "吐瓦魯",
    "Uganda": "烏干達",
    "Ukraine": "烏克蘭",
    "UnitedArabEmirates": "阿拉伯聯合大公國",
    "UnitedKingdom": "英國",
    "UnitedStates": "美國",
    "UnitedStatesMinorOutlyingIslands": "美國本土外小島嶼",
    "Uruguay": "烏拉圭",
    "Uzbekistan": "烏茲別克",
    "Vanuatu": "萬那杜",
    "Venezuela": "委內瑞拉",
    "VietNam": "越南",
    "VirginIslandsBritish": "英屬維京群島",
    "VirginIslandsUS": "美屬維京群島",
    "WallisandFutuna": "瓦利斯和富圖納",
    "WesternSahara": "西撒哈拉",
    "Yemen": "葉門",
    "Zambia": "尚比亞",
    "Zimbabwe": "辛巴威"
  },
  fallback: {
    'Something_Went_Wrong': '抱歉，發生錯誤！',
    'We_are_on_it_will_fix_it_asap':
      '我們正在處理中，將會盡快修復。',
    'Go_Back': '返回',
  },

  //status

  "NEW": "新建",
  "SUBMITTED": "已提交",
  "APPROVED": "已批准",
  "REJECTED": "已拒絕",
  // feeback form
  "Share Your Feedback": "分享您對新 UI 的回饋",
  "Feedback Form": "新 UI 回饋",
  "Subject": "主題",
  "Please input your subject!": "請輸入主題！",
  "Enter Your Message": "輸入您的訊息",
  "Please input your query!": "請輸入您的問題！",
  "Try out our New Das Gateway Features. For Older Version": "您目前使用的是新版 Gateway UI",
  "Feel free to share your valuable feedbacks.": "如需舊版 Gateway UI",
  "Click Here": "點擊這裡",

  // Legacy Notice
  "Notice": "通知",
  "Legacy Transaction Notice": "舊版交易（V2）已於2022年9月完成遷移至V3交易系統，因此已停止使用。不過，在指定期間內，我們仍會支援舊版交易的退款及爭議處理功能。因此，您可能無法在舊版交易（V2）中使用部分最新功能。",
  "Legacy Statement Notice": "舊版對帳單（V2）已於2022年9月完成遷移至V3對帳單系統，因此已停止使用。不過，在完成撥款結算前，我們仍會繼續支援舊版對帳單功能。因此，您可能無法在舊版對帳單（V2）中使用部分最新功能。",
  "Legacy Chargeback Notice": "舊版爭議管理（V2）已於2022年9月完成遷移至V3爭議管理系統，因此已停止使用。不過，在指定期間內，我們仍會繼續支援舊版爭議管理的拒付（Chargeback）功能。因此，您可能無法在舊版爭議管理（V2）中使用部分最新功能。",

  // Timestamp Datepicker
  "ABSOLUTE": "絕對",
  "RELATIVE": "相對",
  "Start": "開始",
  "End": "結束",
  "OK": "確定",
  "Days": "天數",



  // login page 
  "Sign in to": "登入",
  "Payment Options": "Payment Options",
  "Email Address": "電子郵件",
  "Password": "密碼",
  "Forgot Password?": "忘記密碼？",
  "Not registered yet?": "尚未註冊？建立帳戶",
  "Create an Account": "請輸入商戶電子郵件",
  "Merchant Email Address": "無效電郵",

  //  ValidationSchema
  "Invalid email": "必填",
  "Required": "登入",

  // button
  "Login": "登入",
  // Swiper_Login
  "Simplifying Payments,": "簡化付款流程",
  "Enable Growth": "促進成長",
  "Your all-in-one digital payment solutions provider, built to accelerate your business growth.": "一站式數位支付方案，加速業務成長",
  "Solution Provider,": "解決方案供應商",
  "Payment Methods": "付款方式",
  "Start accepting a wide variety of Payment Methods, choose from credit cards, e-wallets, over-the-counter payments and many more.": "開始接受多種多樣的支付方式，包括信用卡、電子錢包、櫃檯付款等。",
  "Fastening Payments,": "快速處理付款，",
  "Empowering Growth": "推動業務成長",
  "Instantly accept online payments on your website or collect payments using our no code solutions.": "透過我們的無程式碼解決方案，立即在您的網站上接受線上付款或收取款項。",
  // forgot page 
  "Forgot Your Password": "忘記密碼",
  "We will send you help, just enter your email below to receive password instructions.": "我們將為您提供協助，請在下方輸入您的電子郵件地址，即可收到密碼重設指引。",
  //button
  "Submit": "提交",
  "Submitting": "正在提交",
  "Back To Login": "返回登入頁面",
  // Reset Password
  "Reset Password": "重設密碼",
  "Enter New Password": "輸入新密碼",
  "Enter Current Password": "輸入現行密碼",
  "Confirm New Password": "確認新密碼",
  "Password is required": "必須輸入密碼",
  "Password is too short - should be 14 characters minimum.": "密碼過短 - 應至少為 14 個字符。",
  "Your password must include at least one number, one special character, one uppercase letter, and one lowercase letter.": "您的密碼必須包含至少一個數字、一個特殊字元、一個大寫字母和一個小寫字母。",
  "Passwords must match": "密碼必須一致",

  // ResetPasswordSuccessfull
  "Congratulations": "恭喜",
  "Your Password has been successfully changed.": "您的密碼已成功變更。",

  // Onboading info and buttons
  "Back": "上一頁",
  "Next": "下一頁",
  "Overall Percentage": "總體百分比",

  //Create Password
  "Create Password": "建立密碼",
  "CREATE ACCOUNT": "建立帳戶",
  "Password Requirements": "密碼要求",
  "Minimum password length should be 14 characters": "密碼的最少長度必須為14個字元",
  "password_req_heading_two": "密碼長度：密碼長度最少須為 14 個字符。.",
  "password_req_heading_three": "密碼複雜度：密碼必須包含最少以下元素：",
  "should contain a letter.": "一個小寫字母。",
  "should contain a number.": "一個數字。",
  "should contain a uppercase.": "一個大寫字母。",
  "and should contain a special character.": "一個特殊字符。",
  "Supported Special characters": "其他特殊字符:",
  "You’re on the last step of registration!": "最後步驟",
  "Set your account’s password.": "設定密碼",
  "I agree with the": "我同意", // I agree with the
  "Terms and Conditions": "服務條款", // Terms and Conditions
  "Privacy Policy": "私隱政策", // Privacy Policy
  "and": "及", // and
  "I/We warrant that": "本人／我們保證：",

  // ChooseAccount
  "Choose an Account": "選擇帳戶",
  "What type of account you want to create?": "您要建立哪種類型的帳戶？",
  "I’m a Merchant": "我是商家",
  "I’m a Partner": "我是合作夥伴",
  "Already have an account?": "已有帳戶？",
  "Sign In": "登入",

  // Notification
  "Notifications": "通知",
  "No updates yet": "目前尚無更新",
  "Your password is going to expire in": "您的密碼將於到期",
  "days on": "天後",
  "To change your password": "若要變更密碼",
  "Your password has expired": "您的密碼已過期",

  //AccountsTab
  "Continue": "繼續",

 //Create Account Page
"Create your": "建立您的",
"Merchant Account": "商戶帳戶",
"Complete all required fields": "請填寫所有必填欄位",
"First Name": "名字",
"Last Name": "姓氏",
"Business Location": "所在國家",
"Phone Number": "電話號碼",
"Verify": "驗證",
"Verified": "已驗證",
"Partner Account": "合作夥伴帳戶",
"Partner": "合作夥伴",

//OTP Modal
"Please enter OTP to verify your account": "請輸入一次性密碼 (OTP) 以驗證您的帳戶",
// Please enter OTP to verify your account

'Please check your email account for the verification code we just sent you and enter that code in the box below':
'請檢查您的電子郵件以取得我們剛發送的驗證碼，並將該驗證碼輸入到下方欄位中', 
// Please check your email account for the verification code we just sent you and enter that code in the box below

"OTP": "一次性密碼",
"Didn’t receive code?": "沒有收到驗證碼？",
"Resend OTP": "重新發送一次性密碼",
"VERIFY": "驗證",

  //Risk Management Page
  "Risk Configuration": "風險設定",
  "Add Risk Configuration": "新增風險設定",
  "Choose File": "選擇檔案",
  "Add Risk Rule": "新增風險規則",
  "Prohibited": "禁止",
  "Entity Risk Rule": "實體風險規則",
  "List": "清單",
  "Select_All": "全選",
  "default": "預設",

  // Add Risk Rule 
  "Prohibited Pan List": "禁止的船舶清單",
  "Prohibited Country List": "禁止的國家清單",
  "Prohibited IP List": "禁止的 IP 清單",
  "Prohibited Bin List": "禁止的貨櫃清單",
  // Bank account Types
  "Normal": "正常",
  "Current": "目前",
  "Savings": "儲蓄",
  "Other": "其他",

  //Delete Confirmation Box
  "Delete": "刪除",
  "Are you sure?": "確定嗎？",
  "Do you really want to delete this record? This process can not be undone.": "您真的要刪除此筆記錄嗎？此操作無法撤銷。",
  "Cancel": "取消",
  //Tabs
  "Statement": "報表",
  "Trigger Type": "觸發類型",
  "PO Entity": "採購單實體",
  "Action": "動作",
  "Status": "狀態",

  //NewRiskRule Tab Fields
  "Rule Conditions": "規則條件",
  "Rule Assignments": "規則指派",
  "field_value": "值 將套用至該欄位的值",
  "operator": "運算子 將套用至該欄位的條件",



  //Edit Risk Rule Fields
  "Edit Risk Rule": "編輯風險規則",
  "Prohibited List": "禁止清單",
  "Allowed List": "允許清單",
  "Click To Choose New File": "選擇新檔案",
  "Click To Choose File": "選擇檔案",
  "Download Prohibited List": "下載禁止清單",
  "Download List": "下載清單",
  "No file chosen": "未選擇檔案",
  "Blacklist": "黑名單",
  "Field": "欄位",
  "Home": "首頁",
  "PAN": "PAN",
  "Issuing Country": "發卡國",
  "Bin Numbers": "BIN 號碼",
  "IP Address": "IP 位址",
  "Enabled": "啟用",
  "Disabled": "停用",
  "BLACKLIST": "黑名單",
  "Allowed BIN List": "允許 BIN 清單",
  "Allowed IP List": "允許 IP 清單",

  //  Options
  "PO Singapore": "PO 新加坡",
  "PO Japan": "PO 日本",
  "PO Mauritius": "PO 毛里求斯郵政",
  "PO Lithuania": "PO 立陶宛",
  "PO Malaysia": "PO 馬來西亞",
  "File is too large, maximum allowed size is $maxSize kb. Current file has $size kb.": "File is too large, maximum allowed size is $maxSize kb. Current file has $size kb.",
  "Max Transaction Amount": "最大交易金額",
  "Min Transaction Amount": "最小交易金額",
  // ProductRiskConfiguration
  "Threshold": "閾值",
  "Velocity": "交易頻率",
  "TimeFrame": "時間範圍",
  "Risk Controls for": "風險控制對象",
  "The value of the number must be greater than 0": "數值必須大於 0",
  "Value": "數值",
  "Value must be greater than 0": "數值必須大於 0",
  "Value of the number must be greater than 0": "數值必須大於 0",
  "JPY": "日圓",
  "Configure Rules": "設定規則",
  "Months": "月",
  "Hours": "小時",
  "Minutes": "分鐘",

  //MFA Screen
  "VERIFY_CODE": "請透過多重驗證確認您的身分",
  "ENTER_CODE": "輸入驗證器應用程式提供的驗證碼",
  "MFA_RESET_BUTTON": "返回",
  "MFA_SUBMIT_BUTTON": "提交",
  "MFA_HAVING_TROUBLE": "遇到問題嗎？",
  "RESET_MFA": "重置 MFA",
  "STEP_1": "步驟 1",
  "STEP_1_DESC": "安裝一個相容的應用程式，例如",
  "STEP_1_DESC_2": "或",
  "STEP_1_DESC_3": "行動裝置或電腦上的應用程式。",
  "STEP_1_DESC_GOOGLE": "Google Authenticator",
  "STEP_1_DESC_DUO": "Duo Mobile",
  "STEP_1_DESC_AUTTY": "Authy",
  "STEP_2": "步驟 2",
  "STEP_2_DESC": "開啟您的驗證器應用程式，並掃描顯示的 QR 碼，或點擊「顯示密鑰」以手動將其輸入驗證器應用程式中。",
  "STEP_3": "步驟 3",
  "STEP_3_DESC": "請在下方輸入兩個連續的多因素驗證 (MFA) 碼",
  "ENTER_OTP_1": "輸入 OTP 1",
  "ENTER_OTP_2": "輸入 OTP 2",
  "SKIP_MFA": "跳過 MFA",
  "SHOW_SECRET_KEY": "顯示密鑰",
  "COPY_SECRET_KEY": "密鑰已複製到剪貼簿！",
  "FAIL_COPY_SECRET_KEY": "複製密鑰失敗。",
  "SCAN_QR_CODE": "掃描 QR 碼",
  "Skip MFA will remain available for this Release. After Next Release, MFA will be required again for added Security.": "在本次版本中，「跳過多重驗證」按鈕仍可使用，但將於下個版本中移除，以強制實施多重驗證，提升安全性。",
  "Multi Factor Authentication Setup": "多重驗證設定",

  // Error Page
  "ERROR_HEADING": "哎呀！發生錯誤。",
  "ERROR_MESSAGE": "處理請求時發生問題。",
  "ERROR_BUTTON": "返回上一頁",

  // Dispute
  "link": "連結",
  "Choose": "選擇",
  "Choose...": "選擇...",

  //billing cycle
  "Billing_Cycle": {
    "Daily": "每日",
    "Weekly": "每週",
    "Monthly": "每月",
    "Quarterly": "每季",
    "Semiannually": "每半年",
    "Annually": "每年"
  },
  "Payment_Cycle": {
    "Daily": "每日",
    "Weekly": "每週",
    "Monthly": "每月",
    "N/A": "N/A"
  },

  "SUBSCRIPTION_STATUS": {
    "ACTIVE": "進行中",
    "COMPLETED": "已完成",
    "PAUSED": "暫停",
    "INITIATED": "已啟動",
    "PENDING": "待處理",
    "CANCELLED": "已取消",
    "REJECTED": "已拒絕",
    "TOKENPAYMENTFAILED": "代幣支付失敗",
    "TOKENEXPIRED": "代幣已過期",
    "INACTIVE": "非活躍"
  },

  //Risk Configuration
  "Payment Attempts": "付款嘗試",
  Merchant: {
    Login: {
      "label": "商家登入",
      // 'email-label': 'Email Address',
      // 'password-label': 'Password',
      // 'forgot-password': 'Forgot Password?',
      // 'not-registered': 'Not registered yet?',
      // 'create-account': 'Create an Account',
      "Session_Timeout": "會話超時...！",
      validationSchema: {
        // Invalid_email: 'Invalid email',
        "password_not_provided": "未提供密碼"
      },
      // button: {
      //   'Login-button': 'Login',
      // },
      Swiper_Login: {
        // headingA: 'Simplifying Payments,',
        // mainTitleA: 'Enable Growth',
        // descriptionA:
        //   'Your all-in-one digital payment solutions provider, built to accelerate your business growth.',
        // headingB: 'Solution Provider,',
        // mainTitleB: 'Payment Methods',
        // descriptionB:
        //   'Start accepting a wide variety of Payment Methods, choose from credit cards, e-wallets, over-the-counter payments and many more.',
        // headingC: 'Fastening Payments,',
        // mainTitleC: 'Empowering Growth',
        // descriptionC:
        //   'Instantly accept online payments on your website or collect payments using our no code solutions.',
      },
    },
    // ForgotPassword: {
    // label: 'Forgot Your Password',
    // description:
    //   'We will send you help, just enter your email below to receive password instructions.',
    // Fields: {
    //   'email-label': 'Email Address',
    // },
    // button: {
    // 'Submit-button': 'Submit',
    // 'Login-button': 'Back To Login',
    // },
    // },
    ResetPassword: {
      // label: 'Reset Password',
      Fields: {
        "otp-label": "輸入一次性密碼 (OTP)"
        // 'new-password-label': 'Enter New Password',
        // 'confirm-password-label': 'Confirm New Password',
      },
      errorMessage: {
        // Required: 'Password is required',
        // PasswordLength: 'Password is too short - should be 14 characters minimum.',
        // PasswordLatin:
        //   'Your password must include at least one number, one special character, one uppercase letter, and one lowercase letter.',
        // PasswordMatch: 'Passwords must match',
        PasswordShouldNotMatch:
          "您的密碼不能與使用者名稱相同，也不能是「admin」。"
      },
      // button: {
      // 'Reset-button': 'Reset Password',
      // },
    },
    ResetPasswordSuccessfull: {
      // label: 'Congratulations',
      // description: 'Your Password has been successfully changed.',
      button: {
        'Login-button': "返回登入頁面"
      },
    },
    AccountsTab: {
      "MerchantAccont": "建立商家帳戶",
      "PartnerAccont": "建立合作夥伴帳戶",
      "ComingSoon": "即將推出"
      // Continue: 'Continue',
    },
  },

  TransactionsResult: {
    columnDefs: {
      "Action": "操作",
      "TransactionRefID": "交易參考編號",
      "V2UUID": "V2 編號",
      "Amount": "金額",
      "status": "狀態/類型",
      "Date": "交易日期",
      "UpdatedTransactionDate": "更新日期",
      "StartDate": "開始日期",
      "EndDate": "結束日期",
      "DASMID": "DASMID",
      "Scheme": "方案",
      "Merchant": "商家帳戶",
      "PaymentType": "付款類型",
      "Acquirer": "收單機構",
      "Type": "類型",
      "TransactionType": "交易類型",
      "TimeZone": "交易時區",
      "IntegrationMethod": "整合方式",
      "IntegrationType": "整合類型",
      "CardNumber": "卡號",
      "MerchantRefID": "商戶參考編號",
      "trackID": "軌道編號",
      "AcquirerMID": "收單機構 MID",
      "AuthCode": "授權碼",
      "CurrencyCode": "貨幣",
      "productType": "產品類型",
      "subscriptionID": "訂閱編號",
      "TerminalID": "終端機編號",
      "TerminalName": "終端機名稱",
      "GatewayError": "網關回應",
      "ResponseCode": "回應代碼",
      "TransactionID": "交易編號",
      "LinkName": "連結名稱",
      "MerchantAccountEnglish": "商戶帳戶（英文）",
      "TransactionEvent": "交易事件",
      "Event": "交易事件"
    },
    "BreadCrumb": {
      "Home": "首頁",
      "Search-Transaction-Result": "搜尋交易結果"
    },
    "DownloadCSV": "下載交易",
    "Refresh": "重新整理",
    "AdditionalColumn": "新增欄位",
    "AdditionalFields": "新增欄位",
    "SelectAll": "全選",
    "Search": "搜尋",
    "note": "注意：",
    "description": "您從上方清單中選取的額外欄位將儲存為使用者偏好設定，並會顯示在您的交易清單檢視中，直到您在此處更新此設定為止。",
    "filterInfoDescription": "預設情況下，系統會對您的交易套用「過去 1 個月」的篩選條件"
  },
  TransactionDetailDrawerBody: {
    "TransactionHistory": "交易記錄",
    "AuditLog": "稽核日誌",
    "Status_Heading": "編輯交易狀態",
    "Should be 6 characters long": "長度應為 6 個字元。",
    ApprovePopup: {
      "title": "批准",
      "heading": "您確定嗎？",
      "content": "您確定要變更交易狀態嗎？",
      "button": {
        "cancel": "取消",
        "submit": "批准"
      },
    },
    "SubscriptionDetails": {
      "Heading": "訂閱記錄",
      "BillingCycle": "計費週期："
    },
    "TokenizationDetails": {
      "Heading": "代幣化記錄"
    },
    "ChargebackHistory": {
      "Heading": "退款記錄"
    },
    TransactionReportDownload: {
      "TransactionDownload": "下載交易記錄",
      "ScheduleReport": "排程報告",
      "DownloadReportTitle": "交易明細",
      "Default Applied Filter": "請使用交易參考ID篩選以搜尋交易（可忽略日期範圍). 其他搜尋或交易下載請選擇適當的日期範圍（不可超過一年）",
      "PleaseApply": "請套用篩選條件以下載交易報表",
      "PleaseDownload": "請下載您所請求的交易報表",
      "FileTimeLimit": "最近下載的交易報表：（僅保留14天）",
      "MaxLimitReachedTitle": "已超過交易報表下載限制",
      "MaxLimitReachedMessage": "您正在嘗試下載超過300,000筆交易。請聯絡支援團隊協助處理此請求，或使用更多篩選條件縮小搜尋範圍。",
      "AppliedFilters": "已套用篩選條件",
      "RequestDownload": "請求下載",
      "DownloadReport": "下載報告",
      "ReportType": "報告格式",
      "Total Records": "總記錄數",
      "ColumsnDefs": {
        "Action": "操作",
        "FileName": "報告名稱",
        "FileFormat": "報告格式",
        "CreatedAt": "建立時間",
        "Filter": "已套用篩選條件",
        "Status": "狀態",
        "NoOfRecords": "#記錄",
        "Preferred Report Name": "首選報告名稱"
      },
      "ReportStatus": {
        "Initiated": "已啟動",
        "InProgress": "進行中",
        "Ready": "已完成",
        "Failure": "失敗"
      },
      "SensitiveColumns": {
        "Include Sensitive Columns": "包含敏感欄位",
        "Include Whitelisted Transactions": "包含白名單交易",
        "ECI VALUE": "ECI值",
        "AVS": "AVS（地址驗證系統）",
        "ACQUIRER MID": "收單機構MID",
        "HASH CARD NUMBER": "Hash卡號",
        "EXPIRY DATE (MM/YY)": "有效期限 (月/年)"
      }
    }
  },
  "SideMenu": {
    "MenuItems": {
      "Dashboard": "儀表板",
      "Transactions": "交易",
      "Merchants": "商戶",
      "Acquirers": "收單機構",
      "Entity": "風險管理",
      "Paybylink": "Pay By Link",
      "Disputemanagement": "爭議管理",
      "OnBoarding": "註冊",
      "Statements": "對帳單",
      "Contact": "協助與支援",
      "SalesLead": "銷售潛在客戶",
      "Partner": "合作夥伴",
      "LegacyTransactions": "舊版交易",
      "LegacyDisputemanagement": "舊版爭議管理",
      "LegacyStatement": "舊版對帳單",
      "Reseller": "經銷商",
      "Hash Card": "Hash Card"
    },
  },
  MenuAppBar: {
    "UserProfileItems": {
      "LastLogin": "上次登入時間：",
      "Entity": "採購單實體：",
      "Access": "存取群組：",
      "Logout": "登出",
      "Settings": "設定",
      "Change Password": "變更密碼",
      "User Settings": "使用者設定",
      "Sign In As A Merchant": "以商家身分登入",
      "Merchant Id": "商家 ID",
      "Sign Out as Merchant": "以商家身分登出"
    },
    "ToggleText": {
      "Test": "測試",
      "Live": "正式環境"
    }
  },
  "FilterPopup": {
    "button": {
      "Filter": "篩選",
      "NextGenFilter": "新一代濾網"
    },
    "PoEntityName": {
      "PO Singapore": "PO新加坡",
      "PO Japan": "PO日本",
      "PO Mauritius": "PO模里西斯",
      "PO Europe": "PO歐洲",
      "PO Hong Kong": "PO香港",
      "PO China": "PO中國"
    }
  },
  "MerchantList": {
    "Merchants_View_ColumnDefs": {
      "Action": "操作",
      "MerchantAccount": "商家帳戶",
      "MerchantID": "商家 ID",
      "LegalNameInEnglish": "商家帳戶（英文）",
      "LegalName": "商家帳戶",
      "Products": "產品",
      "Country": "採購訂單實體",
      "CreatedDate": "建立日期",
      "Status": "狀態",
      "StartDate": "",
      "EndDate": "",
      "DASMID": "DASMID",
      "ReferredCode": "推薦代碼",
      "AcquirerName": "收單機構"
    },
    "Product_View_ColumnDefs": {
      "Action": "交易類型",
      "MerchantName": "商家帳戶",
      "ProductName": "產品名稱",
      "type": "產品類型",
      "MCC": "商家類別代碼",
      "DASMID": "DASMID",
      "AcquirerCode": "收單機構",
      "Tooltip": {
        "View_Details": "檢視詳細資訊",
        "AddRiskRule": "新增風險規則",
        "AddPayByLink": "新增「Pay By Link」",
        "EnableMID": "啟用 MID",
        "DisableMID": "停用 MID",
        "EditPayByLink": "編輯購物車項目",
        "SoftposDevice": "SoftPOS 裝置"
      }
    },
    "tabs": {
      "Merchant": "商家檢視",
      "Product": "產品檢視"
    },
    "MerchantDetailsTabs": {
      "Merchant Details": "商家詳細資訊",
      "Product Details": "產品資訊",
      "User Management": "使用者存取管理",
      "Catalog": "商家目錄",
      "Merchant Settings": "商家設定",
      "Device Management": "裝置管理"
    },
    "MerchantSettingsTabs": {
      "IP Whitelisting": "IP 白名單設定",
      "Webhook URL": "Webhook URL 設定",
      "Refund Balance": "退款餘額摘要",
      "IP_Whitelisting": {
        "Add Ip Address": "新增 IP 位址",
        "Edit Ip Address": "編輯 IP 位址",
        "Previous Comments": "先前留言",
        "no_record_message": "目前沒有任何 IP 位址被列入白名單。",

    "Column_Def": {
      "IP Address": "IP 位址",
      "Status": "狀態",
      "Created Date": "建立日期",
      "Created By": "建立者",
      "Updated Date": "更新日期",
      "Updated By": "更新者"
    },
    "Form_Fields": {
      "IP Address": "IP 位址",
      "Status": "狀態",
      "Comments": "備註"
    },
    "ApprovePopup": {
      "titleAdd": "新增 IP 位址",
      "titleEdit": "更新 IP 位址",
      "heading": "確定嗎？",
      "contentAdd": "您確定要新增此 IP 位址嗎？",
      "contentEdit": "您確定要更新此 IP 位址嗎？",
      "button": {
        "cancel": "取消",
        "submit": "提交"
      },
      "Validation": {
        "ExactIPAddress": "IP 位址無效",
        "MaxLength": "最多僅限 128 個字元。"
      }
    },
  },
  "Webhook_Url": {
    "Add Webhook Url": "新增 Webhook URL",
    "Edit Webhook Url": "編輯 Webhook URL",
    "Previous Comments": "先前留言",
    "No Webhook Url Configured": "未設定 Webhook URL",
    "Please proceed to configure Webhook Url": "請繼續設定 Webhook URL。",
    "Column_Def": {
      "Webhook Url": "Webhook URL",
      "Status": "狀態",
      "Created Date": "建立日期",
      "Created By": "建立者",
      "Updated Date": "更新日期",
      "Updated By": "更新者",
      "Comments": "備註"
    },
    "Form_Fields": {
      "Webhook Url": "Webhook URL",
      "Status": "狀態",
      "Comments": "備註"
    },
    "ApprovePopup": {
      "titleAdd": "新增 Webhook URL",
      "titleEdit": "更新 Webhook URL",
      "heading": "您確定嗎？",
      "contentAdd": "您確定要新增 Webhook URL 嗎？",
      "contentEdit": "您確定要更新 Webhook URL 嗎？",
      "button": {
        "cancel": "取消",
        "submit": "提交"
      },
      "Validation": {
        "ExactIPAddress": "Webhook URL 無效",
        "MaxLength": "最多僅限 128 個字元。"
      },
    },
      },
    },
    MerchantCatalogs:{
      "MerchantCategory":{
        "Add Category": "新增分類",
        "Edit Category": "編輯分類",
        "View Products": "檢視商品",
        "Delete Category": "刪除分類",
        "Go Back": "返回分類列表",
        "ColumnsDefs":{
          "CategoryName": "分類名稱",
          "CategoryDesc": "描述",
          "CategoryStatus": "狀態",
          "CategoryID": "分類 ID",
          "CreatedAt": "建立時間",
          "UpdatedAt": "更新時間"
        },
        "FormFields":{
          "CategoryName": "分類名稱",
          "CategoryDesc": "描述",
          "CategoryStatus": "狀態",
          "FoodType": "食品類型",
          "Size": "份量"
        },
        "ApprovePopup": {
          "titleAdd": "新增分類",
          "titleEdit": "更新分類",
          "heading": "您確定嗎？",
          "contentAdd": "您確定要新增目錄分類嗎？",
          "contentEdit": "您確定要更新目錄分類嗎？",
          "button": {
            "cancel": "取消",
            "submit": "提交"
          }
        }
      },
      "MerchantCategoryProducts":{
        "Add Product": "新增商品",
        "Edit Product": "編輯商品",
        "View Products": "檢視商品",
        "Delete Product": "刪除商品",
        "ColumnsDefs": {
          "ProductName": "商品名稱",
          "ProductDesc": "描述",
          "ProductFoodType": "食品類型",
          "ProductSize": "份量",
          "ProductStatus": "狀態",
          "CategoryID": "類別 ID",
          "ProductPrice": "價格",
          "ProductID": "產品 ID",
          "ProductImage": "圖片",
          "ProductCode": "產品 SKU / 編號",
          "CreatedAt": "建立時間",
          "UpdatedAt": "更新時間",
          "ProductStock": "庫存"
        },
        "FormFields": {
          "ProductName": "產品名稱",
          "ProductDesc": "描述",
          "ProductStatus": "狀態",
          "ProductPrice": "價格",
          "ProductImage": "圖片",
          "ProductCode": "產品 SKU / 編號",
          "ProductStock": "庫存",
          "Currency": "貨幣",
          "FoodType": "食品類型",
          "Size": "份量",
          "foodSizeOptions": {
            "Regular": "標準",
            "Medium": "中份",
            "Large": "大份"
          },
          "foodTypeOptions": {
            "Non-Veg": "非素食",
            "Veg": "素食"
          }
        },
        "ApprovePopup": {
          "titleAdd": "新增產品",
          "titleEdit": "更新產品",
          "heading": "您確定嗎？",
          "contentAdd": "您確定要新增此商品嗎？",
          "contentEdit": "您確定要更新此商品嗎？",
          "button": {
            "cancel": "取消",
            "submit": "提交"
          }
        }
      },

      "DeviceManagement": {
        "Add Device": "新增設備",
        "Edit Device": "編輯設備",
        "View Products": "查看產品",
        "Delete Device": "刪除設備",
        "Go Back": "返回設備",
        "ColumnsDefs": {
          "RegistrationNumber": "唯一代碼",
          "DeviceName": "設備名稱",
          "MerchantID": "商戶 ID",
          "DasMid": "DASMID",
          "DeviceType": "設備類型",
          "Status": "狀態",
          "CreatedAt": "建立日期",
          "os": "作業系統",
          "version": "版本",
          "manufacturer": "製造商"
        },
        "FormFields": {
          "RegistrationNumber": "唯一代碼",
          "DeviceName": "設備名稱",
          "MerchantID": "商戶 ID",
          "DasMid": "DASMID",
          "DeviceType": "設備類型",
          "Status": "狀態"
        },
        "ApprovePopup": {
          "titleAdd": "新增分類",
          "titleEdit": "更新分類",
          "heading": "確定嗎？",
          "contentAdd": "確定要新增目錄分類嗎？",
          "contentEdit": "確定要更新目錄分類嗎？",
          "button": {
            "cancel": "取消",
            "submit": "提交"
          }
        }
      }
    },
    "breadcrumbs": {
      "Home": "首頁",
      "Merchants": "商戶"
    },
    "MerchantTable": {
      "View_Details": "查看詳情"
    },
    "ApprovePopup": {
      "title": "停用 MID",
      "heading": "確定嗎？",
      "content": "確定要停用此 MID 嗎？",
      "button": {
        "cancel": "取消",
        "submit": "確認"
      }
    },
    "DeclinePopup": {
      "title": "啟用 MID",
      "heading": "確定嗎？",
      "content": "確定要啟用此 MID 嗎？",
      "button": {
        "cancel": "取消",
        "submit": "確認"
      }
    },
    "EnableDisableMID": {
      "placeholder": "啟用／停用 MID",
      "Active": "啟用",
      "Terminate": "終止",
      "Pending": "待處理"
    },
    "Action": "操作",
    "TerminalId": "終端機 ID",
    "TerminalName": "終端機名稱",
    "LocationId": "位置 ID"
  },
  "AcquirerList": {
    "AcquirerList_ColumnDefs": {
      "Action": "操作",
      "AcquirerName": "收單機構",
      "AcquirerCode": "收單機構代碼",
      "SettlementOffset": "結算偏移日",
      "DateInserted": "建立日期",
      "Status": "狀態"
    },
    "breadcrumbs": {
      "Home": "首頁",
      "Acquirer": "收單機構"
    },
    "AddAcquirer": "新增收單機構",
    "EditAcquirer": "編輯收單機構",
    "AddAcquirerDetails": "新增收單 MID 詳情",
    "AddAcquirerDetail": {
      "fields": {
        "Acquirer MID": "收單 MID",
        "INTEGRATION METHOD": "整合方式",
        "ACQUIRER IDENTIFIER": "收單機構代碼",
        "STATUS": "狀態",
        "DESCRIPTION": "描述",
        "Transaction Type": "交易類型",
        "Username": "用戶名稱",
        "Password": "密碼",
        "Is Recurring": "是否支援定期交易",
        "Is Tokenised": "是否支援代碼化",
        "Is Dynamic MCC": "是否支援動態 MCC",
        'Is Block Refund': '是集体退款吗？',
        "Google MID": "Google MID",
        "Google MID Validation": "Google MID 只能包含字母與數字"
      }
    },
    "EditAcquirerDetails": "編輯收單 MID 詳情"
  },
  "TransactionDetail": {
    "TransactionDetailHeading": "交易詳情",
    "Edit_button": "編輯狀態",
    "breadcrumb": {
      "Home": "首頁",
      "SearchTransactionDetails": "搜尋交易結果"
    },
    "TransactionTile": {
      "Total Sales": "總銷售額",
      "Today Sales": "今日銷售額",
      "Total Refund": "總退款額",
      "Today Refund": "今日退款額",
      "Approval Ratio": "核准率"
    },
    "TransactionInfo": {
      "label": "交易資訊",
      "fields": {
        "TransactionRefID": "交易參考 ID",
        "V2UUID": "V2 ID",
        "DASMID": "DASMID",
        "Merchant": "商戶帳戶",
        "LegalNameInEnglish": "商戶帳戶（英文）",
        "TransactionType": "交易類型",
        "ReferenceRemark": "參考編號",
        "Date": "交易日期",
        "Amount": "金額",
        "CurrencyCode": "貨幣",
        "Response": "回應代碼",
        "Status": "狀態",
        "AuthCode": "授權碼",
        "RequestID": "請求 ID",
        "CVVResponse": "CVV 回應",
        "GatewayError": "Gateway 回應",
        "TransactionID": "交易 ID",
        "TrackID": "追蹤 ID"
      }
    },
    "CustomerDetails": {
      "label": "持卡人資料",
      "field": {
        "CardNumber": "卡號",
        "HashCardNumber": "卡號雜湊值",
        "Scheme": "卡別",
        "ExpiryDate": "到期日（MM/YYYY）",
        "CardHolder": "持卡人姓名",
        "EmailAddress": "電子郵件地址",
        "Phone": "電話號碼",
        "BillingCountry": "帳單國家",
        "BillingPostcode": "帳單郵遞區號",
        "BillingAddress": "帳單地址",
        "BillingCity": "帳單城市",
        "ShippingCountry": "配送國家",
        "ShippingPostcode": "配送郵遞區號",
        "ShippingAddress": "配送地址",
        "ShippingCity": "配送城市",
        "PaymentType": "付款類型"
      }
    },
    "SubscriptionDetails": {
      "label": "訂閱詳情",
      "field": {
        "SubscriptionID": "訂閱 ID",
        "SubscriptionPlan": "訂閱方案",
        "BillingCycle": "付款週期",
        "NextBilling": "下次扣款日期",
        "CycleBilled": "已扣款週期",
        "Status": "訂閱狀態"
      }
    },
    "AdditionalInformation": {
      "label": "其他資訊",
      "fields": {
        "IssuingBank": "發卡銀行",
        "IssuingCountry": "發卡國家",
        "BIN": "BIN",
        "TransactionTimezone": "交易時區",
        "MerchantCategoryCode": "商戶類別代碼",
        "MerchantIP": "商戶 IP",
        "CustomerIP": "客戶 IP",
        "MerchantRefNumber": "商戶參考 ID",
        "Acquirer": "收單機構",
        "AcquirerMID": "收單 MID",
        "AcquirerReferenceNumber": "收單機構參考號碼",
        "eci": "ECI 值",
        "ACQError": "收單機構回應",
        "Isrecurring": "是否為定期交易",
        "Memo": "備註",
        "TerminalID": "終端機 ID",
        "TerminalName": "終端機名稱",
        "PBLLinkName": "連結名稱",
        "ProductType": "產品類型"
      }
    },
    "BrowserInformation": {
      "label": "瀏覽器資訊",
      "fields": {
        "acceptHeader": "接受標頭",
        "screenColorDepth": "螢幕色彩深度",
        "javaEnabled": "已啟用 Java",
        "challengeWindowSize": "挑戰視窗尺寸",
        "language": "語言",
        "screenHeight": "螢幕高度",
        "screenWidth": "螢幕寬度",
        "challengeWindow": "挑戰視窗",
        "userAgent": "使用者代理"
      }
    },
    "TransactionHistory": {
      "label": "交易歷史"
    },
    "TransactionListButtonPopper": {
      "button": {
        "Details": "詳情"
      }
    },
    "actionButton": {
      "REFUND": "退款",
      "CAPTURE": "請款",
      "DISPUTE": "爭議",
      "Void_Authorisation": "取消授權",
      "heading": "確定嗎？",
      "content": "你確定要取消這筆交易授權嗎？此操作無法復原。",
      "message": {
        "refundFailed": "退款失敗..！",
        "captureFailed": "請款失敗..！"
      },
      "button": {
        "cancel": "取消",
        "submit": "提交"
      }
    },
    "rufundButton": "退款",
    "voidButton": "取消授權",
    "TransactionTabList": {
      "Transaction History": "交易歷史",
      "Subscription History": "訂閱歷史",
      "Tokenization History": "代幣化歷史",
      "Audit Log": "審計紀錄",
      "Rule Evaluation": "規則評估",
      "Case History": "案件歷史",
      "Chargeback History": "拒付歷史",
      "Order Overview": "訂單概覽"
    }
  },
  "ActionButtons": {
    "TransactionEvent": "交易事件",
    "PENDING": "待處理",
    "REFUSED": "已拒絕",
    "CANCELLED": "已取消",
    "PURCHASED": "已購買",
    "CAPTURED": "已請款",
    "AUTHORISED": "已授權",
    "REFUNDED": "已退款",
    "ACQERROR": "收單機構錯誤",
    "VOIDED": "已取消授權",
    "PARTIALLY_CAPTURED": "部分請款",
    "PARTIALLY_REFUNDED": "部分退款",
    "PRECONDITION_FAILED": "前置條件失敗",
    "NOT_ACCEPTABLE": "不可接受",
    "UNKNOWN_ERROR": "未知錯誤",
    "TIMEOUT": "逾時",
    "DECLINED": "已拒絕交易"
  },
  "RefundTransaction": {
    "title": "發起退款",
    "Amount": "原始金額",
    "RemainingAmount": "剩餘金額",
    "RefundAmount": "退款金額",
    "Reference": "參考（選填）",
    "ConfirmRefundCheckbox": "是的，我想發起這筆退款，並了解此操作不可逆。請協助開始退款流程",
    "helperText": {
      "RefundAmount_helperTxt_JP": "數值必須大於1",
      "RefundAmount_helperTxt": "數值必須大於0",
      "OptionalMessage": "最多僅限128個字元"
    },
    "message": {
      "ConfirmRefundCheckbox": "請確認是否要繼續此請求",
      "RefundAmount": "數值最多僅可到小數點後兩位",
      "ref_max_Character": "最多僅限128個字元"
    }
  },
  "Merchant_Detail": {
    "MerchantDetail": {
      "label": "商戶資料",
      "fields": {
        "LegalName": "商戶帳戶",
        "LegalNameInEnglish": "商戶帳戶",
        "RegistrationNumber": "註冊號碼",
        "SubsidiaryID": "PO 實體",
        "Company_Address_Information": "公司地址資訊",
        "City": "城市",
        "PostalCode": "郵遞區號",
        "Country": "國家",
        "ResellerName": "合作夥伴名稱",
        "MCC": "商戶類別代碼",
        "MerchantID": "商戶編號"
      }
    },
    "MerchantRefundBalance": {
      "label": "退款餘額摘要",
      "fields": {
        "CustomRefundBalance": "自訂退款餘額",
        "CurrentRefundBalance": "目前退款餘額"
      }
    },
    "API_keys": {
      "label": "API 金鑰",
      "fields": {
        "Live_API_key": "生產環境 API 金鑰",
        "Test_API_key": "測試環境 API 金鑰",
        "Live Key Visible": "生產金鑰顯示",
        "Live Key Hidden": "生產金鑰隱藏",
        "Test Key Visible": "測試金鑰顯示",
        "Test Key Hidden": "測試金鑰隱藏",
        "Live Key Encoded": "生產金鑰已編碼",
        "Live Key Decoded": "生產金鑰已解碼",
        "Test Key Encoded": "測試金鑰已編碼",
        "Test Key Decoded": "測試金鑰已解碼",
        "Live Key Copied": "生產金鑰已複製",
        "Test Key Copied": "測試金鑰已複製",
        "Failed to show Key": "無法顯示金鑰",
        "Failed to Copy": "無法複製",
        "Failed to Encode / Decode": "編碼／解碼失敗"
      }
    },
    "Product_Information": {
      "label": "產品資訊",
      "columnDefs": {
        "Action": "操作",
        "Name": "名稱",
        "Type": "類型",
        "MCC": "商戶類別代碼",
        "DASMID": "DAS 商戶編號",
        "V2DASMID": "V2 DAS 商戶編號",
        "AcquirerMID": "收單商戶編號",
        "OneTimeSetUpFee": "Setup Fee",
        "MonthlyFee": "Monthly Fee",
        "AnnualFee": "Annual Fee",
        "FraudMonitorFee": "Fraud Monitoring Fee (Flat Fee)",
        "SettlementTransferFee": "Settlement Transfer Fee",
        "TransactionFee": "Success Fee",
        "BankFee": "Decline Fee",
        "RefundFee": "Refund Fee",
        "ChargebackFee": "Chargeback Fee",
        "MinFeeAmt": "Pre-Arbitration Fee",
        "MaxFeeAmt": "Representment Fee",
        "RetrievalFee": "Retrievals Fee",
        "MDR": "MDR",
        "MicroMDR": "Micro MDR",
        "RollingReserve": "Rolling Reserve %",
        "RollingReserveHeld": "Rolling Reserve Held (YTD)",
      },
      "View_Details": "查看詳情",
      // Add_Risk_Rule: 'Add Risk Rule',
      "Edit_Risk_Rule": "編輯風險規則",
      "view_subscription_Plan": "訂閱方案詳情",
      "Edit_Subscription_Plan": "編輯訂閱方案",
      "View_Subscriber": "訂閱者詳情",
      "Edit_Subscriber": "編輯訂閱者",
      "View_Subscriptions": "查看訂閱",
      "Create_Subscription": "建立訂閱",
      "Edit_Subscription": "編輯訂閱",
      "View_Scheduler": "查看排程"
    },
    "User_Management": {
      "label": "使用者存取管理",
      "columnDefs": {
        "Action": "操作",
        "First_Name": "名字",
        "Last_Name": "姓氏",
        "Email": "電子郵件地址",
        "User_Role": "使用者角色",
        "Recieve_Notifications": "接收通知",
        "User_Access_Level": "使用者存取層級",
        "Status": "狀態",
        "Join_Date": "加入日期",
        "Last_Login": "最後登入時間",
        "DASMID": "DAS 商戶編號",
        "Products": "產品",
        "Notifications": {
          "Recieve_Notifications": "接收通知",
          "Chargeback": "退單",
          "Statement": "對帳單",
          "Help_Support": "幫助與支援",
          "Emergency_Holiday": "緊急假期",
          "Monthly_Public_Holiday": "每月公眾假期"
        }
      },
      "Edit_User": "編輯使用者權限",
      "Reset": "重設密碼",
      "Deactivate": "停用使用者",
      "Activate": "啟用使用者",
      "Delete": "刪除使用者",
      "button": {
        "cancel": "取消",
        "submit": "提交"
      },
      "Add_New_User": {
        "add_label": "新增使用者",
        "edit_label": "編輯使用者"
      },
      "User_Roles": {
        "Admin": "管理員",
        "Viewer": "檢視者",
        "Editor": "編輯者",
        "Customer": "客戶",
        "Expired": "已過期",
        "Staff": "員工"
      },
      "Status": {
        "Active": "啟用",
        "Inactive": "停用",
        "Expired": "已過期"
      },
      "DeletePopup": {
        "title": "刪除",
        "heading": "是否確定？",
        "content": "是否確定要刪除此使用者？此操作無法復原",
        "button": {
          "cancel": "取消",
          "submit": "刪除"
        }
      },
      "DeactivatePopup": {
        "title": "停用",
        "heading": "是否確定？",
        "content": "是否確定要停用此使用者？此操作無法復原",
        "button": {
          "cancel": "取消",
          "submit": "確認"
        }
      },
      "ActivatePopup": {
        "title": "啟用",
        "heading": "是否確定？",
        "content": "是否確定要啟用此使用者？此操作無法復原",
        "button": {
          "cancel": "取消",
          "submit": "確認"
        }
      },
      "ResetPasswordPopup": {
        "title": "重設密碼",
        "heading": "是否確定？",
        "content": "是否確定要重設密碼？系統將寄送電子郵件通知使用者，此操作無法復原",
        "button": {
          "cancel": "取消",
          "submit": "確認"
        }
      },
      "ApiMessages": {
        "Delete": {
          "UserDelete": "使用者已成功刪除",
          "UserDeleteFailed": "使用者刪除失敗"
        }
      }
    },
    "Subscription": {
      "label": "訂閱",
      "tabs": {
        "subscriptionsPlans": "訂閱方案",
        "Subscriptions": "訂閱",
        "Subscribers": "訂閱者"
      },
      "columnDefs": {
        "action": "操作",
        "planName": "方案名稱",
        "billingCycle": "計費週期",
        "amount": "金額",
        "trialPeriod": "試用期",
        "discount": "折扣",
        "discountPercenatge": "折扣百分比",
        "discountMonth": "折扣月數",
        "Subscribers": "訂閱者",
        "status": "狀態",
        "subscriptionName": "訂閱名稱",
        "subscriptionPlan": "訂閱方案",
        "subscriptionID": "訂閱編號",
        "subscriberName": "訂閱者姓名",
        "startDate": "開始日期",
        "endDate": "結束日期",
        "nextBilling": "下次扣款",
        "nextBillingDate": "下次扣款日期",
        "cycleBilling": "已扣款週期",
        "source": "來源",
        "planID": "方案編號",
        "subscriptionLink": "訂閱連結",
        "trialPeriodFree": "試用期（免費天數）",
        "Days": "天",
        "APIDAYS": "天",
        "Months": "月",
        "emailAddress": "電子郵件地址",
        "firstName": "名字",
        "lastName": "姓氏",
        "includes": "包含",
        "immediately": "立即",
        "specificDate": "指定日期",
        "forever": "永久",
        "after": "之後",
        "cycles": "週期",
        "linkExpiryDate": "連結到期日",
        "sendSubscriptionLink": "傳送訂閱連結給訂閱者",
        "billedCycle": "已計費週期",
        "phoneNum": "電話號碼",
        "CardNumber": "卡號",
        "expiryDate": "到期日",
        "country": "國家",
        "subscriptions": "訂閱",
        "cvv": "CVV",
        "postCode": "郵遞區號",
        "billingCountry": "帳單國家",
        "browse": "瀏覽",
        "currency": "貨幣",
        "CreateSubscription": "建立訂閱",
        "firstPercentage": "首期百分比",
        "SpecificStartDate": "指定開始日期",
        "SpecificEndDate": "指定結束日期",
        "Subscription Type": "訂閱類型",
        "Discount Percentage": "折扣百分比",
        "Discount Month": "折扣月份",
        "SUBSCRIBER DETAILS": "訂閱者資料",
        "SUBSCRIPTION DETAILS": "訂閱詳情",
        "Comments": "備註"
      },
      "buttons": {
        "view": "查看詳情",
        "copyLink": "複製連結",
        "edit": "編輯",
        "duplicatePlan": "複製方案",
        "duplicate": "複製",
        "delete": "刪除",
        "cancel": "取消",
        "submit": "提交",
        "addSubscriptionPlan": "建立新訂閱方案",
        "addSubscription": "建立新訂閱",
        "uploadSubscription": "匯入訂閱",
        "regenerateLink": "重新產生連結",
        "createSubscription": "建立訂閱",
        "pauseButton": "暫停",
        "resumeButton": "恢復"
      },
      "drawer": {
        "subscriptionPlanDetails": "訂閱方案詳情",
        "addSubscriptionPlan": "建立新訂閱方案",
        "EditSubscriptionPlan": "編輯訂閱方案",
        "editSubscriptionPlanDetails": "編輯訂閱方案",
        "createSubscription": "建立訂閱",
        "SubscriptionDetails": "訂閱詳情",
        "EditSubscription": "編輯訂閱",
        "ViewSubscriber": "訂閱者詳情"
      },
      "subscriptionDetailsDrawer": {
        "subscriberDetails": "訂閱者資料",
        "subscriptionDetails": "訂閱詳情"
      },
      "deletePopup": {
        "deleteSubscriptionPlan": "刪除訂閱方案",
        "deleteSubscriber": "刪除訂閱者",
        "warningMsg": "是否確定？",
        "deleteSubscription": "刪除訂閱",
        "subscriptionPlanContent": "是否確定要刪除此訂閱方案？此操作無法復原",
        "subscriptionContent": "是否確定要取消此訂閱？此操作無法復原",
        "subscriberContent": "是否確定要刪除此訂閱者？此操作無法復原",
        "subscriptionPlanDeleteMsg": "訂閱方案已成功刪除",
        "subscriberDeleteMsg": "訂閱者已成功刪除",
        "pauseSubscription": "暫停訂閱",
        "resumeSubscription": "恢復訂閱",
        "pauseSubscriptionMsg": "是否確定要暫停此訂閱？",
        "resumeSubscriptionMsg": "是否確定要恢復此訂閱？"
      },
      "downloadPopup": {
        "subscriptionsCSVImport": "訂閱CSV匯入",
        "popupHeader": "請以上傳CSV格式的訂閱清單",
        "uploadCSVFile": "上傳CSV檔案"
      },
      "duplicatePopup": {
        "duplicateSubscription": "訂閱已存在",
        "heading": "此訂閱者已擁有此訂閱方案：",
        "changePlan": "變更方案",
        "overwriteSubscription": "覆蓋訂閱"
      },
      "Subscriber": {
        "editSubscriber": "編輯訂閱者",
        "paymentDetails": "付款資料"
      },
      "errorMsg": {
        "endDate": "必須填寫結束日期",
        "startDate": "必須填寫開始日期"
      },
      "subscriberCount": "此訂閱方案已有現有訂閱者",
      "activeSubscriber": "訂閱者為啟用狀態",
      "subscriptionCreatedSuccessfully": "訂閱建立成功",
      "subscriptionUpdatedSuccessfully": "訂閱更新成功"
    },
    "ContactDetail": {
      "label": "聯絡資料",
      "fields": {
        "FirstName": "名字",
        "LastName": "姓氏",
        "MiddleName": "中間名",
        "TelephoneNumber": "電話號碼",
        "EmailAddress": "電子郵件地址"
      }
    },
    "breadcrumbs": {
      "Home": "首頁",
      "Merchants": "商戶",
      "MerchantsDetails": "商戶資料"
    }
  },
  "ProductModal": {
    "Merchant Account": "商戶帳戶",
    "Shop Processing URL": "商戶處理網址",
    "customerServiceNumber":"Customer Service Number",
    "Merchant Category Code": "商戶類別代碼",
    "Settlement Currency": "結算貨幣",
    "Processing Currency": "交易貨幣",
    "Acquirer MID": "收單商戶編號",
    "Recurring Acquirer MID": "週期性收單商戶編號",
    "Auth Acquirer MID": "授權收單商戶編號",
    "ApplePay MID": "ApplePay 商戶編號",
    "GooglePay MID": "GooglePay 商戶編號",
    "GCash MID": "GCash 商戶編號",
    "PAYPAY MID": "PAYPAY 商戶編號",
    "PayEasy MID": "PAYEasy 商戶編號",
    "Konbini MID": "Konbini 商戶編號",
    "Purchase Acquirer MID": "購買收單商戶編號",
    "DAS MID": "DAS 商戶編號",
    "Billing Descriptor": "帳單描述",
    "Merchant Logo URL": "商戶標誌網址",
    "Scheme Types": "卡組類型",
    "Acquirer Code": "收單機構",
    'Customer Service Number': 'Customer Service Number',
    "ConnectionMethods": {
      "Connection Methods": "整合類型",
      "value": {
        "HPP": "Hosted Payment Page",
        "SERVERTOSERVERAPI": "Server to Server"
      }
    },
    "TransactionType": {
      "Transaction Type": "交易類型",
      "value": {
        "3DSecure": "3D安全驗證",
        "Non3DSecure": "非3D安全驗證",
        "CVV2/CVC2": "CVV2/CVC2",
        "NonCVV2/CVC2": "非CVV2/CVC2",
        "Recurring": "週期性扣款",
        "Tokenised": "代幣化",
        "DynamicMCC": "動態商戶類別代碼"
      }
    },
    "button": {
      "closeButton": "關閉"
    }
  },
  "Acquirer_Details": {
    "AcquirerDetails": {
      "label": "收單機構詳情",
      "fields": {
        "AcquirerName": "收單機構",
        "TimeZone": "時區",
        "URL1": "網址",
        "Country": "國家",
        "ChargebackInvestigationDays": "退單調查天數",
        "AcquirerIndentifier": "收單機構代碼",
        "RetrievalInvestigationDays": "交易查詢整合天數",
        "SettlementOffset": "結算偏移",
        "Token": "代碼",
        "Sender": "發送者",
        "Channel": "通道",
        "Status": "狀態"
      }
    },
    "AcquirerMID": {
      "label": "收單商戶編號詳情",
      "fields": {
        "AcquirerMID": "收單商戶編號",
        "PaymentCurrency": "付款貨幣",
        "SettlementCurrency": "結算貨幣",
        "Description": "描述",
        "EnterMsg": "輸入訊息"
      }
    },
    "breadcrumbs": {
      "Home": "首頁",
      "Acquirer": "收單機構",
      "AcquirerDetails": "收單機構詳情"
    }
  },
  "Add_Acquirer": {
    "AddAcquirer": {
      "label": "新增收單機構",
      "fields": {
        "AddAcq": "收單機構",
        "TimeZone": "時區",
        "URL1": "網址",
        "Country": "國家",
        "ChargebackInvestigationDays": "退單調查天數",
        "AcquirerIndentifier": "收單機構代碼",
        "RetrievalInvestigationDays": "交易查詢整合天數",
        "SettlementOffset": "結算偏移",
        "Status": "狀態",
        "Token": "代碼",
        "Sender": "發送者",
        "Channel": "通道",
        "URLMaxLimitMessage": "最多256個字元",
        "NameMaxLimitMessage": "最多128個字元",
        "CodeMaxLimitMessage": "最多45個字元"
      },
      "breadcrumb": {
        "Home": "首頁",
        "Acquirer": "收單機構",
        "AddAcquirer": "新增收單機構"
      },
      "button": {
        "Submit": "提交",
        "Cancel": "取消"
      }
    }
  },
  "EditAcquirer": {
    "label": "編輯收單機構詳情",
    "breadcrumb": {
      "Home": "首頁",
      "Acquirer": "收單機構",
      "AcquirerDetails": "收單機構詳情",
      "EditAcquirer": "編輯收單機構"
    }
  },
  "Filter": {
    "AdvancedFilters": "進階篩選",
    "AdvancedNextGenFilters": "下一代篩選器",
    "Add_New_Filter": "新增篩選條件",
    "button": {
      "Reset": "重設",
      "Apply": "套用"
    },
    "field": "欄位",
    "Value": "值",
    "Operator": "運算子",
    "AUTHORISATION": "授權",
    "PURCHASE": "消費",
    "CAPTURE": "捕捉",
    "VOIDAUTHORISATION": "取消授權",
    "REFUND": "退款",
    "SUCCESSFUL": "成功",
    "NOTSUCCESSFUL": "失敗",
    "PENDING": "進行中",
    "SELECTDATERANGE": "選擇日期範圍",
    "ECOM": "電子商務",
    "QR": "QR",
    "PBL": "PBL",
    "SUBSCRIPTION": "訂閱",
    "SCHEDULER": "排程",
    "MOTO": "MOTO",
    "SOFTPOS": "軟POS"
  },
  "ISSUE_A_REFUND": {
    "label": "發起退款"
  },
  "FormTemplate": {
    "button": {
      "Submit": "提交",
      "Cancel": "取消"
    }
  },
  "ProductRiskRuleDrawerModal": {
    "currency": {
      // JPY: 'JPY',
      "SGD": "新加坡幣"
    },
    "DownloadProhibitedList": "下載禁止清單",
    // RISK_CONFIGURATION: 'Risk Configuration',
    // 'transaction-title': 'Risk Controls for',
    // Statement: 'Statement',
    "Trigger_Type": "觸發類型",
    "Action": "操作",
    // Configure_Rules: 'Configure Rules',
    "Blacklist": "黑名單",
    "Threshold": "閾值",
    "Velocity": "速度限制",
    "Whitelist": "白名單",
    "Refund_Percentage": "退款百分比",
    "Max_Volume": "交易量",
    // ProhibitedList: 'Prohibited Country List',
    // Field: 'Field',
    "TimeFrame": "時間範圍",
    "Select_Currency": "選擇貨幣",
    "Total_payout": "總撥款金額",
    "Allowable_Refund": "允許退款百分比",
    "Refund_Balance": "允許退款金額",
    "Remaining_Refund_Amount": "剩餘退款金額",
    "Settlement_Period": "結算週期",
    "Payment_Cycle": "付款週期",
    "Statement_Status": "對帳單狀態",
    // Value: 'Value',
    // Required: 'Required',
    // Choose_File: 'Choose File',
    // No_File_Chosen: 'No file chosen',
    // Edit_Ridk_Rule: 'Edit Risk Rule',
    "Add_Risk_configuration": "新增風險配置",
    "button": {
      "Submit": "提交",
      "Cancel": "取消"
    },
    // helperText: {
    // Threshold: 'Value of the number must be greater than 0',
    // TimeFrame: 'Value must be greater than 0',
    // Value: 'The value of the number must be greater than 0',
    // },
    "option": {
      "IssuingCountry": "發卡國家",
      // PAN: 'PAN',
      // IPAddress: 'IP Address',
      "Field": "單筆最大交易金額",
      "MaxTransactionAmount": "單筆最大交易金額",
      "MinTransactionAmount": "單筆最小交易金額",
      "MaxVolume": "最大交易量",
      "REFUND": "退款次數",
      "REFUND_VOLUME": "退款交易量"
    },
    "message": {
      "Value": "數值最多僅可到小數點後兩位"
    }
  },
  "ProductEnableDisableMid": {
    "heading": "啟用／停用商戶編號"
  },
  "TransactionCaptureDrawerBody": {
    "ISSUE_A_CAPTURE": "發起請款",
    "fields": {
      "Original_Amount": "原始金額",
      "Remaining": "剩餘金額",
      "CaptureAmount": "請款金額",
      "Reference": "參考編號（選填）",
      "ConfirmCaptureCheckbox": "是的，我想請款該金額，並了解此操作不可逆。請協助執行請款流程"
    },
    "helperText": {
      "CaptureAmountJP": "數值必須大於1",
      "CaptureAmount": "數值必須大於0",
      "OptionalMessage": "最多僅限128個字元"
    },
    "message": {
      "ConfirmCaptureCheckbox": "請確認是否要繼續此請求",
      "CaptureAmount": "數值最多僅可到小數點後兩位",
      "notification": "請款金額不可大於剩餘金額",
      "ref_max_Character": "最多僅限128個字元"
    },
    "button": {
      "Submit": "提交",
      "Cancel": "取消"
    }
  },
  "TransactionRefundDrawerBody": {
    "notification": "退款金額不可大於剩餘金額"
  },
  "TransactionCSVDownload": {
    "heading": "CSV下載選項",
    "subTitle": "請選擇日期範圍以下載CSV",
    "label": "選擇日期範圍",
    "downloadCsv": "請下載CSV"
  },
  "EntityRiskConfiguration": {
    // label: 'Risk Configuration',
    // Risk_ColumnDefs: {
    //  Statement: 'Statement',
    //  Type: 'Trigger Type',
    //  POEntity: 'PO Entity',
    //  action: 'Action',
    //  enabled: 'Status',
    // },
    // Confirmation_Dialog: {
    // title: 'Delete',
    //   heading: 'Are you sure?',
    //   content:
    //     'Do you really want to delete this record? This process can not be undone.',
    // },
    "fields": {
      // subsidiaryID: 'PO Entity',
      // statement: 'Statement',
      // type: 'Trigger Type',
      // fieldBlackList: 'Field',
      // blacklisteditems: 'Prohibited Country List',
      // blacklistedbins: 'Prohibited Bin List',
      // blacklistedpan: 'Prohibited Pan List',
      // blacklistedip: 'Prohibited IP List',
      "enabled": "狀態",
      "errorMessage": "檔案過大，最大允許大小為$maxSize KB。目前檔案為$size KB"
    },
    "form_title": "設定規則",
    file_upload: {
      // label: 'Prohibited List',
    },
    "button": {
      "Submit": "提交",
      "Cancel": "取消"
    },
    "breadcrumbs": {
      "Home": "首頁",
      // Rules: 'Entity Risk Rule',
    },
    "options": {
      "Singapore": "PO 新加坡",
      "Japan": "PO 日本",
      "Mauritius": "PO 模里西斯",
      "Lithuania": "PO 立陶宛",
      "Malaysia": "PO 馬來西亞"
    },
    "TriggerTypeValues": {
      "VELOCITY": "交易速度限制",
      "BLACKLIST": "黑名單",
      "THRESHOLD": "閾值",
      "WHITELIST": "白名單",
      "REFUND": "退款",
      "VOLUME": "交易量"
    },
    // TriggerType: 'Blacklist',
    // BinNumbers: 'Bin Numbers',
    // IP_Address: 'IP Address',
    // IssuingCountry: 'Issuing Country',
    // PAN: 'PAN',
    // Status: {
    //   Enabled: 'Enabled',
    //   Disabled: 'Disabled',
    // },
  },
  "PayByLinkConfiguration": {
    "Pay By Link": "連結付款",
    "Das Pay By Link": "Das 連結付款",
    "PayByLink_ColumnDefs": {
      "action": "操作",
      "link": "連結編號",
      "linkname": "連結名稱",
      "linknameoptional": "連結名稱（選填）",
      "generateddate": "產生日期",
      "amount": "總金額",
      "expirydate": "到期日期",
      "reminderdate": "提醒日期",
      "status": "狀態"
    },
    "PayByLink_ColumnDefs_Buttons": {
      "View Details": "查看詳情",
      "View Link": "查看連結",
      "Copy Link": "複製連結"
    },
    "Create_link_button": {
      "Create New Link": "建立新連結"
    },
    "Pay By Link For": "連結付款對象",
    "Link_fields": {
      "Set Reminder": "設定提醒",
      "Expiry Date": "到期日期",
      "Let customer adjust quantity": "允許客戶調整數量",
      "Allow Promocodes": "允許折扣碼"
    },
    "Pbl_button": {
      "Generate Link": "產生連結",
      "Deactivate Link": "停用連結"
    },
    "message": {
      "Value is not a number": "數值不是數字"
    },
    "Generate_button": {
      "copy": "複製",
      "preview": "預覽"
    },
    "Cart_Details": {
      "Cart Items": "購物車項目",
      "Total": "總計："
    },
    "Message_Update": {
      "PayByLINK_Details_Updated": "連結付款詳情已更新",
      "Order_Link_Desactivated": "訂單連結已停用"
    },
    "Confirmation_Dialog": {
      "LEAVE PAGE": "是否離開頁面？",
      "Are you sure": "是否確定？",
      "you want to leave this page": "是否要離開此頁面？",
      "content": "您對此連結所做的變更可能尚未儲存，請重新產生此連結",
      "STAY": "停留",
      "EXIT": "離開"
    },
    "Confirmation_Delete_Dialog": {
      "Delete": "刪除",
      "Are you sure": "是否確定？",
      "content": "是否確定要刪除此記錄？此操作無法復原",
      "cancel": "取消",
      "submit": "提交"
    },
    "Confirmation_Deactivate_Dialog": {
      "title": "停用連結",
      "heading": "是否確定？",
      "content": "是否確定要停用此連結？此操作無法復原",
      "cancel": "取消",
      "submit": "提交"
    },
    "PblDelete_item": {
      "delete_item": "購物車中至少需新增一個項目"
    },
    "file_upload": {
      "fileSize": "檔案過大，最大允許大小為$maxSize KB，目前檔案為$size KB",
      "imageType": "不支援的圖片格式"
    },
    "PblProduct_ColumnDefs": {
      "action": "操作",
      "photo": "圖片",
      "products": "產品",
      "quantity": "數量",
      "price": "單價",
      "totalPrice": "總價"
    },
    "PblProduct_ColumnDefs_Buttons": {
      "Edit Item": "編輯項目",
      "Delete Item": "刪除項目"
    },
    "Add_Product_button": {
      "Add New Item": "新增項目"
    },
    "Product_fields": {
      "productname": "產品名稱",
      "quantity": "數量",
      "currency": "選擇貨幣",
      "price": "單價",
      "upload": "上傳照片",
      "errorMsg": {
        "MaxLimit Message": "最多255個字元",
        "MaxNameLimit Message": "最多100個字元"
      }
    },
    "Product_button": {
      "Add To Cart": "加入購物車",
      "Cancel": "取消"
    },
    "BreadCrumb": {
      "Home": "首頁",
      "paybylink": "連結付款"
    }
  },
  "CreateThresholdEndAdornment": {
    "Payment_Attempts": "付款嘗試次數"
  },
  // CreateTimeFrameAdornment: {
  //   Months: 'Months',
  //   Hours: 'Hours',
  //   Minutes: 'Minutes',
  // },
  "PoMidSchema": {
    "QR": {
      "Merchant_Name": "商戶名稱",
      "Merchant Category Code": "商戶類別代碼",
      "Currency": "貨幣",
      "Acquirer MID": "收單商戶編號",
      "DAS MID": "DAS 商戶編號",
      "Location Name": "地點名稱",
      "Terminal ID": "終端機編號",
      "Terminal Name": "終端機名稱",
      "Merchant Logo URL": "商戶標誌網址",
      "Billing Descriptor": "帳單描述",
      "Scheme Types": "卡組類型",
      "TransactionType": {
        "Transaction Type": "交易類型",
        "value": {
          "3DSecure": "3D安全驗證",
          "CVV2/CVC2": "CVV2/CVC2",
          "NonCVV2/CVC2": "非CVV2/CVC2",
          "Non3DSecure": "非3D安全驗證"
        }
      },
      "Generate_label": "選擇貨幣以生成QR碼",
      "button": {
        "Download_QR": "下載QR碼",
        "Generate_QR": "產生QR碼"
      }
    }
  },
  "PoMidSchemaPBL": {
    "PBL": {
      "Merchant_Name": "商戶名稱",
      "MCC": "商戶類別代碼",
      "Currency": "貨幣",
      "Acquirer_MID": "收單商戶編號",
      "DASMID": "DAS 商戶編號",
      "Location_name": "地點名稱",
      "TerminalID": "終端機編號",
      "MerchantLogoURL": "商戶標誌網址",
      "BillingDescriptor": "帳單描述",
      "SchemeTypes": "卡組類型",
      "TransactionType": {
        "label": "交易類型",
        "value": {
          "3DSecure": "3D安全驗證",
          "CVV2/CVC2": "CVV2/CVC2",
          "NonCVV2/CVC2": "非CVV2/CVC2",
          "Non3DSecure": "非3D安全驗證",
          "Recurring": "週期性扣款"
        }
      }
    }
  },
  "PoMidSchemaSCHEDULER": {
    "SCHEDULER": {
      "Merchant_Name": "商戶名稱",
      "MCC": "商戶類別代碼",
      "Currency": "貨幣",
      "Acquirer_MID": "收單商戶編號",
      "DASMID": "DAS 商戶編號",
      "Location_name": "地點名稱",
      "TerminalID": "終端機編號",
      "MerchantLogoURL": "商戶標誌網址",
      "BillingDescriptor": "帳單描述",
      "SchemeTypes": "卡組類型",
      "TransactionType": {
        "label": "交易類型",
        "value": {
          "3DSecure": "3D安全驗證",
          "CVV2/CVC2": "CVV2/CVC2",
          "NonCVV2/CVC2": "非CVV2/CVC2",
          "Non3DSecure": "非3D安全驗證",
          "Recurring": "週期性扣款"
        }
      }
    }
  },
  "PoMidSchemaMOTO": {
    "MOTO": {
      "Merchant_Name": "商戶名稱",
      "MCC": "商戶類別代碼",
      "Currency": "貨幣",
      "Acquirer_MID": "收單商戶編號",
      "DASMID": "DAS 商戶編號",
      "Location_name": "地點名稱",
      "TerminalID": "終端機編號",
      "MerchantLogoURL": "商戶標誌網址",
      "BillingDescriptor": "帳單描述",
      "SchemeTypes": "卡組類型",
      "TransactionType": {
        "label": "交易類型",
        "value": {
          "3DSecure": "3D安全驗證",
          "CVV2/CVC2": "CVV2/CVC2",
          "NonCVV2/CVC2": "非CVV2/CVC2",
          "Non3DSecure": "非3D安全驗證",
          "Recurring": "週期性扣款"
        }
      }
    }
  },
  "AddNewProduct": {
    "Tooltip": "返回",
    "Title": "購物車項目"
  },
  "constants": {
    "Failure": {
      "ACTION_INVALID_USER": "使用者名稱或密碼無效"
    },
    "SUCCESS": {
      "ACTION_VOID_AUTHORIZATION": "交易已成功撤銷",
      "ACTION_CAPTURE": "金額請款成功",
      "ACTION_REFUND": "金額退款成功"
    }
  },
  "RiskManagement": {
    "CreateRule": "建立新規則",
    "NoLevels": "無層級",
    "Schema": {
      "tooltip": {
        "fieldSelect": "選擇用於規則評估的交易屬性",
        "valueText": "輸入將與所選欄位比較的值",
        "valueSelect": "選擇將與所選欄位比較的值",
        "levelField": "選擇用於規則評估的層級",
        "levelValue": "輸入將與所選層級類型比較的層級值"
      }
    }
  },
  "DisputeManagement": {
    "Dispute Management": "爭議管理",
    "Status_Heading": "編輯拒付案件",
    "InformationCards": {
      "TOTALDISPUTES": {
        "heading": "爭議總數"
      },
      "TOTALAMOUNTSGD": {
        "heading": "總金額",
        "currencySGD": CurrencyType.SGD,
      },
      "TOTALAMOUNTJAPAN": {
        "heading": "總金額",
        "currencyJPY": CurrencyType.JPY,
      }
    },
    "DrawerType": {
      "StatusType": {
        "open": "處理中",
        "progress": "未代表申訴",
        "represented": "已關閉",
        "closed": "已過期",
        "expired": "爭議案件詳情"
      }
    },
    "DisputeDetailHeading": "案件討論",
    "CaseDiscussion": {
      "label": "訊息",
      "fields": {
        "Message": "新增檔案",
        "AddFile": "發送"
      },
      "button": {
        "Submit": "挑戰爭議"
      }
    },
    "ChallangeDispute": "案件歷史",
    "CaseHistory": {
      "label": "交易資料請求",
      "RetrievalRequest": "首次拒付",
      "FirstChargeback": "首次拒付",
      "SecondChargeback": "二次拒付",
      "Reversal": "拒付撤銷",
      "LostFund": "損失資金",
      "CaseClosed": "案件已關閉",
      "InternalDispute": "內部爭議",
      "AutoRepresentment": "自動代表申訴",
      "ChargebackReversal": "拒付撤銷",
      "CaseCreated": "案件已建立",
      "EvidenceUnderReview": "證據審核中",
      "CaseReOpened": "案件重新開啟",
      "CaseUpdated": "案件已更新"
    },
    "OrignalHistory": {
      "Orignal Transaction History": "原始交易紀錄"
    },
    "columnDefs": {
      "Action": "操作",
      "ChargebackCaseID": "案件編號",
      "DASMID": "DAS 商戶編號",
      "Merchant": "商戶帳戶",
      "MerchantInEnglish": "商戶帳戶（英文）",
      "CaseType": "案件類型",
      "ReasonID": "原因代碼",
      "ReasonCategory": "原因描述",
      "STATUS": "狀態",
      "Amount": "爭議金額",
      "Currency": "貨幣",
      "IssueDate": "發起日期",
      "DueDate": "到期日期",
      "UpdatedAt": "更新日期",
      "ARN": "授權參考號碼（ARN）",
      "Acquirer": "收單機構",
      "OrderCode": "交易參考編號"
    },
    "DetailInfo": {
      "Case Info": "案件資訊",
      "fields": {
        "Chargeback Case ID": "案件編號",
        "Merchant": "商戶帳戶",
        "MerchantInEnglish": "商戶帳戶（英文）",
        "ARN": "授權參考號碼（ARN）",
        "Auth Code": "授權碼",
        "Case Type": "案件類型",
        "Date": "發起日期",
        "Cycle": "週期",
        "Reason Category": "爭議原因描述",
        "Card Number": "卡號",
        "Amount": "爭議金額",
        "Currency": "貨幣",
        "Due Date": "到期日期",
        "DASMID": "DAS 商戶編號",
        "Acquirer": "收單機構",
        "STATUS": "狀態",
        "Order Code": "訂單編號",
        "Time Left": "剩餘時間"
      }
    },
    "BreadCrumb": {
      "Home": "首頁",
      "list": "爭議管理"
    },
    "DownloadCSV": "下載CSV",
    "SentToAcquirer": "已送往收單機構",
    "IssueChargeback": "建立新案件",
    "DisputeListButtons": {
      "Details": "詳情",
      "Complete": "已送往收單機構",
      "Accept": "接受爭議",
      "Challenge": "挑戰爭議",
      "Evidence": "提交證據",
      "Missing Info": "缺少資訊",
      "Missing Information": "缺少資訊",
      "label": "請在案件討論中上傳證據",
      "Case Close": "結案",
      "Edit": "編輯"
    },
    "Status": {
      "CASE STATUS": "案件狀態",
      "open": "開啟"
    },
    "FilterStatus": {
      "open": "開啟",
      "closed": "已關閉"
    },
    "AutoLodge": {
      "Title": "自動提交拒付",
      "Button": "自動提交",
      "UploadInstruction": "上傳自動提交拒付檔案（格式 XLSX）",
      "DragDropText": "拖放您的檔案至此",
      "FormatNote": "注意：請確保檔案符合指定模板格式，僅接受 .xlsx 檔案，工作表名稱必須為「Chargeback」",
      "InvalidFileType": "檔案類型無效，請上傳 Excel 檔（.xlsx）",
      "FileTooLarge": "檔案大小超過 5MB 限制",
      "NoFileSelected": "請選擇檔案以上傳",
      "UploadSuccess": "拒付資料上傳成功",
      "UploadFailed": "拒付上傳失敗，請重試",
      "DownloadTemplate": "下載範本",
      "TemplateHint": "使用此範本以確保格式正確",
      "TemplateDownloaded": "範本下載成功",
      "TemplateDownloadFailed": "範本下載失敗",
      "RequiredColumns": "必填欄位（依順序）",
      "MandatoryNote": "標示星號及橘色邊框的欄位為必填",
      "Validating": "檔案驗證中",
      "ValidationSuccess": "檔案驗證成功，準備上傳",
      "ValidationFailed": "驗證失敗，請修正以下錯誤",
      "ValidationError": "驗證期間發生錯誤",
      "ValidationErrors": "驗證錯誤",
      "AllRowsValid": "所有列皆有效，已準備上傳",
      "ValidationErrorsFound": "發現驗證錯誤，請修正後重新上傳",
      "FixValidationErrors": "請先修正驗證錯誤再進行上傳",
      "MoreErrors": "以及 {{count}} 個錯誤"
    }
  },
  "MDR": {
    "Add_MDR_Rates": "新增 MDR 費率",
    "Same_MDR_Rates": "所有產品皆使用相同 MDR 費率",
    "buttons": {
      "mdrRates": "MDR 費率",
      "submit": "提交",
      "confirm": "確認",
      "cancel": "取消"
    },
    "Confirmation_Dialog": {
      "sub_content": "是否確定要提交此 MDR 費率？此操作無法復原"
    }
  },
  "AcceptChargebackDrawer": {
    "Accept_Chargeback": "接受拒付",
    "Info": "接受拒付將會針對此交易發起退款，並從下次撥款中扣除",
    "fields": {
      "Original_Amount": "拒付金額",
      "Remaining": "退款金額"
    },
    "helperText": {
      "CaptureAmount": "數值必須大於0"
    },
    "button": {
      "Submit": "接受拒付",
      "Cancel": "取消"
    }
  },
  "DeclineChargebackDrawer": {
    "Decline_Chargeback": "拒絕拒付",
    "Info": "請提供證據並上傳相關文件以支持您的案件",
    "fields": {
      "Description": "描述",
      "FileUpload": "上傳檔案"
    },
    "helperText": {
      "CaptureAmount": "數值必須大於0"
    },
    "button": {
      "Submit": "拒絕拒付",
      "Cancel": "取消"
    }
  },
  "SubmitEvidenceDrawer": {
    "Heading": "提交證據",
    "fields": {
      "message": "輸入訊息",
      "document": "附加檔案",
      "upload": "點擊上傳",
      "helperText": {
        "OptionalMessage": "最多250個字元",
        "OptionalDesMessage": "最多128個字元"
      },
      "file_upload": {
        "fileSize": "檔案過大，最大允許大小為$maxSize MB，目前檔案為$size MB",
        "imageType": "僅支援PDF檔案格式"
      },
      "button": {
        "send": "發送",
        "cancel": "取消"
      }
    },
    "successMessage": "拒付案件已成功更新"
  },
  "SearchChargebackTransaction": {
    "Heading": "搜尋交易",
    "fields": {
      "CardNumber": "卡號",
      "Date": "交易日期",
      "V2UUID": "V2編號",
      "Acquirer": "收單機構",
      "Amount": "金額",
      "AuthCode": "授權碼",
      "Scheme": "卡組織"
    },
    "helperText": {
      "CaptureAmount": "數值必須大於0"
    },
    "button": {
      "Submit": "搜尋",
      "Cancel": "取消",
      "Reset": "重設"
    },
    "TransactionResult": "交易結果",
    "columnDefs": {
      "Action": "操作",
      "TransactionRefID": "交易參考編號",
      "V2UUID": "V2編號",
      "DASMID": "DAS商戶編號",
      "Date": "日期",
      "Amount": "金額",
      "AuthCode": "授權碼"
    },
    "ActionButton": "查看",
    "EditButton": "連結"
  },
  "IssueChargebackDrawer": {
    "Issue_Chargeback": "發起拒付／交易查詢 (Retrieval)",
    "fields": {
      "TransactionRefID": "交易參考編號",
      "ChargebackARN": "授權參考號碼（ARN）",
      "Acquirer": "收單機構",
      "ChargebackIssuedDays": "發起日期",
      "DueDate": "到期日期",
      "Amount": "爭議金額",
      "ReasonCategory": "原因描述",
      "ReasonForUpdate": "更新原因",
      "Cycle": "案件類型",
      "OrderID": "交易參考編號",
      "Status": "狀態"
    },
    "AcquirerValues": {
      "Worldpay": "WorldPay"
    },
    "helperText": {
      "CaptureAmount": "數值必須大於0"
    },
    "button": {
      "Submit": "提交",
      "Cancel": "取消"
    },
    "message": {
      "notification": "金額不可大於原始金額",
      "Cancel": "返回列表"
    },
    "ApprovePopup": {
      "title": "已完成",
      "heading": "是否確定？",
      "content": "是否確定要送往收單機構？此操作無法復原",
      "message": {
        "settlementFailed": "爭議完成失敗",
        "settlementSuccess": "爭議已完成並核准"
      },
      "button": {
        "cancel": "取消",
        "submit": "完成"
      }
    },
    "AcceptDisputePopup": {
      "title": "接受爭議",
      "heading": "是否確定？",
      "content": "是否確定要接受此爭議？此操作無法復原",
      "message": {
        "settlementFailed": "接受爭議失敗",
        "settlementSuccess": "接受爭議已核准"
      },
      "button": {
        "cancel": "取消",
        "submit": "接受"
      }
    },
    "CaseClosePopup": {
      "title": "結案",
      "heading": "是否確定？",
      "content": "是否確定要結案此案件？此操作無法復原",
      "message": {
        "settlementFailed": "結案失敗",
        "settlementSuccess": "結案已核准"
      },
      "button": {
        "cancel": "取消",
        "submit": "核准"
      }
    },
    "CaseCloseDrawer": {
      "title": "結案",
      "fields": {
        "reason": "原因",
        "comment": "備註"
      }
    }
  },
  "CreateCurrencyFrameAdornment": {
    "SGD": "新加坡幣",
    "JPY": "日圓",
    "USD": "美元"
  },
  "AG_GRID_LOCALE": {
    "Page": "頁",
    "to": "至",
    "of": "共",
    "more": "更多"
  },
  "FinanceStatements": {
    "msg": {
      "EDIT_MSG": "請重新產生對帳單"
    },
    "breadcrumbs": {
      "Home": "首頁",
      "Statements": "財務",
      "ClearSelections": "清除選擇"
    },
    "Statement_Transactions": {
      "Statement Transactions": "對帳單編號",
      "Merchant Account": "商戶帳戶",
      "Merchant Account (English)": "商戶帳戶（英文）",
      "DASMID": "DAS商戶編號",
      "Statement Date": "對帳單日期",
      "Statement Status": "對帳單狀態",
      "Sync": "同步",
      "Is Whitelisted": "是否列入白名單",
      "PopupData": {
        "No Whitelist": "是（白名單）",
        "Yes Whitelist": "否（白名單）",
        "Are you sure?": "是否確定？",
        "Are You Sure you want to disable Whitelist feature": "是否確定要將此交易標記為非白名單？",
        "Are You Sure you want to enable Whitelist feature": "是否確定要將此交易標記為白名單？",
        "Approve": "核准",
        "Close": "關閉"
      }
    },
    "Statement_ColumnDefs": {
      "STATEMENT_ID": "對帳單編號",
      "Date": "對帳單日期",
      "TRANSACTION_START_DATE": "交易開始日期",
      "TRANSACTION_END_DATE": "交易結束日期",
      "DASMID": "DAS商戶編號",
      "Payout_Date": "撥款日期",
      "PaymentType": "付款類型",
      "Acquirer": "收單機構",
      "amount": "總撥款金額",
      "Recon_Status": "對帳狀態",
      "STATUS": "對帳單狀態",
      "Wired_Status": "電匯狀態",
      "action": "操作",
      "ROLLING_RESERVE_HELD": "滾存保留比例",
      "ROLLING_RESERVE_HELD_AMOUNT": "已保留滾存金額",
      "ROLLING_RESERVE_RELEASED": "已釋放滾存金額",
      "CUMULATIVE_RESERVES": "累計保留金額",
      "TransactionDate": "交易日期",
      "OnHoldStatus": "對帳單釋出狀態",
      "FixedDepositHeldYTDAmount": "固定存款保留金額",
      "AdjustmentsAmount": "調整金額",
      "NET_SALES": "淨銷售額",
      "TOTAL_FEES": "總費用",
      "ReleasedDate": "釋出日期",
      "PO_Entity": "PO 實體"
    },
    "Popper_Buttons": {
      "edit": "編輯",
      "view": "查看",
      "download": "下載",
      "settle": "結算",
      "generate": "產生",
      "approve": "核准",
      "download_pdf": "PDF",
      "regenerate": "重新產生",
      "Report": "報表",
      "Select To Download": "選擇下載項目",
      "Multiple Statements on": "多個對帳單",
      "Selection limit reached You can download 25 statements only": "選擇已達上限：最多只能下載25個對帳單"
    },
    "StatusTypes": {
      "PENDING": "待處理",
      "APPROVED": "已核准",
      "RECONCILED": "已對帳",
      "DISCREPANCY": "差異",
      "NOT_PAID": "未付款",
      "PAID_OUT": "已結算－已撥款",
      "CARRY_FORWARD": "結轉",
      "CARRYFORWARDUNAPPROVED": "結轉未核准",
      "ACTIVE": "啟用中",
      "ON_HOLD": "暫停中",
      "SUBMITTED": "已提交",
      "COMPLETED": "已完成",
      "INACTIVE": "停用"
    },
    "tabs": {
      "Account": "對帳",
      "Merchant": "商戶對帳單",
      "MerchantHeading": "商戶對帳單",
      "Holiday": "公眾假期"
    },
    "EditMerchantStatements": {
      "title": "編輯商戶對帳單",
      "Edit_form_Fields": {
        "NET_SALES": "淨銷售額",
        "TOTAL_FEES": "總費用",
        "GROSS": "總結算金額",
        "ROLLING_RESERVE_HELD": "滾存保留比例",
        "ROLLING_RESERVE_HELD_AMOUNT": "已保留滾存金額",
        "ROLLING_RESERVE_RELEASED": "已釋放滾存金額",
        "amount": "總撥款金額",
        "CUMULATIVE_RESERVES": "累計保留金額",
        "TAX_PLACEHOLDERS": "稅務佔位符",
        "ADJUSTMENT": "調整金額",
        "ADJUSTMENT_NOTE": "調整備註",
        "STATUS": "狀態",
        "Wired_Status": "電匯狀態",
        "FixedDepositHeldYTDAmount": "固定存款保留金額",
        "button": {
          "SAVE": "儲存",
          "CANCEL": "取消"
        },
        "helperText": {
          "OptionalMessage": "最多128個字元"
        }
      }
    },
    "ViewMerchantStatements": {
      "title": "商戶對帳單詳情",
      "Statement_Settlement": {
        "LABEL": "結算對帳單",
        "fields": {
          "CLIENT_NAME": "客戶名稱",
          "CLIENT_CODE": "客戶代碼",
          "STATEMENT_ID": "對帳單編號",
          "BillingDescriptor": "帳單描述",
          "Currency": "貨幣",
          "STATEMENT_DATE": "對帳單日期",
          "STATEMENT_PERIOD": "對帳期間",
          "PAYMENT_TRANSFER_DAY": "撥款轉帳日",
          "RESERVES": "保留金"
        }
      },
      "Processing_Summary": {
        "LABEL": "處理摘要",
        "fields": {
          "PURCHASE_CAPTURE": "消費／請款銷售額",
          "REFUND": "退款",
          "CHARGEBACK": "拒付",
          "CHARGEBACK_REVERSAL": "拒付撤銷",
          "REPRESENTMENT": "重新提交申訴",
          "NET_TRANSACTION_AMOUNT": "淨交易金額"
        }
      },
      "FEES": {
        "LABEL": "費用",
        "fields": {
          "Fees": "費用",
          "Count": "數量",
          "Fee": "費用",
          "JPY_Amount": "日圓金額"
        }
      },
      "Settlement_Summary": {
        "LABEL": "結算摘要",
        "fields": {
          "Settlement_Summary_Label": "結算摘要",
          "Date": "",
          "Fee": "",
          "JPY_Amount": "日圓金額"
        }
      },
      "button": {
        "SAVE": "儲存",
        "CLOSE": "關閉"
      }
    },
    "SelectLanguagePopup": {
      "title": "語言選項",
      "heading": "請選擇下載檔案的語言",
      "message": {
        "settlementFailed": "語言變更失敗",
        "settlementSuccess": "語言變更成功"
      },
      "button": {
        "cancel": "取消",
        "submit": "下載"
      }
    },
    "ApprovePopup": {
      "title": "核准",
      "heading": "是否確定？",
      "content": "是否確定要核准所有已選擇的對帳單？此操作無法復原",
      "message": {
        "settlementFailed": "對帳單核准失敗",
        "settlementSuccess": "對帳單已核准"
      },
      "button": {
        "cancel": "取消",
        "submit": "核准"
      }
    },
    "WiredPopup": {
      "content": "是否確定要核准所有已選擇對帳單的電匯狀態？此操作無法復原"
    },
    "confirmPopup": {
      "title": "結算",
      "heading": "是否確定？",
      "content": "是否確定要結算所有已選擇的對帳單？此操作無法復原",
      "message": {
        "settlementFailed": "對帳單結算失敗",
        "settlementSuccess": "對帳單已結算"
      },
      "button": {
        "cancel": "取消",
        "submit": "提交"
      }
    },
    "DownloadconfirmPopup": {
      "title": "下載",
      "heading": "是否確定？",
      "content": "是否確定要下載所有已選擇的對帳單？此操作無法復原",
      "message": {
        "downloadFailed": "下載失敗",
        "downloadSuccess": "下載成功"
      },
      "button": {
        "cancel": "取消",
        "submit": "提交"
      }
    }
  },
  "Holiday": {
    "AddButton": "新增假期／緊急休假",
    "EditButton": "編輯假期／緊急休假",
    "Public Holiday List": "公眾假期清單",
    "InvalidUploadTemplate": "請使用有效範本",
    "InvalidUploadFileType": "請使用有效的檔案格式",
    "UploadFileLable": "上傳假期清單（Excel格式）",
    "UploadBtn": "上傳",
    "CancelBtn": "取消",
    "Uploading": "處理中",
    "UploadFailed": "檔案上傳失敗",
    "Schema": {
      "Name": "名稱",
      "Type": "類型",
      "Date": "日期",
      "Country": "PO實體",
      "SendEmailCheckbox": "發送電子郵件通知"
    },
    "ColumnDefs": {
      "HolidayName": "假期名稱",
      "Type": "類型",
      "Month": "日期",
      "Day": "星期",
      "Country": "PO實體"
    },
    "type": {
      "PublicHoliday": "公眾假期",
      "EmergencyOff": "緊急休假"
    },
    "DeletePopup": {
      "title": "確認刪除",
      "heading": "是否確定？",
      "content": "是否確定要刪除此記錄？此操作無法復原",
      "button": {
        "cancel": "取消",
        "submit": "提交"
      }
    },
    "Button": {
      "Add": "提交",
      "Cancel": "取消"
    }
  },
  "validation": {
    "Required": "必填",
    "MIN_NUMBER_VALUE": "最小輸入金額必須為1",
    "CHARGEBACK_MIN_NUMBER_VALUE": "最小輸入金額必須大於0",
    "TWO_DECIMAL_PLACES": "只允許兩位小數",
    "InvalidStringCharacters": "允許字元：字母、數字、空格，以及 &., '\"()-_/: – $ @ # *",
    "InvalidStringCharactersSQL": "不允許的字元",
    "charMaxLimitMessage": "最多100個字元",
    "NameMaxLimitMessage": "最多128個字元"
  },
  "NO_RECORD_FOUND": "無資料",
  "NO_ROWS_TO_SHOW": "無可顯示資料列",
  "OnBoarding": {
    "VirusScan": {
      "NoVirus": "掃描完成",
      "VirusDetectedFileRemoved": "防毒軟體已移除受感染檔案，請移除檔案識別碼後重新上傳",
      "VirusDetectedFileRemoved_1": "防毒軟體已移除受感染檔案，請上傳新檔案",
      "VirusScanInProg": "防毒掃描進行中"
    },
    "welcomeContent": {
      "Welcome": "歡迎使用 Payment Options", // Welcome to Payment Options
      "details": "歡迎註冊！在您開始使用本平台前，請先填寫以下帳戶資料。",
      // Before you enjoy our platform, we would need your details for your account.
    
      "Business": "商戶資料", // Business Information
      "Business_details": "請提供關鍵公司資料，以便我們為您配置最合適的帳戶設定。",
      // We need some key information on your business to prescribe you with the correct setup.
    
      "Stakeholder": "持份者資料", // Stakeholder Information
      "Stake_details": "我們需要收集您的主要持份者資料（KYC）。", 
      // We'll need to get to know your stakeholders (KYC).
    
      "Payment": "付款或結算", // Payment or Settlement
      "Payment_details": "請告知我們貴司的收益款項應匯入哪個結算帳戶。", 
      // We need to know where to send your business proceeds.
    
      "detail_second": "需要更多時間填寫嗎？", 
      // Need more time in filling up the form?
    
      "first_description": "別擔心！您可以隨時返回此處，繼續上次未完成的步驟。請確保在進入最終提交環節前，已完成所有分頁的必填欄位。", 
      // No worries! You can get back on where you left off and continue from there. Just ensure that you complete all the fields on the tabs before you proceed to the completion.
    
      "second_description": "我們將全程為您追蹤填寫進度。", 
      // We’ll help you track your progress along the way.
    
      "arrow_description_left": "尚待填寫欄位", 
      // Fields left for you to answer
    
      "arrow_description_right": "需要更多時間填寫嗎？", 
      // Need more time in filling up the form?
    
      "Buttons": {
        "Next": "下一步", // Next
        "Start": "立即開始", // Get Started Now
      },
    },
    "SideNav": {
      "Complete": "完成您的註冊",
      "Your_registration": "",
      "fill_out_required_fields": "請透過以下區塊填寫所有必填欄位",
      "through_the_following_section": "",
      "Sales_Heading": "商戶註冊"
    },
    ChooseAccount: {
      // label: 'Choose an Account',
      // type: 'What type of account you want to create?',
      "Merchant_label": {
        "first_title": "我是",
        // second_title: 'I’m a Merchant',
      },
      "Partner_label": {
        "first_title": "我是",
        // second_title: 'I’m a Partner',
      },
    },
    "BreadCrumbs": {
      "MerchantTitle": "商戶註冊",
      "SalesTitle": "申請審核",
      "ResellerTitle": "合作夥伴註冊",
    },
    "Prompt_Message": {
      "IfSubmittedTrue": "您的註冊已完成，資料正在審核中，可能需約5–8個工作天",
      "IfSubmittedFalse": "您的註冊尚未完成，請點擊連結繼續並提交申請",
      "MissingInfoMessage": "您收到補件要求，請點擊連結提供所需資料",
      "TCDisagreed_1": "您已拒絕該申請，該申請及存取權限將於",
      "TCDisagreed_2": "天內移除",
      "TCDisagreed_3": "您已不同意條款，您的申請流程將於當天結束前永久移除",
      "requiredUBO": "請至少標記一位利益相關者為最終受益人（UBO）",
      "primaryContact": "請完成主要利益相關者的資料",
      "SolePercentage": "獨資經營者的持股比例應為100%",
      "SolePercenatgeErrorMsg": "獨資經營者的持股比例請設定為100%",
      "requiredAuthorizedSignatory": "請至少標記一位利益相關者為授權簽署人",
      "Please_Click_On-Edit_Primary_Stakeholder": "請點擊編輯按鈕以完成主要利益相關者資料",
      "Buttons": {
        "ClickHere": "點擊此處"
      },
      "deletePreviouslyUploadedFile": {
        "title": "需更新文件！",
        "heading": "更改此選項需要您上傳對應的文件。請確保您上傳的文件與所選類型一致。",
        "ok": "確定"
      },
    },
    "OTP_MODAL": {
      "TITLE": "請輸入OTP以驗證您的帳戶",
      "DESCRIPTION": "請檢查您的電子郵件帳戶以取得我們剛發送的驗證碼，並在下方欄位輸入該驗證碼",
      "VERIFY": "驗證",
      "RESEND_OTP": "重新發送OTP",
      "VERIFIED": "已驗證",
      "DIDNT_RECIEVED": "尚未收到驗證碼？",
      "OTP": "OTP驗證碼"
    },
    "Password_requirements": {
      "heading": "密碼要求",
      "pass_one": "一個小寫字母",
      "pass_two": "一個數字",
      "pass_three": "一個大寫字母",
      "pass_four": "一個特殊字元",
      "pass_five": "支援的特殊字元"
    },
    "ABOUT_BUSSINESS": {
      "About_Business": "關於您的業務", // About your Business
      "Business_Location": "公司所在地", // Business Location
      "Business_Name": "公司名稱", // Company Name
      "Name": "全名", // Full Name
      "Select_Date": "選擇日期", // Select date
      "Doing_Business": "商店／品牌名稱", // Store/Brand Name
      "Unique_Entity_Number": "公司註冊編號", // Registration Number
      "Monthly_Revenue": "每月收入", // Monthly Revenue
      "BusinessLicense": "您的企業是否需要營業牌照？", // Does your business require a license to operate?
      "MailingAddress": "是否有不同的通訊地址？", // Different Mailing Address?
      "MainMailingAddress": "地址", // Address
      "Registered_Address": "公司註冊地址", // Registered Address
      "AddressLine1": "地址第一行", // Address Line 1
      "AddressLine2": "地址第二行", // Address Line 2
      "Postcode": "郵遞區號", // Postcode
      "City": "城市", // City
      "Country": "國家", // Country
      "IncorporationDate": "公司成立日期", // Incorporation Date
      "Company_Type": "公司類型", // Company Type
      "Company_Type_Other": "公司類型（其他）", // Company Type (Other)
      "NEXT": "下一步", // NEXT

      "UploadDocuments": "公司註冊文件／公司註冊證明", 
      // Company Registration Document / Certificate of Incorporation

      "UploadDocuments_Required": "公司註冊文件／公司註冊證明／股東名冊／地址證明為必填項", 
      // Company Registration Document / Certificate of Incorporation / Share Register / Proof of Address is required

      "DocumentTypeShareRegister": "股東名冊", // Share Register

      "Right_Panel_Text": "請注意，在最後一步您需要上傳公司註冊證書或公司組織文件，請提前準備好這些文件。您也可以稍後返回繼續完成註冊。",
      // Please note that you will be prompt at the last step to upload your Company Registration Certificate or Organisational Documentation...

      "ToolTip_Text": "指貴公司註冊證書上的營業名稱。", 
      // Refers to the trading name of your Company Registration Certificate.

      "JP_Business_Name": "商戶帳戶（英文）", // Merchant Account (English)
      "Stock_Code": "股票代碼", // Stock Code
      "noOfEmployees": "員工人數", // Number of Employees
      "DocumentUpload": "文件上傳", // Document Upload

      "BusinessTooltips": {
        "Registered_Address": "不接受郵政信箱（PO Box）", // PO Box is not acceptable
        "This amount represents the fee for each individual transaction": "此金額表示每筆交易的手續費"
        // This amount represents the fee for each individual transaction
      },
      "Business_Name_Messages": {
        "Name": "與身份證明文件相符的全名", // Full Name as per ID
      },

      "POSTCODE_MESSAGES": {
        "Merchant_Min_Value": "請輸入有效的 7 位數郵遞區號。", // Please enter a valid postal code with 7 digits.
        "Merchant_Max_Value": "請輸入有效的 7 位數郵遞區號。", // Please enter a valid postal code with 7 digits.
        "Partner_Min_Value": "請輸入至少 2 位數的有效郵遞區號。", // Please enter a valid postal code with minimum 2 digits.
        "Partner_Max_Value": "請輸入最多 10 位數的有效郵遞區號。" // Please enter a valid postal code with maximum 10 digits.
      },

      "COMPANY_TYPES": {
        "Company": "有限公司", // Company Limited
        "Liability": "有限責任公司（LLC）", // Limited Liability Company (LLC)
        "Partnership": "合夥企業", // Partnership
        "Limited": "有限合夥企業", // Limited Partnership
        "NonProfit": "特定非營利法人", // Specified Non-profit Corporation
        "IncorporatedAssociation": "一般社團法人", // General Incorporated Association
        "IncorporatedFoundation": "一般財團法人", // General Incorporated Foundation
        "Sole": "個人獨資企業" // Sole Proprietor
      },
      "CorporateWebsite": "公司網站／社交媒體"
    },
    "SUPPORTED_COUNTRY": {
      "SupportedCountries": "關於您的業務",
      "BANNER_SUBTITLE": "不支援的國家！",
      "FIRST_PARAGRAPH": "很抱歉，我們的服務尚未在您的國家提供。",
      "MIDDLE_PARAGRAPH": "如果您準備將業務提升到下一個階段，請與我們聯繫，以尋找合適的支付解決方案，或在我們於您的業務所在地提供服務時獲得通知！",
      "SECOND_PARAGRAPH": "同時，您可以從以下清單中選擇其他地區：",
      "SPEAKTOUS": "聯絡我們",
      "LOCATEUS": "或在世界其他地區找到我們",
      "BUTTON": "繼續註冊",
      "Business_Location": "DASGATEWAY 目前支援"
    },
    "CREATE_ACCOUNT": {
      "LEFT_SUBTITLE": "提交您的業務資料並取得商戶帳戶，以開始接收付款",
      "RESELLER_SUBTITLE": "提交您的資料並取得轉售商帳戶，以開始獲取佣金",
      // Create_Your: 'Create your',
      // Merchant_Account: 'Merchant Account',
      // Last_Step: 'You’re on the last step of registration!',
      // Set_Password: 'Set your account’s password.',
      // Complete_all_required_fields: 'Complete all required fields',
      //  First_Name: 'First Name',
      "Middle_Name": "中間名",
      // Last_Name: 'Last Name',
      "Phone_Number": "電話號碼",
      // Business_Location: 'Business Location',
      // Email_Address: 'Email Address',
      // Verify: 'Verify',
      "Verified": "已驗證",
      "Create_Password": "建立密碼",
      "Confirm_Password": "確認密碼",
      // I_agree_with_all: 'I agree with the',
      // 'terms_&_conditions': 'Terms and Conditions',
      // privacy_policy: 'Privacy Policy',
      // and: 'and',
      "CREATE_ACCOUNT": "建立帳戶",
      "Or_Sign_Up_with_your_social_media_account": "或使用您的社群媒體帳戶註冊",
      // 'already-registered': 'Already have an account?',
      // 'signin-account': 'Sign In',
      "CreateAccountTooltips": {
        "Name": "請確保姓名以羅馬拼音填寫，並與您的身份證或護照一致"
      },
      ValidationMessages: {
        // Please input your first name
        "Please input your first name": "請輸入您的名字",

        // Invalid first name
        "Invalid first name": "名字無效",

        // Please input your last name
        "Please input your last name": "請輸入您的姓氏",

        // Invalid last name
        "Invalid last name": "姓氏無效",

        // Please select country code
        "Please select country Code": "請選擇國家代碼",

        // Please input your phone number
        "Please input your phone number": "請輸入您的電話號碼",

        // Invalid phone number
        "Invalid phone number": "電話號碼無效",

        // Please input your business location
        "Please input your business location": "請輸入您的商業所在地",

        // Please input your email
        "Please input your email": "請輸入您的電子郵件",

        // Please input your password
        "Please input your password": "請輸入您的密碼",

        // Please confirm your password!
        "Please confirm your password!": "請確認您的密碼！",

        // The new password that you entered do not match!
        "The new password that you entered do not match!": "您輸入的新密碼不一致！",

        // Password is too short - should be 14 characters minimum.
        "Password is too short - should be 14 characters minimum.": "密碼過短，至少需要14個字元。",

        // Your password cannot be the same as your username or admin
        "Your password cannot be the same as your username or admin": "您的密碼不能與您的用戶名或 admin 相同",

        // Your password must include at least one number, one special character, one uppercase letter, and one lowercase letter.
        "Your password must include at least one number, one special character, one uppercase letter, and one lowercase letter.": "您的密碼必須至少包含一個數字、一個特殊字元、一個大寫字母和一個小寫字母。",

        // You must accept the terms and privacy policy to register your account.
        "You must accept the terms and privacy policy to register your account": "您必須接受服務條款及私隱政策才能註冊您的帳戶"
      }
    },
    "PAYMENT_METHODS": {
      "Payment_Methods": "付款方法",
      "Choose_payment_acceptance": "選擇收款方式",
      "Settlement_Currency": "結算貨幣",
      "Settlement_Currency_Required": "結算貨幣為必填欄位",
      "Scheme": "卡組織",
      "SchemeLabel": "付款方法",
      "Cards": "支付卡",
      "Processing_Currency": "交易處理幣種",
      "Processing_Website": "交易處理網站",
      "Processing_Website_required": "網站欄位為必填項目",
      "Processing_Website_invalid": "無效的網站",
      "Option": {
        "3DSecure": "3D安全驗證",
        "NON3DSecure": "非3D安全驗證",
        "Recurring": "週期性扣款"
      },
      "TypeOfIntegration": "整合類型",
      "DescribeTheProducts": 
        "請描述您所銷售的產品或提供的服務",
      "Countries": "主要交易來源國家",
      "countriesOptions": {
        "Japan": "日本",
        "Singapore": "新加坡"
      },
      "Average_Transaction_Amount": "單筆平均交易金額",
      "Maximum_Transaction_Amount": "單筆最高交易金額",
      "Total_Annual_Projection": "年度總交易預估量",
      "is_Store_Customer_Info": 
        "您是否儲存客戶的信用卡資訊？",
      "hasTechnologicalArchitecture": 
        "您的技術架構是否符合支付卡產業資料安全標準（PCI DSS）？",
      "is_Process_Card_trans": "您是否曾處理卡片交易？",
      "Refund_Rate": "退款率",
      "Average_Refund": "平均退款",
      "Chargeback_Rate": "拒付率",
      "Average_Chargeback": "平均拒付",
      "HPP": "託管支付頁面",
      "SERVER_API": "伺服器 API",
      "PAYMENT_LINK": "付款鏈結",
      "RECURRING": "定期付款",
      "QR_CODE": "QR 碼",
      "SUBSCRIPTION": "訂閱付款",
      "isRecurringText": 
        "您的業務是否接受週期性或訂閱模式？",
      "DECIMAL_ERROR": "請輸入不含小數點的數字",
      "Refund_Rate_MAX_VALIDATOR": 
        "退款率應小於或等於100%",
      "Refund_Rate_MIN_VALIDATOR": "退款率應大於0.01%",
      "Chargeback_Rate_MAX_VALIDATOR": 
        "拒付率應小於或等於100%",
      "Chargeback_Rate_MIN_VALIDATOR": "拒付率應大於0.01%",
      "Chargeback_Rate_REQUIRED": "退款率為必填項目",
      "Refund_Rate_REQUIRED": "退款率為必填項目",
      "Average_Refund_REQUIRED": "平均退款為必填項目",
      "Average_Refund_MIN_VALIDATOR": "平均退款應大於1",
      "Average_Chargeback_REQUIRED": "平均拒付為必填項目",
      "Average_Chargeback_MIN_VALIDATOR": "平均拒付應大於1",
      "Average_Transaction_Required": "平均交易金額為必填項目",
      "Maximum_Transaction_Amount_Required": 
        "最大交易金額為必填項目",
      "Total_Annual_Projection_Required": "年度總預估金額為必填項目",
      "Average_Transaction_MIN": "平均交易金額應大於1",
      "Maximum_Transaction_Amount_MIN": 
        "最大交易金額應大於1",
      "Total_Annual_Projection_MIN": "年度總預估金額應大於1",
      "Days": "天數",
      "ID_Of_The_Individual": 
        "有效護照／MyNumber身分證／駕照／健康保險證",
      "Proof_Of_Address": 
        "銀行對帳單／水電費帳單／租賃合約（最近3個月內）"
    },
    "PAYOUT_DETAILS": {
      "Payout_Details": "結算資料",
      "Add_New_Payout_Details": "新增結算資料",
      "Edit_Payout_Details": "編輯結算資料",
      "View_Payout_Details": "查看結算資料",
      "Account_Number": {
        "label": "銀行帳號",
        "tooltip": "請上傳一份最近三個月內簽發的銀行月結單副本"
      },
      "Settlement_Currency": "結算貨幣",
      "Bank_Country": {
        "Country_of_Bank": "銀行所在國家",
        "option": {
          "Japan": "本地銀行帳戶",
          "Singapore": "新加坡",
          "International": "國際銀行帳戶"
        }
      },
      "Bank_Name": "銀行名稱",
      "Branch_Code": "分行代碼",
      "Bank_Code": "銀行代碼",
      "Bank_Account_Name": "銀行帳戶名稱",
      "Swift_Code": "SWIFT 代碼",
      "How-often_to_paid": {
        "label": "結算頻率",
        "option": {
          "Daily": "每日",
          "Bi-Weekly": "每兩週",
          "Weekly": "每週",
          "Monthly": "每月"
        }
      },
      "How-often_to_paid_helper_text": "最低結算金額：JPY 40,000",
      "How-often_to_paid_helper_text_for_hkd": "最低結算金額：HKD 1,500",
      "Min-settlement-amount": "最低結算金額：JPY 10,000",
      "UploadDocuments": "請上傳最近一個月的銀行月結單或帳戶結算單（需為近三個月內文件）",
      "IBAN": "IBAN",
      "UploadDocuments_Message": "需要上傳銀行月結單",
      "AccountType": "帳戶類型",
      "Account_Type": {
        "Normal": "普通帳戶",
        "Current": "往來帳戶",
        "Savings": "儲蓄帳戶",
        "Others": "其他"
      }
    },
    "EXTRA_DOCUMENTS": {
      "heading": "缺少資訊",
      "Upload_more_documents": "上傳更多文件",
      "Upload_Documents_heading": "文件／證書",
      "Upload_Missing_Info": "上傳缺失資訊",
      "Request": "請求",
      "fileDownloadOptions": "文件下載",
      "No_Data_Found": "無資料"
    },
    "ENTITIES": {
      "Entities": "實體",
      "Payment_Options_Entities": "Payment Options 實體",
      "Please_Select_Merchant_Entities": "請選擇您的商戶實體"
    },
    "REGISTRATION_COMPLETED": {
      "REGISTRATION_COMPLETED": "註冊完成",
      "FIRST_PARAGRAPH": "感謝您提交申請，我們將在未來5–8個工作天內透過電子郵件通知您審核結果。",
      "SECOND_PARAGRAPH": "如果您需要進一步協助，歡迎透過以下管道與我們聯繫：",
      "Shibuya_Office": "Shibuya Office",
      "Address": "Address:",
      "Dogenzaka_Address": "Dogenzaka 225 Bldg. 1F/2F, 2-23-14 Dogenzaka, Shibuya-ku, Tokyo",
      "Email": "電子郵件地址：",
      "Opening_Time": "營業時間：",
      "Opening_Days_And_Time": "星期一至星期五 10am 至 7pm",
      "Explore_As_Test_Mode": "在此期間，歡迎您先以測試模式探索我們的支付網關"
    },
    "REGISTRATION_COMPLETED_RESELLER": {
      "REGISTRATION_COMPLETED": "註冊完成",
      "THANK_REGISTRATION_WITH_US": "感謝您的註冊",
      "FIRST_PARAGRAPH": "我們將審核您的資料，約需5–8個工作天",
      "MIDDLE_PARAGRAPH": "如需進一步釐清您的KYC申請，我們將透過電子郵件通知您",
      "LAST_PARAGRAPH": "在此期間，歡迎您先以測試模式探索我們的支付網關"
    },
    "STAKEHOLDERS_INFO": {
      "About_your_Stakeholders": "關於您的持份者",
      "Add_New_Payout": "新增結算資料",
      "columnDefs": {
        "Action": "操作",
        "First_Name": "名字",
        "Middle_Name": "中間名",
        "Last_Name": "姓氏",
        "Nationality": "國籍",
        "UBO": "持股比例 %",
        "Auth_Signatory": "授權簽署人",
        "KYC_Status": "eKYC 狀態",
        "Applicant_Status": "狀態"
      },
      "ISAUTHORIZED_YES": "是",
      "NA": "不適用"
    },
    "UPLOAD_DOCUMENTS": {
      "Upload_Documents": "最後步驟",
      "VirusScanIssues_text_1": "您的文件正在進行病毒掃描，請稍候…",
      "VirusScanIssues_text_2": "發現部分文件含有病毒，請移除後重新上傳",
      "Company_Registration_Certificate": "公司註冊文件／公司成立證明",
      "No_order_doc": "請上傳不超過六個月內的文件",
      "Drop_File_to_Upload": "拖曳文件至此上傳 或",
      "ID": "身分證明文件：有效護照／MyNumber身分證／駕駛執照／健康保險證",
      "Bank_Statement": "最近銀行對帳單或帳戶明細（不超過3個月）",
      "Confirmation_Dialog": "我確認所提供的所有資訊皆為真實且正確。提交後將無法再修改您的註冊資料。如需提交後變更，請聯絡我們的。",
      "Support_Team": "支援團隊",
      "button": {
        "SUBMIT": "提交"
      },
      "Identification_Document": "需提供身分證明文件",
      "TERMS_CONDITION": "我同意條款與條件",
      "Hooray": "太好了！您已完成註冊的最後一步！",
      "Neccessary": "哎呀！您尚未填寫所有必要資訊",
      "Neccessary_text": "請確保所有必填欄位已完成後再進入此頁面。您可以依照各分頁上的提示標記來查看尚未填寫的欄位。謝謝！",
      "TERMS_CONDITION_DESCRIPTION": "透過提交本申請，商戶及其代表聲明並保證其向 PAYMENT OPTIONS 所提供的資料均屬真實且正確，並同意下列聲明條款。\n進一步確認並同意，將交易憑證傳送至 PAYMENT OPTIONS，即視為客戶已接受並同意服務條款。\n由客戶代表提交本申請，或向本公司傳送交易憑證或任何交易證明文件，即表示客戶已接受並同意本協議條款。\n本協議包括本申請文件、服務條款及操作指南。\n客戶同意遵守本申請、服務條款、操作指南，以及所有適用法律、規則與規範（包括各卡組織之規定），並明白如未遵守可能導致服務終止。\n本申請中未特別定義之詞彙，均依服務條款之定義為準。",
      "TERMS_CONDITION_DESCRIPTION_RESELLER": "透過提交本申請，第三方及其代表聲明並保證其向 PAYMENT OPTIONS 提供的資訊均屬真實且正確，並同意以下聲明條款。\n同時確認並同意，將交易憑證傳送至 PAYMENT OPTIONS，即視為客戶已接受並同意服務條款。\n客戶代表提交本申請，或向我們傳送交易憑證或任何交易證明，即表示客戶已接受並同意本協議條款。\n本協議包含本申請文件、服務條款及操作指南。\n客戶同意遵守本申請、服務條款、操作指南，以及所有適用法律、規則與規範（包括各卡組織規則），並了解若違反規定可能導致服務終止。\n本申請中未特別定義之詞彙，均以服務條款為準。",
      "Attestation": "確認書",
      "Attestation_Description": "我／我們已閱讀、理解並同意受本協議約束。本協議（及其不時修訂內容）適用於Payment Options同意向我／我們提供之轉售服務。\n我／我們保證：\n本申請表及任何補充資料中所提供的資訊均為真實、準確及完整。\n我／我們為該業務／公司的擁有人或授權代表，並擁有就本申請作出最終決策之權限。\n我／我們知悉Payment Options有權自行決定拒絕本申請，且無需提供任何理由，亦不承擔任何責任。\n我／我們的業務／公司已於［］完成註冊，並已取得所有必要之營業執照及許可，以銷售或推廣相關服務及／或商品。\n由第三方代表提交本申請，即表示第三方已接受並同意本協議條款，包括本申請、服務條款及相關文件。\n第三方同意遵守本申請、服務條款及所有適用法律、規則與規範（包括卡組織規則），並理解違規可能導致服務終止。\n本申請中未特別定義之詞語，其含義以協議為準。\n我以授權簽署人身份代表第三方提交此申請。",
      "AGREE_LABEL": "選擇「我同意」即表示您同意上述條款與條件。",
      "I_AGREE": "我同意",
      "I_DISAGREE": "我不同意",
      "Merchant-Attestation": "我／我們已閱讀、理解並同意受《服務條款》（以及任何附帶之操作指南或與本申請相關之文件，以下統稱「協議」）約束。\n本協議（及其不時修訂內容）適用於申請之服務，並適用於PAYMENT OPTIONS不時同意向我／我們提供之服務。",
      "Merchant_termsData": {
        "TextA": "我／我們在本申請表及任何與服務提供或業務狀態相關之補充資料中所提供的所有資訊，均屬真實、準確且完整。",
        "TextB": "我／我們為本業務／公司的擁有人或授權代表，並擁有就本申請 PAYMENT OPTIONS 商戶接入計劃作出最終決策之權限。",
        "TextC": "我／我們確認 PAYMENT OPTIONS 保留其絕對酌情權，可在不承擔任何責任及無需提供任何理由的情況下拒絕本申請。",
        "TextD": "我／我們的業務／公司已於＿＿（國家／地區）註冊",
        "TextDD": "",
        "TextE": "並已取得所有必要的執照及許可，以銷售或推廣所提供之服務及／或商品"
      },
      "Merchant_ApplicationSubmissitionText": "由客戶代表向 PAYMENT OPTIONS 提交本申請，或向 PAYMENT OPTIONS 傳送交易憑證或任何交易證明，即構成客戶已接受並同意本協議之條款與條件。\n本協議包括本申請文件、《服務條款》（TOS）、操作指南及相關文件。\n客戶同意遵守本申請、TOS、操作指南及所有適用法律、規則與規範（包括各卡組織規則），並明白若未遵守可能導致支付處理服務被終止。\n本申請中未特別定義之詞語，其含義以TOS為準。",
      "Merchant_behalf": "我以授權簽署人身份代表商戶提交此申請",
      "Partner-Attestation": "我／我們已閱讀、理解並同意受本協議約束。本協議（及其不時修訂內容）適用於轉售服務，而Payment Options將不時向我／我們提供相關服務。",
      "Partner_termsData": {
        "TextA": "我／我們在本申請表及任何與服務提供或業務狀態相關之補充資料中所提供的所有資訊，均屬真實、準確且完整。",
        "TextB": "我／我們為本業務／公司的擁有人或授權代表，並擁有就本申請Payment Options轉售商計劃作出最終決策之權限。",
        "TextC": "我／我們確認Payment Options保留其絕對酌情權，可在不承擔任何責任及無需提供任何理由的情況下拒絕本申請。",
        "TextD": "我／我們的業務／公司註冊於",
        "TextDD": "",
        "TextE": "並已取得所有必要的執照及許可，以銷售或推廣所提供之服務及／或商品。"
      },
      "Partner_ApplicationSubmissitionText": "由第三方代表向 Payment Options 提交本申請，即構成第三方已接受並同意本協議所載之條款與條件。本協議包括本申請文件、《Terms of Service》及相關資料。第三方同意遵守本申請、Terms of Service 以及所有適用法律、規則與規範（包括卡組織規則），並明白若未遵守可能導致服務終止。本申請中未特別定義之詞語，其含義以本協議為準。",
      "Partner_behalf": "我以授權簽署人身份代表第三方提交此申請。",
      "Confirmation_Dialog_Content": {
        "title": "確認刪除",
        "heading": "是否確定？",
        "content": "若您不同意條款，您的申請將在七（7）天內被排程刪除且無法恢復。在此期間，您可取消刪除並返回完成申請，而不會遺失申請資料及登入資訊。您確定要刪除此申請嗎？",
        "button": {
          "submit": "確認",
          "cancel": "取消"
        }
      }
    },
    "ADD_NEW_STAKEHOLDER": {
      "Add_New_StakeHolder": "新增持份者",
      "Delete_Stakeholder": "刪除持份者",
      "EDIT_StakeHolder": "編輯持份者",
      "Select_Date": "選擇日期",
      "StakeHolder_Info": "查看持份者",
      "First_Name": "名字",
      "Last_Name": "姓氏",
      "DOB": "出生日期",
      "Nationality": "國籍",
      "PhoneNumber": "電話號碼",
      "ID_Number": "證件號碼",
      "ID_Type": "證件類型",
      "Job_Title": "職位",
      "Rigth_to_Sign_Doc": "此人為授權簽署人",
      "Ultimate_Beneficiary_Owner": "此人為最終實益擁有人",
      "A_Sole_Proprietor": "此人為個人獨資經營者",
      "Percentage_in_Ownership": "持股比例",
      "Percentage_in_Ownership_Validate": "持股比例為必填欄位",
      "overallPercentage": "總持股比例不能超過 100",
      "Percentage_in_Ownership_NUM": "請輸入 25 至 100 之間的數字",
      "Country_of_Residence": "居住國家",
      "Postcode": "郵遞區號",
      "City": "城市",
      "Address": "地址",
      "Update_KYC": "更新 KYC",
      "button": {
        "SUBMIT": "提交",
        "CANCEL": "取消"
      },
      "tooltip_title": "請上傳身份證明文件照片，以便我們驗證每位持份者的身份。",
      "Percentage_in_Ownership_MAX_VALIDATOR": "持股比例不能超過 100%",
      "Percentage_in_Ownership_MIN_VALIDATOR": "持股比例必須大於 25%",
      "CHECKBOX_ERROR": "必須至少選擇最終實益擁有人或授權簽署人。",
      "Stakeholder_Tooltips": {
        "Name": "名字",
        "Surname": "姓氏",
        "Ultimate_Beneficiary_Owner": "持有該公司超過百分之二十五投票權／股份之自然人。",
        "Auth_Signatory": "由公司依法授權代表公司簽署及執行交易的自然人。",
        "Registered_Address": "不接受郵政信箱（PO Box）"
      },
      "EmptyEmailErrorMsg": "請輸入您的電郵！",
      "validEmailErrorMsg": "輸入的電郵地址無效！",
      "expiryDate": "有效期限",
      "issuedDate": "簽發日期",
      "IDTYPES": {
        "Passport": "護照",
        "NationalID": "身份證",
        "MyNumberCard": "My Number 卡",
        "DriverLicense": "駕駛執照",
        "InsuranceCard": "保險卡",
        "ResidenceCard": "在留卡"
      }
    },
    "RegistrationComplete": {
      "EXPLORE_THE_GATEWAY": "探索支付網關"
    },
    "API_ERROR_MESSAGE": "請重試…",
    "FILE_UPLOAD_TEXT": "拖曳文件至此上傳 或",
    "BROWSE": "瀏覽檔案",
    "IS_REQUIRED": "是必需的",
    "ResellerOnboarding": {
      "COMPANY_PROFILE": {
        "Company_Profile": "業務資訊",
        "Doing_Business_As_Name": "營業名稱（DBA）",
        "Company_Registration_Number": "公司註冊編號",
        "Company_Registration_Number_sole": "公司註冊編號（如不適用請填NA）",
        "Country_Company_Incorporated": "公司註冊所在國家",
        "Settlement_currency": "貨幣",
        "Country_Business_Operations": "業務營運所在國家",
        "Country_Payment_Options_Business_Operations": "推薦 PAYMENT OPTIONS 產品的國家",
        "Company_Type": "公司類型",
        "Corporate_Website": "公司網站",
        "No_Of_Employees": "員工人數",
        "Business_Industry": "核心業務產業／核心業務性質",
        "Type_ThirdParty": "第三方類型",
        "Other_Third_Party": "其他（第三方類型）",
        "Type_ThirdPary": "第三方類型",
        "Other_Business_Industry": "其他（業務產業）",
        "MailingAddress": "您的業務是否需要監管牌照才能營運？",
        "MainMailingAddress": "註冊地址",
        "doingBusinessDBA": "營業名稱（DBA）地址",
        "RegistrationAddressTooltip": "不接受郵政信箱（PO Box）地址",
        "BusinessAsDBA": "若「DBA地址」與註冊地址不同，請填寫總公司實體地址（包含郵遞區號）。不接受郵政信箱（PO Box）",
        "SameAsRegistration": "與註冊地址相同",
        "PostCode": "郵遞區號",
        "City": "城市"
      },
      "STAKEHOLDERS_INFO": {
        "Stakeholders_Info": "利益相關者資料",
        "BusinessRepresentativeInfo": "商業代表資料",
        "BusinessRepresentativeInfoToolTip": "商業代表可以是控制性董事或授權簽署人。控制性董事是指對公司管理或營運具有重大責任的個人，包括由公司委任負責日常事務管理的執行董事或高級管理人員。授權簽署人是指由公司透過董事會決議或由控制性董事簽署授權書所委任，代表公司簽署及執行交易的人士。",
        "controllingPerson": "控制人／企業擁有人／股東／最終受益人資料",
        "controllingPersonTooltip": "最終受益人（UBO）必須為自然人（上市公司除外）。請列出持股達25%及以上的UBO。若無任何人持股超過25%，請列出持股比例最高的前三位UBO。",
        "Contact_Number": "聯絡電話",
        "Email_Address": "電子郵件地址",
        "Name": "姓名",
        "Registration_Address_Proof": "授權簽署人簽署權證明（授權書或公司董事會決議）",
        "UltimateBeneficialOwner": "最終受益人（UBO）",
        "IndividualShareholder": "個人股東",
        "CorporateShareholder": "公司股東",
        "AuthorisedRepresentative": "授權代表",
        "ControllingDirector": "控制性董事",
        "Position": "職位",
        "columnDefs": {
          "Name": "姓名",
          "Position": "職位",
          "ShareholdingPercent": "持股比例（%）"
        },
        "ADD_NEW_STAKEHOLDER": {
          "Name": "姓名",
          "Ultimate_Beneficiary_Owner": "是否為最終受益人？",
          "Individual_Shareholder": "個人股東",
          "Corporate_Shareholder": "公司股東",
          "GovtID": "政府簽發的有效身份證明文件（適用於授權簽署人、董事、控制人，以及持股超過25%的股東／最終受益人）",
          "Registry_Verification": "股權登記資料（用於最終受益權驗證）",
          "Proof_Of_Address": "Proof of Address (if not noted on the government issued ID) for Shareholder/Ultimate Beneficial Owners over 25% - Proof of address can take the form of a utility bill or blank statement issued in the last three (3) months, or a local tax authority or national revenue department bill issued within the last twelve (12) months, or a government issued benefits statement."
        }
      },
      "BUSINESS_INFO": {
        "Business_Info": "商業資訊",
        "Heading": "是否儲存客戶信用卡資料？",
        "SubHeading": "您的技術架構是否符合支付卡產業資料安全標準（PCI DSS）？",
        "Yes": "是的",
        "No": "非也。"
      },
      "PAYOUT_SETTLEMENT_INFORMTION": {
        "Payout_Settlement_Information": "撥款／結算資訊",
        "Currency": "貨幣",
        "HKD": "港幣（HKD）",
        "MYR": "馬來西亞令吉（MYR）",
        "PHP": "菲律賓披索（PHP）",
        "THB": "泰銖（THB）",
        "JPY": "日圓（JPY）",
        "BankName": "銀行名稱",
        "Bank_Identification_Code": "銀行識別代碼（分行代碼）",
        "Bank_Account_Name": "銀行帳戶名稱",
        "Bank_Account_Number": "銀行帳戶號碼",
        "Settlement_Doc_Upload": "結算銀行帳戶副本",
        "Settlement_Doc_Upload_Msg": "銀行帳戶文件需為最近3個月內發出，並至少包含帳戶持有人姓名、地址、帳號及日期"
      },
      "UPLOAD_DOCUMENTS": {
        "Upload_Documents": "最後一步",
        "mailingAddressUploadDocuments": "商業／監管牌照副本（如業務需要以進行或開始營運）",
        "mailingAddressUploadDocumentsRequired": "商業／監管牌照副本（如業務需要以進行或開始營運）為必填",
        "certificateOfIncorporation": "公司註冊證明書、商業登記證／登記摘錄、週年申報表或由政府機構發出的同等文件",
        "AuthorisedSignatoryName": "授權簽署人姓名",
        "AuthorisedSignatoryChecked": "我以授權簽署人身份代表第三方提交此申請",
        "Position": "職位",
        "Signature": "簽名",
        "Date": "日期",
        "Browse": "瀏覽",
        "NotificationOfCommencement": "個人事業開業通知",
        "ConfirmationOfTaxDeclaration": "稅務申報收據確認／藍色申報登記／個人獨資登記受理證明",
        "SolePropPDF_first": "稅務局－開業申報.pdf",
        "SolePropPDF_Second": "稅務局－藍色申報.pdf",
        "AllFOrmats": "支援所有檔案格式",
        "Doc_required": "文件為必填",
        "NNC": "NNC1（成立未滿1年的公司）",
        "NAR": "NAR1（成立超過1年的公司）"
      },
      "ENTITIES": {
        "Entities": "實體"
      },
      "ResellerCompanyType": {
        "default": {
          "SOLE": "獨資經營者／個體商戶",
          "PARTNER": "合夥企業",
          "PUBLIC": "公開有限公司",
          "PRIVATE": "私人有限公司",
          "STOCK": "上市公司",
          "INDIVIDUAL": "個人",
          "OTHER": "其他"
        },
        "JP": {
          "SOLE": "獨資經營者／個體商戶",
          "PRIVATE": "私人有限公司",
          "GODOKAISHA": "合同會社（Godo Kaisha）",
          "INDIVIDUAL": "個人",
          "OTHER": "其他"
        },
        "Malaysia": {
          "SOLE": "獨資經營者／個體商戶",
          "PARTNER": "合夥企業",
          "PUBLIC": "公開有限公司（BDH）",
          "PRIVATE": "私人有限公司（SDN BDH）",
          "INDIVIDUAL": "個人",
          "OTHER": "其他"
        }
      },
      "businessIndustry": {
        "FOOD": "餐飲",
        "RETAILGOODS": "零售商品",
        "TRANSPORTATION": "運輸",
        "TOBACCO": "菸草",
        "FURNITURE": "家具",
        "JEWELLERY": "珠寶",
        "ELECTRONICS": "電子產品",
        "FINANCIALSERVICE": "金融服務",
        "REALESTATE": "房地產",
        "TRAVEL": "旅遊",
        "HOTELS": "飯店與住宿",
        "MEMBORG": "會員組織",
        "MEDIA": "社群媒體",
        "DRUGS": "藥品／藥局",
        "MARKETING": "直效行銷",
        "DATING": "約會與伴遊服務",
        "GAMBLING": "賭博",
        "OTHER": "其他"
      }
    },
    "UploadMessage": {
      "size": "檔案大小超過2MB限制",
      "limit": "已達上傳限制",
      "helpertext": "最多可上傳5個檔案，每個檔案不得超過2MB",
      "helpertext2": "用於驗證銀行帳戶持有人姓名、地址、帳號及日期",
      "fileFormat": "非有效的檔案格式"
    }
  },
  "Footer": {
    "button": {
      "TERMS_BUTTON": "條款與條件",
      "PRIVACY_BUTTON": "隱私政策"
    }
  },
  "ConfirmationDialogRaw": {
    "actionButton": {
      "title": "取消授權",
      "heading": "是否確定",
      "content": "是否確定要取消此交易？此操作無法復原",
      "Cancel": "取消",
      "Submit": "提交"
    },
    "voidButton": {
      "title": "取消授權",
      "heading": "是否確定",
      "content": "是否確定要取消此交易？此操作無法復原",
      "Cancel": "取消",
      "Submit": "提交"
    },
    "riskRule": {
      "title": "刪除",
      "heading": "是否確定？",
      "content": "您是否真的要刪除此記錄？此操作無法復原",
      "cancel": "取消",
      "submit": "提交"
    }
  },
  "RiskRule": {
    "TabLabel": "風險配置",
    "tooltipTitle": "新增風險規則",
    "Configure_Rules": "配置規則",
    "Risk_Control_for": "風險控制",
    "button": {
      "Close": "關閉"
    },
    "FileType": "僅支援CSV檔案格式"
  },
  "ActivateAccount": {
    "title": "啟用您的帳號",
    "description": "您的商戶帳號已成功建立。您可以繼續啟用帳號並重設密碼。",
    "breadcrumb": {
      "Home": "首頁",
      "activate": "啟用您的帳號"
    },
    "buttons": {
      "Activate": "啟用您的帳號"
    }
  },
  "languagecode": "en",
  "API_STATUS_MESSAGE": {
    "INFO0000": "付款成功",
    "INFO0001": "金額成功扣款",
    "INFO0002": "金額成功退款",
    "INFO0003": "授權已成功取消",
    "INFO0004": "交易狀態更新成功",
    "INFO0005": "查詢所有拒付案件詳情",
    "INFO0006": "查詢單一拒付案件詳情",
    "INFO0007": "狀態更新成功",
    "INFO0008": "申請已提交",
    "INFO0009": "已儲存為草稿",
    "INFO0010": "申請提交成功",
    "INFO0011": "文件已下載",
    "INFO0012": "申請詳情",
    "INFO1001": "Token已更新",
    "INFO1002": "您的密碼已成功重設",
    "INFO3000": "訂閱已更新",
    "INFO20000": "成功",
    "INFO3001": "交易處理中",
    "INFO3002": "交易失敗，請重試",
    "INFO3003": "交易已成功完成",
    "INFO_AB_0000": "成功",
    "INFO4000": "預設篩選條件新增成功",
    "INFO4001": "預設篩選條件更新成功",
    "INFO4002": "預設篩選條件刪除成功",
    "INFO4003": "預設篩選條件取得成功",
    "INFO4004": "已取得預設篩選條件",
    "INFO4010": "報表偏好新增成功",
    "INFO4011": "報表偏好更新成功",
    "INFO4012": "報表偏好刪除成功",
    "INFO4013": "已取得報表偏好",
    "INFO4014": "已取得報表偏好",
    "INFO4020": "交易下載排程新增成功",
    "INFO4021": "交易下載排程更新成功",
    "INFO4022": "交易下載排程刪除成功",
    "INFO4023": "已取得交易下載排程",
    "INFO4024": "已取得交易下載排程",
    "INFO4030": "交易欄位偏好新增成功",
    "INFO4031": "交易欄位偏好更新成功",
    "INFO4032": "交易欄位偏好刪除成功",
    "INFO4033": "已取得交易欄位偏好",
    "INFO4034": "已取得交易欄位偏好",
    "INFO_FS_O0050": "對帳單偏好新增成功",
    "INFO_FS_O0051": "對帳單偏好更新成功",
    "INFO_FS_O0052": "對帳單偏好刪除成功",
    "INFO_FS_O0053": "已取得對帳單偏好",
    "INFO_FS_O0054": "已取得對帳單偏好",
    "INFO_FS_O0056": "爭議偏好新增成功",
    "INFO_FS_O0057": "爭議偏好更新成功",
    "INFO_FS_O0058": "爭議偏好刪除成功",
    "INFO_FS_O0059": "已取得爭議偏好",
    "INFO_FS_O0060": "已取得爭議偏好",
    "INFO_AB_0001": "OTP已發送至您的電子郵件",
    "INFO_AB_0002": "OTP已驗證",
    "INFO_AB_0003": "OTP已重新發送至電子郵件",
    "INFO_AB_0004": "註冊完成，請登入",
    "INFO_AB_0005": "OTP已驗證",
    "INFO_AB_0006": "註冊完成，但登入時發生技術問題",
    "INFO_AB_0007": "找不到申請資料",
    "INFO_AB_0008": "申請已提交",
    "INFO_AB_0009": "已儲存為草稿",
    "INFO_AB_0010": "申請提交成功",
    "INFO_AB_0011": "文件已下載",
    "INFO_AB_0012": "申請詳情",
    "INFO_AB_0013": "已刪除…！",
    "INFO_AB_0014": "申請已核准",
    "INFO_AB_0015": "申請已拒絕",
    "INFO_AB_0016": "申請將於x天內移除",
    "INFO_AB_0017": "申請提交中，請稍後重新整理",
    "INFO_AB_0018": "價格設定提交成功",
    "INFO_ACQ_0000": "成功",
    "INFO_ACQ_0001": "收單MID已建立",
    "INFO_ACQ_0002": "收單MID已更新",
    "INFO_ACQ_0003": "收單機構已建立",
    "INFO_ACQ_0004": "收單機構詳情",
    "INFO_ACQ_0005": "收單機構清單",
    "INFO_ACQ_0006": "收單機構已更新",
    "INFO_AUTH_0000": "成功",
    "INFO_AUTH_0001": "Token已更新",
    "INFO_AUTH_0002": "您的密碼已成功重設",
    "INFO_AUTH_0003": "OTP已重新發送至電子郵件",
    "INFO_AUTH_0005": "OTP已發送至您的電子郵件",
    "INFO_CONFIG_0000": "成功",
    "INFO_CONFIG_0001": "已建立",
    "INFO_CONFIG_0002": "已更新",
    "INFO_CONFIG_0003": "已刪除",
    "INFO_FS_O0000": "檔案上傳成功，新資料正在處理中，將稍後顯示",
    "INFO_FS_O0001": "對帳單更新成功",
    "INFO_FS_O0002": "對帳單清單",
    "INFO_FS_O0003": "OTP已重新發送至電子郵件",
    "INFO_FS_O0004": "拒付案件已成功建立",
    "INFO_FS_O0005": "查看所有拒付案件詳情",
    "INFO_FS_O0006": "查看單一拒付案件詳情",
    "INFO_FS_O0007": "狀態更新成功",
    "INFO_FS_O0008": "查詢拒付紀錄 INFO_FS_o",
    "INFO_FS_O0009": "拒付案件更新成功",
    "INFO_FS_O0010": "查看拒付訊息詳情",
    "INFO_FS_O0011": "查看拒付歷史詳情",
    "INFO_FS_O0012": "檔案上傳成功",
    "INFO_FS_O0013": "請先關閉相同訂單編號的開啟案件",
    "INFO_FS_O0014": "檔案下載成功",
    "INFO_FS_O0015": "發現重複ARN，請重試",
    "INFO_FS_O0016": "必須先發起第一筆拒付",
    "INFO_FS_O0017": "請輸入有效的DASMID",
    "INFO_FS_O0018": "請輸入有效的案件ID",
    "INFO_FS_O0019": "請輸入有效的狀態",
    "INFO_FS_O0020": "假期清單詳情",
    "INFO_FS_O0021": "假期清單生成成功",
    "INFO_FS_O0022": "對帳單重新生成成功",
    "INFO_FS_O0023": "假期清單郵件發送成功",
    "INFO_FS_O0025": "請建立自動代表性拒付",
    "INFO_FS_O0026": "下載請求已發起",
    "INFO_FS_O0028": "所有對帳交易詳情",
    "INFO_FS_O0029": "交易同步",
    "INFO_FS_O0031": "Hashcard已更新",
    "INFO_FS_O0034": "Hash Card新增成功",
    "INFO_FS_O1000": "下載成功開始",
    "INFO_MS_0000": "成功",
    "INFO_MS_0001": "對帳單更新成功",
    "INFO_MS_0002": "對帳單清單",
    "INFO_MS_0003": "OTP已重新發送至電子郵件",
    "INFO_MS_0004": "狀態更新成功",
    "INFO_MS_0005": "感謝您的聯絡！",
    "INFO_MS_0006": "查找產品支援詳情",
    "INFO_MS_0007": "請選擇有效的產品類型",
    "INFO_MS_0008": "未找到符合該 DASMID／商戶ID 的產品",
    "INFO_MS_0009": "已更新該商戶DASMID的狀態",
    "INFO_MS_0010": "已成功取得循環訂閱方案",
    "INFO_MS_0011": "已成功取得方案詳情",
    "INFO_MS_0012": "請輸入有效的方案ID",
    "INFO_MS_0013": "方案建立成功",
    "INFO_MS_0014": "方案更新成功",
    "INFO_MS_0015": "訂閱詳情",
    "INFO_MS_0016": "訂閱編輯成功",
    "INFO_MS_0017": "請輸入有效的訂閱ID",
    "INFO_MS_0018": "訂閱已存在",
    "INFO_MS_0019": "訂閱取消成功",
    "INFO_MS_0020": "找不到訂閱",
    "INFO_MS_0021": "訂閱方案已存在",
    "INFO_MS_0022": "訂閱者詳情",
    "INFO_MS_0023": "找不到訂閱者",
    "INFO_MS_0024": "訂閱者電子郵件已存在",
    "INFO_MS_0025": "訂閱者建立成功",
    "INFO_MS_0026": "查找訂閱者詳情",
    "INFO_MS_0027": "無法更新正在運行的訂閱方案",
    "INFO_MS_0028": "查找商戶及商戶配置詳情",
    "INFO_MS_0029": "無法編輯訂閱",
    "INFO_MS_0030": "請輸入有效的 DASMID",
    "INFO_MS_0031": "無法刪除正在使用的訂閱方案",
    "INFO_MS_0032": "方案刪除成功",
    "INFO_MS_0033": "電子郵件發送成功！",
    "INFO_MS_0034": "糟糕！您目前已訂閱",
    "INFO_MS_0035": "訂閱者已成功刪除",
    "INFO_MS_0036": "未找到訂閱方案",
    "INFO_MS_0037": "使用者建立成功",
    "INFO_MS_0038": "所有使用者詳情",
    "INFO_MS_0039": "使用者詳情",
    "INFO_MS_0040": "找不到使用者",
    "INFO_MS_0041": "使用者已存在",
    "INFO_MS_0042": "使用者已刪除",
    "INFO_MS_0043": "使用者啟用／停用成功",
    "INFO_MS_0044": "使用者更新成功",
    "INFO_MS_0045": "訂閱者資料更新成功",
    "INFO_MS_0046": "商戶詳情",
    "INFO_MS_0047": "已建立",
    "INFO_MS_0048": "已更新",
    "INFO_MS_0049": "已刪除",
    "INFO_MS_0050": "產品詳情",
    "INFO_MS_0051": "密碼重設成功",
    "INFO_MS_0052": "請登出後重新登入以切換帳號",
    "INFO_MS_0055": "分類建立成功",
    "INFO_MS_0056": "分類更新成功",
    "INFO_MS_0057": "分類刪除成功",
    "INFO_MS_0059": "產品建立成功",
    "INFO_MS_0060": "產品更新成功",
    "INFO_MS_0061": "產品刪除成功",
    "INFO_MS_0063": "Webhook建立成功",
    "INFO_MS_0064": "Webhook更新成功",
    "INFO_MS_0065": "Webhook清單",
    "INFO_MS_0066": "商戶IP清單",
    "INFO_MS_0067": "商戶IP建立成功",
    "INFO_MS_0068": "商戶IP更新成功",
    "INFO_MS_0069": "商戶IP刪除成功",
    "INFO_MS_0070": "商戶IP資料",
    "INFO_PBL_0000": "成功",
    "INFO_PBL_0001": "已建立新訂單以透過連結付款",
    "INFO_PBL_0002": "已更新",
    "INFO_PBL_0003": "已建立",
    "INFO_PBL_0004": "已刪除",
    "INFO_PBL_0005": "訂單連結已停用",
    "INFO_PBL_0006": "圖片上傳成功",
    "INFO_DX_0000": "成功",
    "ERR0000": "拒絕存取",
    "ERR0001": "發生錯誤，請重試",
    "ERR0002": "發生錯誤",
    "ERR0003": "無法建立連線，請重試",
    "ERR0004": "OTP已過期",
    "ERR0005": "已超過重試次數，請重新產生OTP",
    "ERR0006": "OTP無效",
    "ERR0007": "已超過最大重試次數",
    "ERR0008": "電子郵件未驗證",
    "ERR0009": "已找到Payment Options電子郵件識別",
    "ERR0010": "申請未處理",
    "ERR0011": "上傳失敗",
    "ERR0012": "下載失敗",
    "ERR0013": "無法移除檔案",
    "ERR0014": "無法取得申請詳情",
    "ERR0015": "找不到申請資料",
    "ERR0016": "不支援的國家",
    "ERR0017": "無效的使用者ID",
    "ERR0018": "無效的使用者ID",
    "ERR0019": "無資料",
    "ERR0020": "無法取得詳細資料",
    "ERR0024": "使用者不存在",
    "ERR0025": "無法為停用使用者重設密碼",
    "ERR0030": "此電子郵件地址已被加入",
    "ERR0100": "金額超過允許上限",
    "ERR0101": "卡片無效",
    "ERR0102": "卡片已過期",
    "ERR0103": "不支援的卡片",
    "ERR0104": "安全性違規",
    "ERR0105": "不允許用於循環扣款授權",
    "ERR0106": "付款資訊無效",
    "ERR0107": "FraudWall已攔截此交易",
    "ERR0108": "付款請求缺少訂閱資料",
    "ERR0109": "無效的訂閱ID",
    "ERR0110": "缺少dfReferenceId",
    "ERR0111": "規則名稱已存在，請使用不同名稱",
    "ERR0201": "請輸入有效的扣款金額",
    "ERR0202": "可扣款金額不足",
    "ERR0203": "金額不可為小數",
    "ERR0204": "可退款金額不足",
    "ERR0205": "無效的交易ID",
    "ERR0206": "交易狀態無法更新為相同狀態",
    "ERR0207": "非有效的扣款交易",
    "ERR0208": "無效的DASMID",
    "ERR1000": "API未實作",
    "ERR1001": "使用者名稱或密碼錯誤",
    "ERR1002": "無效的使用者會話",
    "ERR1003": "Refresh token已過期或使用者已登出系統",
    "ERR1004": "Payment Options電子郵件，請聯絡支援",
    "ERR1005": "使用者尚未註冊",
    "ERR1006": "無效的OTP",
    "ERR1007": "無效的驗證碼，請重新請求",
    "ERR1008": "已超過嘗試次數限制，請稍後再試",
    "ERR1009": "無效請求",
    "ERR1010": "使用者已停用，請聯絡支援團隊",
    "ERR10000": "無效的URL",
    "ERR10001": "無效金額",
    "ERR10002": "無效訂閱或缺少訂閱資料",
    "ERR10003": "連結中未找到任何資料",
    "ERR3000": "無效的訂閱DASMID",
    "ERR3001": "無效的交易ID",
    "ERR3002": "只有啟用中的訂閱才可暫停",
    "ERR3003": "訂閱取消失敗",
    "ERR3004": "無法恢復該訂閱",
    "ERR3019": "退款餘額不足",
    "ERR3020": "退款餘額不足",
    "ERR0211": "不允許退款",
    "ERR0213": "已超過允許退款量限制，請聯絡支援團隊以獲取協助",
    "ERR0214": "此名稱的預設篩選已存在於該使用者",
    "ERR0223": "該使用者已存在同名交易欄位偏好",
    "ERR0224": "您無權管理此交易欄位偏好",
    "ERR0225": "找不到提供UUID的交易欄位偏好",
    "ERR_FS_O0020": "該使用者已存在同名對帳單偏好",
    "ERR_FS_O0021": "您無權管理此對帳單偏好",
    "ERR_FS_O0022": "找不到提供UUID的對帳單偏好",
    "ERR_FS_O0025": "該使用者已存在同名爭議偏好",
    "ERR_FS_O0026": "您無權管理此爭議偏好",
    "ERR_FS_O0027": "找不到提供UUID的爭議偏好",
    "ERR_ACQ_0001": "請提供收單機構名稱",
    "ERR_ACQ_0002": "收單機構已存在",
    "ERR_ACQ_0003": "找不到收單機構",
    "ERR_ACQ_0004": "找不到收單MID",
    "ERR_ACQ_0005": "請輸入唯一的收單MID",
    "ERR_AUTH_0001": "使用者名稱或密碼錯誤",
    "ERR_AUTH_0002": "無效的使用者會話",
    "ERR_AUTH_0003": "Refresh token已過期或使用者已登出系統",
    "ERR_AUTH_0004": "Payment Options電子郵件，請聯絡支援",
    "ERR_AUTH_0005": "使用者尚未註冊",
    "ERR_AUTH_0006": "無效的OTP",
    "ERR_AUTH_0007": "無效的驗證碼",
    "ERR_AUTH_0008": "已超過嘗試次數限制",
    "ERR_AUTH_0009": "無效請求",
    "ERR_AUTH_0010": "使用者已停用",
    "ERR_AUTH_0011": "密碼政策無效",
    "ERR_AUTH_0012": "使用者已存在於使用者池中",
    "ERR_AUTH_0013": "無效的電子郵件",
    "ERR_AUTH_0014": "使用者屬性錯誤",
    "ERR_AUTH_0015": "使用者已存在",
    "ERR_AUTH_0016": "新密碼不可與目前密碼相同",
    "ERR_AUTH_0018": "因多次登入失敗，您的帳號已被鎖定，請於60分鐘後再試",
    "ERR_AUTH_0019": "您輸入的驗證碼錯誤或已過期",
    "ERR_CONFIG_0000": "",
    "ERR_CONFIG_0001": "重複的規則",
    "ERR_FS_O0000": "尚未實作",
    "ERR_FS_O0001": "該緊急假期日期已存在，請選擇其他日期",
    "ERR_FS_O0002": "該日期已存在相同名稱的假期，請選擇不同日期",
    "ERR_MS_0021": "無效的方案ID",
    "ERR_MS_0022": "方案必須屬於相同MID",
    "ERR_MS_0023": "非啟用中的方案",
    "ERR_MS_0024": "無法編輯訂閱",
    "ERR_MS_0025": "無效請求",
    "ERR_MS_0026": "使用者名稱或電子郵件已存在",
    "ERR_MS_0027": "訂閱方案已存在",
    "ERR_MS_0028": "無法更新正在運行的訂閱方案",
    "ERR_MS_0029": "無法刪除該方案",
    "ERR_MS_0030": "無法刪除訂閱者",
    "ERR_MS_0034": "該電子郵件已註冊",
    "ERR_MS_0036": "請提供所有可用DASMID",
    "ERR_MS_0037": "商戶IP已存在",
    "ERR_PBL_0001": "請輸入正確的DASMID",
    "ERR_PBL_0002": "所有產品必須使用相同幣別",
    "ERR_AB_0000": "拒絕存取",
    "ERR_AB_0001": "發生錯誤，請重試",
    "ERR_AB_0002": "該電子郵件已註冊",
    "ERR_AB_0003": "找不到使用者資料",
    "ERR_AB_0004": "OTP已過期",
    "ERR_AB_0005": "已超過重試次數，請重新產生OTP",
    "ERR_AB_0006": "無效的OTP",
    "ERR_AB_0007": "已超過最大重試次數，請聯絡支援",
    "ERR_AB_0008": "電子郵件未驗證",
    "ERR_AB_0009": "已找到Payment Options電子郵件識別",
    "ERR_AB_0010": "申請未處理",
    "ERR_AB_0011": "上傳失敗",
    "ERR_AB_0012": "下載失敗",
    "ERR_AB_0013": "無法移除檔案",
    "ERR_AB_0014": "無法取得申請詳情",
    "ERR_AB_1000": "API未實作",
    "ERR_AB_0015": "找不到申請資料",
    "ERR_AB_0016": "不支援的國家",
    "ERR_AB_0017": "無效的使用者ID",
    "ERR_AB_0018": "無效申請",
    "ERR_AB_0019": "申請不完整",
    "ERR_AB_0020": "至少需填寫一位利益相關者",
    "ERR_AB_0021": "至少需填寫一位授權簽署人",
    "ERR_AB_0022": "註冊編號或公司名稱重複",
    "ERR_AB_0023": "至少需填寫一位最終受益人（UBO）",
    "ERR_AB_0024": "申請已處理",
    "ERR_AB_0025": "所選付款類型不允許新增定價",
    "ERR_AB_0026": "客戶尚未完成申請",
    "ERR_AB_0027": "無法將申請推送至DASPOS",
    "ERR_AB_0028": "無效推薦碼",
    "ERR_AB_0029": "通訊錯誤",
    "ERR_AB_0030": "電子郵件不可與主要聯絡電子郵件相同",
    "ERR_AB_0031": "主要聯絡人不可超過一位",
    "ERR_AB_0032": "不允許修改",
    "ERR_AB_0033": "第三方用戶需提供申請ID",
    "ERR_AB_0034": "請重新驗證電子郵件",
    "ERR_AB_0035": "外部銷售類型不允許修改",
    "ERR_AB_0036": "使用者未選擇此產品",
    "ERR_AB_0037": "此申請不允許新增補充資訊請求",
    "ERR_AB_0038": "補充資訊請求尚未完成",
    "ERR_AB_0039": "此請求已完成",
    "ERR_AB_0040": "第三方申請不允許設定定價",
    "ERR_AB_0041": "推薦碼未啟用",
    "ERR_AB_0042": "申請審核已在進行中",
    "ERR_AB_0043": "密碼政策無效",
    "ERR_AB_0044": "尚未提交定價",
    "ERR_AB_0045": "轉售商申請尚未獲銷售團隊核准",
    "ERR_9000": "請求過多",
    "VAL1001": "需要Token詳情",
    "VAL1002": "需要Access Token",
    "VAL1003": "需要ID Token",
    "VAL1004": "需要Refresh Token",
    "VAL1005": "需要OTP",
    "VAL1006": "密碼不一致",
    "VAL1007": "需提供確認密碼",
    "VAL1008": "OTP長度無效",
    "VAL0001": "金額無效",
    "VAL0002": "幣別無效",
    "VAL0003": "需提供auto_capture",
    "VAL0004": "客戶IP無效",
    "VAL0005": "缺少卡片資訊",
    "VAL0006": "缺少帳單國家",
    "VAL0007": "請提供有效電子郵件",
    "VAL0008": "請提供有效電話號碼",
    "VAL0009": "地址第一行缺失",
    "VAL0010": "地址第二行缺失",
    "VAL0011": "缺少城市",
    "VAL0012": "缺少州／省",
    "VAL0013": "缺少郵遞區號",
    "VAL0014": "無效的訂閱方案名稱",
    "VAL0015": "無效的訂閱方案類型",
    "VAL0016": "無效的訂閱方案期限",
    "VAL0017": "無效的訂閱週期",
    "VAL0018": "缺少MID",
    "VAL0019": "無效的訂閱方案描述",
    "VAL0020": "需提供公司成立日期",
    "VAL0021": "無效的訂閱週期類型",
    "VAL0022": "",
    "VAL0023": "無效的訂閱結束類型",
    "VAL0024": "無效的訂閱間隔週期",
    "VAL0025": "缺少或無效的最大循環次數",
    "VAL0026": "是否有試用期需為布林值",
    "VAL0027": "無效的試用期類型",
    "VAL0028": "無效的試用期設定",
    "VAL0029": "是否有折扣需為布林值",
    "VAL0030": "無效的利益相關者ID",
    "VAL0031": "無效的折扣期限",
    "VAL0032": "無效的CVC",
    "VAL0033": "無效的卡片到期月份",
    "VAL0034": "無效的卡片到期年份",
    "VAL0035": "無效的持卡人姓名",
    "VAL0036": "無效的卡號",
    "VAL0037": "無效的利益相關者UBO",
    "VAL0038": "商戶交易參考超過45個字元限制",
    "VAL0039": "無效的商戶ID",
    "VAL0040": "無效的Webhook URL",
    "VAL0041": "無效的成功URL",
    "VAL0042": "無效的失敗URL",
    "VAL0043": "無效的Session ID",
    "VAL0044": "非有效整數",
    "VAL0045": "非有效數字",
    "VAL0046": "非有效的付款方式類型",
    "VAL0047": "無效的訂閱ID",
    "VAL0048": "無效的PaymentMethod.hasServerApi",
    "VAL0049": "無效的PaymentMethod.hasQR",
    "VAL0050": "無效的PaymentMethod.hasPBL",
    "VAL0051": "無效的PaymentMethod.hasVISA",
    "VAL0052": "無效的PaymentMethod.hasMastercard",
    "VAL0053": "無效的PaymentMethod.hasJCB",
    "VAL0054": "無效的PaymentMethod.hasAMEX",
    "VAL0055": "無效的PaymentMethod.hasUPI",
    "VAL0056": "無效的PaymentMethod處理幣別",
    "VAL0057": "無效的PaymentMethod整合類型",
    "VAL0058": "無效的PaymentMethod產品描述",
    "VAL0059": "無效的PaymentMethod交易國家",
    "VAL0060": "無效的平均交易金額",
    "VAL0061": "無效的平均交易幣別",
    "VAL0062": "無效的最大交易金額",
    "VAL0063": "無效的最大交易幣別",
    "VAL0064": "無效的年度總預估金額",
    "VAL0065": "無效的年度總預估幣別",
    "VAL0066": "無效的網站",
    "VAL0067": "無效的是否儲存信用卡資訊",
    "VAL0068": "無效的是否為卡片交易",
    "VAL0069": "無效的退款率",
    "VAL0070": "無效的平均退款",
    "VAL0071": "無效的拒付率",
    "VAL0072": "無效的平均拒付",
    "VAL0073": "無效的付款詳情ID",
    "VAL0074": "無效的付款資料帳號",
    "VAL0075": "無效的付款資料結算幣別",
    "VAL0076": "無效的付款資料銀行名稱",
    "VAL0077": "無效的付款資料銀行國家",
    "VAL0078": "無效的付款資料付款頻率",
    "VAL0079": "無效的付款資料刪除文件選項",
    "VAL0080": "無效的利益相關者刪除文件選項",
    "VAL0081": "無效的商業刪除文件選項",
    "VAL0082": "無效的利益相關者刪除選項",
    "VAL0083": "無效的PaymentMethod是否支援循環扣款",
    "VAL0084": "無效的居住國家",
    "VAL0085": "無效的IBAN",
    "VAL0086": "商業營業名稱為必填",
    "VAL0087": "商業是否有郵寄地址為必填",
    "VAL0088": "商業郵寄地址為必填",
    "VAL0089": "商業郵寄城市為必填",
    "VAL0090": "商業郵寄國家為必填",
    "VAL0091": "商業郵遞區號為必填",
    "VAL0092": "PaymentMethod技術架構欄位為必填",
    "VAL0093": "無效的銀行帳戶名稱",
    "VAL0094": "無效的SWIFT代碼",
    "VAL0095": "商業是否需要營業執照為必填",
    "VAL0096": "無效的MCC",
    "VAL0097": "無效的付款類型",
    "VAL0098": "無效的頻率類型",
    "VAL0099": "無效的MDR卡片折扣率",
    "VAL0100": "無效的設置費",
    "VAL0101": "無效的交易費",
    "VAL0102": "無效的退款處理費",
    "VAL0103": "無效的拒付處理費",
    "VAL0104": "無效的拒絕費",
    "VAL0105": "無效的查詢請求費",
    "VAL0106": "無效的預仲裁費",
    "VAL0107": "無效的再提交費",
    "VAL0108": "無效的欺詐監控費",
    "VAL0109": "無效的狀態",
    "VAL0147": "PaymentMethod.storePaymentMethod無效",
    "VAL0148": "PaymentMethod.storedPaymentMethodId無效",
    "VAL_AB_0001": "電子郵件無效",
    "VAL_AB_0002": "電子郵件過長",
    "VAL_AB_0003": "ID為必填",
    "VAL_AB_0004": "ID無效",
    "VAL_AB_0005": "OTP為必填",
    "VAL_AB_0006": "名字為必填",
    "VAL_AB_0007": "姓氏為必填",
    "VAL_AB_0008": "聯絡電話為必填",
    "VAL_AB_0009": "業務所在地為必填",
    "VAL_AB_0010": "密碼為必填",
    "VAL_AB_0011": "密碼長度過短／過長",
    "VAL_AB_0012": "OTP需為數字",
    "VAL_AB_0013": "使用者ID為必填",
    "VAL_AB_0014": "使用者ID無效",
    "VAL_AB_0015": "業務所在地為必填",
    "VAL_AB_0016": "公司名稱為必填",
    "VAL_AB_0017": "註冊編號為必填",
    "VAL_AB_0018": "公司類型為必填",
    "VAL_AB_0019": "其他公司類型為必填",
    "VAL_AB_0020": "公司成立日期為必填",
    "VAL_AB_0021": "註冊地址為必填",
    "VAL_AB_0022": "商業郵遞區號為必填",
    "VAL_AB_0023": "商業城市為必填",
    "VAL_AB_0024": "無效的申請ID",
    "VAL_AB_0025": "無效的文件ID",
    "VAL_AB_0026": "文件名稱為必填",
    "VAL_AB_0027": "文件資料為必填",
    "VAL_AB_0028": "文件類型為必填",
    "VAL_AB_0029": "商業ID無效",
    "VAL_AB_0030": "無效的利益相關者ID",
    "VAL_AB_0031": "主要利益相關者缺失／無效",
    "VAL_AB_0032": "利益相關者名字缺失",
    "VAL_AB_0033": "利益相關者姓氏無效",
    "VAL_AB_0034": "利益相關者出生日期無效",
    "VAL_AB_0035": "利益相關者電話號碼無效",
    "VAL_AB_0036": "利益相關者電子郵件無效",
    "VAL_AB_0037": "無效的UBO利益相關者",
    "VAL_AB_0038": "利益相關者持股比例無效",
    "VAL_AB_0039": "利益相關者授權狀態無效",
    "VAL_AB_0040": "利益相關者身份證明ID無效",
    "VAL_AB_0041": "利益相關者職位無效",
    "VAL_AB_0042": "利益相關者地址無效",
    "VAL_AB_0043": "利益相關者郵遞區號無效",
    "VAL_AB_0044": "利益相關者城市無效",
    "VAL_AB_0045": "利益相關者國籍無效",
    "VAL_AB_0046": "無效的PaymentMethod ID",
    "VAL_AB_0047": "PaymentMethod.hasHpp無效",
    "VAL_AB_0048": "PaymentMethod.hasServerApi無效",
    "VAL_AB_0049": "PaymentMethod.hasQR無效",
    "VAL_AB_0050": "PaymentMethod.hasPBL無效",
    "VAL_AB_0051": "PaymentMethod.hasVISA無效",
    "VAL_AB_0052": "PaymentMethod.hasMastercard無效",
    "VAL_AB_0053": "PaymentMethod.hasJCB無效",
    "VAL_AB_0054": "PaymentMethod.hasAMEX無效",
    "VAL_AB_0055": "PaymentMethod.hasUPI無效",
    "VAL_AB_0056": "PaymentMethod處理幣別無效",
    "VAL_AB_0057": "PaymentMethod整合類型無效",
    "VAL_AB_0058": "PaymentMethod產品描述無效",
    "VAL_AB_0059": "PaymentMethod交易國家無效",
    "VAL_AB_0060": "PaymentMethod平均交易金額無效",
    "VAL_AB_0061": "PaymentMethod平均交易幣別無效",
    "VAL_AB_0062": "PaymentMethod最大交易金額無效",
    "VAL_AB_0063": "PaymentMethod最大交易幣別無效",
    "VAL_AB_0064": "PaymentMethod年度總預估金額無效",
    "VAL_AB_0065": "PaymentMethod年度總預估幣別無效",
    "VAL_AB_0066": "PaymentMethod網站無效",
    "VAL_AB_0067": "PaymentMethod是否儲存信用卡資訊無效",
    "VAL_AB_0068": "PaymentMethod是否為卡片交易無效",
    "VAL_AB_0069": "PaymentMethod退款率無效",
    "VAL_AB_0070": "PaymentMethod平均退款無效",
    "VAL_AB_0071": "PaymentMethod拒付率無效",
    "VAL_AB_0072": "PaymentMethod平均拒付無效",
    "VAL_AB_0073": "付款詳情ID無效",
    "VAL_AB_0074": "付款詳情帳號無效",
    "VAL_AB_0075": "無效的結算貨幣",
    "VAL_AB_0076": "付款詳情銀行名稱無效",
    "VAL_AB_0077": "付款詳情銀行國家無效",
    "VAL_AB_0078": "付款詳情付款頻率無效",
    "VAL_AB_0079": "付款詳情刪除文件選項無效",
    "VAL_AB_0080": "利益相關者刪除文件選項無效",
    "VAL_AB_0081": "商業刪除文件選項無效",
    "VAL_AB_0082": "利益相關者刪除選項無效",
    "VAL_AB_0083": "PaymentMethod是否支援循環扣款無效",
    "VAL_AB_0084": "居住國家無效",
    "VAL_AB_0085": "IBAN無效",
    "VAL_AB_0086": "商業營業名稱為必填",
    "VAL_AB_0087": "商業是否有郵寄地址為必填",
    "VAL_AB_0088": "商業郵寄地址為必填",
    "VAL_AB_0089": "商業郵寄城市為必填",
    "VAL_AB_0090": "商業郵寄國家為必填",
    "VAL_AB_0091": "商業郵遞區號為必填",
    "VAL_AB_0092": "PaymentMethod是否符合PCI DSS為必填",
    "VAL_AB_0093": "付款詳情銀行帳戶名稱無效",
    "VAL_AB_0094": "付款詳情SWIFT代碼無效",
    "VAL_AB_0095": "商業是否需要營業執照為必填",
    "VAL_AB_0096": "無效的MCC",
    "VAL_AB_0097": "無效的付款類型",
    "VAL_AB_0098": "無效的頻率類型",
    "VAL_AB_0099": "無效的MDR卡片折扣率",
    "VAL_AB_0100": "無效的設置費",
    "VAL_AB_0101": "無效的交易費",
    "VAL_AB_0102": "無效的退款處理費",
    "VAL_AB_0103": "無效的拒付處理費",
    "VAL_AB_0104": "無效的拒絕費",
    "VAL_AB_0105": "無效的查詢請求費",
    "VAL_AB_0106": "無效的預仲裁費",
    "VAL_AB_0107": "無效的再提交費",
    "VAL_AB_0108": "無效的欺詐監控費",
    "VAL_AB_0109": "無效的狀態",
    "VAL_AB_0110": "無效的維護與支援費",
    "VAL_AB_0111": "無效的推薦碼",
    "VAL_AB_0112": "請提供使用者類型",
    "VAL_AB_0113": "推薦碼不適用於第三方",
    "VAL_AB_0114": "無效的使用者類型",
    "VAL_AB_0115": "備註不可為空",
    "VAL_AB_0116": "無效的文件類型",
    "VAL_AB_0117": "無效的資訊ID",
    "VAL_AB_0118": "無效的文件類型",
    "VAL_AB_0119": "無效的業務性質",
    "VAL_AB_0120": "無效的第三方類型",
    "VAL_AB_0121": "無效的3PL商戶實體清單",
    "VAL_AB_0122": "PaymentMethod.settlementCurrencyForHpp幣別無效",
    "VAL_AB_0123": "PaymentMethod.settlementCurrencyForRecurring幣別無效",
    "VAL_AB_0124": "PaymentMethod.settlementCurrencyForServerApi幣別無效",
    "VAL_AB_0125": "PaymentMethod.settlementCurrencyForQR幣別無效",
    "VAL_AB_0126": "PaymentMethod.settlementCurrencyForPBL幣別無效",
    "VAL_AB_0127": "無效的公司網站",
    "VAL_AB_0128": "無效的利益相關者身份類型",
    "VAL_AB_0129": "無效的股票代碼",
    "VAL_AB_0130": "缺少中間名",
    "VAL_AB_0131": "無效的業務性質（其他）",
    "VAL_AB_0132": "無效的其他第三方類型",
    "VAL_AB_0133": "無效的員工人數",
    "VAL_AB_0134": "無效的推薦請求ID",
    "VAL_AB_0135": "推薦請求電子郵件無效",
    "VAL_AB_0136": "推薦請求公司名稱為必填",
    "VAL_AB_0137": "推薦請求聯絡人名稱無效",
    "VAL_AB_0138": "推薦請求訊息無效",
    "VAL_AB_0139": "推薦請求推薦連結為必填",
    "VAL_AB_0140": "推薦請求轉售商名稱為必填",
    "VAL_AB_0141": "推薦請求推薦碼為必填",
    "VAL_AB_0142": "推薦請求標準MDR為必填",
    "VAL_AB_0143": "推薦請求微型MDR為必填",
    "VAL_AB_0144": "無效的付款明細分行代碼",
    "VAL_AB_0145": "無效的付款明細銀行代碼",
    "VAL_AB_0146": "推薦請求語言為必填",
    "VAL_AB_0147": "無效的檔案",
    "VAL_ACQ_0000": "",
    "VAL_AUTH_0001": "電子郵件無效",
    "VAL_AUTH_0002": "ID為必填",
    "VAL_AUTH_0003": "密碼不一致",
    "VAL_AUTH_0004": "無效的ID",
    "VAL_AUTH_0005": "OTP為必填",
    "VAL_AUTH_0010": "密碼為必填",
    "VAL_AUTH_0011": "密碼長度過短／過長",
    "VAL_AUTH_0012": "OTP需為數字",
    "VAL_AUTH_0013": "使用者ID為必填",
    "VAL_AUTH_0014": "使用者ID無效",
    "VAL_AUTH_0015": "需要Token資訊",
    "VAL_AUTH_0016": "需要Access Token",
    "VAL_AUTH_0017": "需要ID Token",
    "VAL_AUTH_0018": "需要Refresh Token",
    "VAL_AUTH_0019": "需要OTP",
    "VAL_AUTH_0020": "密碼不一致",
    "VAL_AUTH_0021": "需提供確認密碼",
    "VAL_AUTH_0022": "OTP長度無效",
    "VAL_CONFIG_0000": "",
    "VAL_DP_0001": "無效金額",
    "VAL_DP_0002": "無效幣別",
    "VAL_DP_0003": "需提供auto_capture",
    "VAL_DP_0004": "客戶IP無效",
    "VAL_DP_0005": "缺少卡片資料",
    "VAL_DP_0006": "缺少帳單國家",
    "VAL_DP_0007": "請提供有效電子郵件",
    "VAL_DP_0008": "請提供有效電話號碼",
    "VAL_DP_0009": "地址第一行缺失",
    "VAL_DP_0010": "地址第二行缺失",
    "VAL_DP_0011": "城市缺失",
    "VAL_DP_0012": "州／省缺失",
    "VAL_DP_0013": "郵遞區號缺失",
    "VAL_DP_0014": "無效訂閱方案名稱",
    "VAL_DP_0015": "無效訂閱方案類型",
    "VAL_DP_0016": "無效訂閱方案期限",
    "VAL_DP_0017": "無效訂閱方案週期",
    "VAL_DP_0018": "缺少MID",
    "VAL_DP_0019": "無效訂閱方案描述",
    "VAL_DP_0020": "",
    "VAL_DP_0021": "無效的訂閱週期類型",
    "VAL_DP_0022": "",
    "VAL_DP_0023": "無效的訂閱結束類型",
    "VAL_DP_0024": "無效的訂閱間隔週期",
    "VAL_DP_0025": "最大循環次數缺失或無效",
    "VAL_DP_0026": "Expecting boolean for has trial period",
    "VAL_DP_0027": "無效的試用期類型",
    "VAL_DP_0028": "無效的試用期設定",
    "VAL_DP_0029": "折扣設定需為布林值",
    "VAL_DP_0030": "無效的折扣百分比",
    "VAL_DP_0031": "無效的折扣期限",
    "VAL_DP_0032": "效的CVC",
    "VAL_DP_0033": "無效的卡片到期月份",
    "VAL_DP_0034": "無效的卡片到期年份",
    "VAL_DP_0035": "無效的持卡人姓名",
    "VAL_DP_0036": "無效的卡號",
    "VAL_DP_0037": "商戶交易參考為必填",
    "VAL_DP_0038": "商戶交易參考超過45個字元限制",
    "VAL_DP_0039": "無效的商戶ID",
    "VAL_DP_0040": "無效的Webhook URL",
    "VAL_DP_0041": "無效的成功URL",
    "VAL_DP_0042": "無效的失敗URL",
    "VAL_DP_0043": "無效的Session ID",
    "VAL_DP_0044": "非有效整數",
    "VAL_DP_0045": "非有效數字",
    "VAL_DP_0047": "無效的訂閱ID",
    "VAL_DP_0048": "非有效的Paymentmethod.type",
    "VAL_DP_0049": "非有效的Paymentmethod.storePaymentMethod",
    "VAL_DP_0050": "非有效的Paymentmethod.storedPaymentMethodId",
    "VAL_DP_0051": "非有效的產品",
    "VAL_DP_0052": "非有效的DASMID",
    "VAL_MS_0085": "需要訂閱者資訊",
    "VAL_MS_0086": "需要訂閱者電子郵件",
    "VAL_MS_0087": "需要訂閱者名字",
    "VAL_MS_0088": "需要訂閱者姓氏",
    "VAL_MS_0089": "需要方案ID",
    "VAL_MS_0090": "無效的訂閱類型",
    "VAL_MS_0091": "無效的訂閱結束時間",
    "VAL_MS_0092": "無效的訂閱開始時間",
    "VAL_MS_0093": "無效的最大循環次數",
    "VAL_MS_0094": "需要DASMID",
    "VAL_MS_0095": "缺少訂閱者資料",
    "VAL_MS_0096": "非有效的連結過期日期",
    "VAL_PBL_0000": "",
    "VAL_FS_O0008": "ROLLING_RESERVE_HELD 的值無效",
    "VAL_FS_O0006": "ROLLING_RESERVE_RELEASED 的值無效",
    "VAL_FS_O0004": "FixedDepositHeldYTDAmount 的值無效",
    "VAL_FS_O0002": "AdjustmentsAmount 的值無效",
    "VAL_FS_O0003": "NetSales 的值無效",
    "VAL_FS_O0001": "TotalFees 的值無效",
    "defaultErrorMsg": "伺服器內部錯誤",
    "CUSTOM_ERR001": "檔案大小必須小於2 MB",
    "ACTION_STATEMENTUPDATE": "對帳單更新成功",
    "ACTION_STATEMENTUPDATEFAILED": "對帳單更新失敗",
    "ADD_NEW_FILTER_ERROR": "請輸入篩選值",
    "INFO_FS_O0032": "Hashcard已存在",
    "INFO_FS_O0033": "交易白名單更新成功",
    "INFO_FS_O0038": "Hashcard已在白名單中",
    "INFO_FS_O0039": "Hashcard不在白名單中",
    "ERR_MS_0039": "產品SKU／代碼已存在",
    "ERR_MS_0040": "類別名稱已存在",
    "VAL100001": "資料格式無效，請檢查後再試",
    "INVALID_FILTER_ERROR": "請輸入有效的篩選值"
  },
  "React-Tour": {
    "Configuration": {
      "Transactions": {
        "heading": "交易",
        "content": "此處可查看所有交易記錄，並可對單筆交易進行退款或扣款操作。"
      },
      "Statements": {
        "heading": "對帳單",
        "content": "可查詢所有商戶結算對帳單，並可檢視或下載副本。"
      },
      "Merchants": {
        "heading": "商戶",
        "content": "點擊此處查看您的商戶資料及DASMID資訊。"
      },
      "dispute-Management": {
        "heading": "爭議管理",
        "content": "若有拒付案件需要處理，通知鈴鐺圖示將會顯示，點擊即可查看案件詳情。"
      },
      "sales-Lead": {
        "heading": "銷售線索",
        "content": "使用您的推薦碼提交的商戶申請將顯示於此，您可選擇核准或拒絕申請。"
      },
      "Filter": {
        "heading": "搜尋篩選",
        "content": "使用進階篩選條件，以特定規則篩選搜尋結果清單。"
      },
      "language": {
        "heading": "語言切換",
        "content": "使用此功能可將系統介面切換至您偏好的語言。"
      },
      "user": {
        "heading": "使用者設定",
        "content": "點擊此處可查看帳號設定並登出系統。"
      },
      "Buttons": {
        "LetsGo": "開始吧！"
      }
    },
    "ResellerConfiguration": {
      "SalesLead": {
        "heading": "銷售線索",
        "content": "透過您的推薦碼提交的商戶申請將顯示於此，您可選擇核准或拒絕這些申請。"
      },
      "Partner": {
        "heading": "合作夥伴",
        "content": "存取您的合作夥伴帳戶資料並查看您的推薦詳情。您可以將推薦連結分享給任何有意接入支付網關的潛在商戶。"
      },
      "Filter": {
        "heading": "搜尋篩選",
        "content": "使用進階篩選條件，以預設條件篩選搜尋結果清單。"
      },
      "language": {
        "heading": "語言切換",
        "content": "使用此選項可將系統切換為您偏好的語言。"
      },
      "user": {
        "heading": "使用者設定",
        "content": "點擊此處查看帳戶設定並登出系統"
      },
      "Buttons": {
        "LetsGo": "開始吧！"
      }
    }
  },
  "ContactUs": {
    "BreadCrumb": {
      "Home": "首頁",
      "Help & Support": "幫助與支援"
    },
    "tabs": {
      "Contact": "聯絡我們"
    },
    "SupportForm": {
      "Send us your request": "提交您的請求",
      "fields": {
        "Subject": "主旨",
        "Ticket Type": "工單類型",
        "values": {
          "Technical Issue": "技術問題",
          "sales": "商業／銷售機會",
          "Change Request": "變更請求",
          "others": "其他"
        },
        "Product": "產品",
        "Description": "描述",
        "Document": "附加檔案",
        "helperText": {
          "Optional Message": "最多500個字元"
        },
        "file_upload": {
          "file Size": "檔案過大，最大允許大小為$maxSize MB，目前檔案大小為$size MB",
          "image Type": "檔案格式不支援"
        }
      },
      "buttons": {
        "Send Request": "發送請求",
        "Cancel": "取消",
        "Reset": "重置"
      }
    },
    "Documentation": {
      "Documentation": "文件說明",
      "Latest": "最新",
      "Archieved": "歸檔",
      "Links": {
        "API Integration Manual": "API整合手冊",
        "User Guide Manual": "使用者指南手冊",
        "Release Notes": "版本更新紀錄／變更日誌"
      }
    }
  },
  "SalesLead": {
    "Heading": "商戶註冊",
    "PartnerHeading": "合作夥伴註冊",
    "Status": "狀態：",
    "RegisterationNumber": "申請參考ID：",
    "BreadCrumb": {
      "Home": "首頁",
      "Application": "商戶上線",
      "PartnerApplication": "合作夥伴上線"
    },
    "AccountsTab": {
      "MerchantAccount": "商戶申請",
      "PartnerAccount": "合作夥伴申請",
      "ComingSoon": "即將推出"
    },
    "columnDefs": {
      "Action": "操作",
      "RegisterationNumber": "申請參考ID",
      "ApplicationDate": "申請日期",
      "CustomerLegalName": "商戶帳號",
      "BusinessLocation": "業務所在地",
      "Email": "電子郵件地址",
      "RegistrationType": "註冊類型",
      "Status": "狀態",
      "Products": "產品",
      "MerchantAccount": "商戶帳號",
      "PartnerName": "合作夥伴名稱"
    },
    "StatusType": {
      "PENDING": "待處理",
      "APPROVED": "已核准",
      "REJECTED": "已拒絕",
      "NOTSUPPORTEDCOUNTRY": "國家不支援",
      "INPROGRESS": "進行中",
      "APPROVALINPROGRESS": "核准進行中",
      "PENDINGFORDELETION": "待刪除",
      "INPROGRESS_REG_NOT_COMPLETED": "未提交"
    },
    "OnBoarding_Content": {
      "APPROVE": "核准",
      "REJECT": "拒絕",
      "ADD": "新增定價",
      "VIEW": "查看定價"
    },
    "RegisterationType": {
      "REFERRAL": "推薦",
      "SELF": "自行"
    },
    "PricingContent": {
      "heading": "新增定價",
      "PricingHeading": "定價詳情",
      "FormFields": {
        "MCC": "商戶類別代碼",
        "MDR_CARD": "綜合MDR卡片折扣率",
        "SETUP_FEE": "設置費",
        "SUPPORT_FEE_FREQUENCY": "維護與支援費頻率",
        "ANNUAL_FEE": {
          "MONTHLY": "每月",
          "ANNUAL": "年費"
        },
        "ANNUAL_MONTHLY_FEE": "年費／月費",
        "TRANSACTION_FEE": "交易費",
        "REFUND_PROCESSING_FEE": "退款處理費",
        "CHARGEBACK_PROCESSING_FEE": "拒付處理費",
        "DECLINE_FEE": "拒絕費",
        "RETRIEVAL_REQUEST_FEE": "查詢請求費",
        "PRE_ARBITRATION_FEE": "預仲裁費",
        "REPRESENTMENT_FEE": "再提交費",
        "FRAUD_MONITORING_FEE": "欺詐監控費",
        "StandardMDRRate": "標準MDR費率",
        "MicroMDRRate": "小額MDR費率",
        "Buttons": {
          "Submit": "提交",
          "Cancel": "取消"
        }
      }
    },
    "SubmitPricing": {
      "title": "提交定價",
      "heading": "尚未新增定價",
      "content": "請在付款方式頁籤中為所選產品新增定價後再提交",
      "ok": "確定",
      "goToPaymentMethods": "前往付款方式"
    },
    "ApprovePopup": {
      "title": "核准",
      "heading": "是否確定？",
      "content": "是否確定要核准此申請？此操作無法復原",
      "message": {
        "settlementFailed": "申請核准失敗",
        "settlementSuccess": "申請已核准"
      },
      "button": {
        "cancel": "取消",
        "submit": "核准"
      }
    },
    "RejectPopup": {
      "title": "拒絕",
      "heading": "是否確定？",
      "content": "是否確定要拒絕此申請？此操作無法復原",
      "message": {
        "settlementFailed": "申請拒絕失敗",
        "settlementSuccess": "申請已拒絕"
      },
      "button": {
        "cancel": "取消",
        "submit": "拒絕"
      }
    },
    "warningMessage": "請注意，部分產品尚未新增定價"
  },
  "TermsAndConditionsHeading": "條款與條件",
  "TermsAndCondtions": {
    "BeforeLinkDescription": "如果您繼續瀏覽並使用本網站，即表示您同意遵守以下使用條款與條件。這些條款與我們的隱私政策共同規範 Payment Options 與您之間就本網站的關係。本使用條款（以下稱「條款」）可能會由我們不時修訂，並構成您使用本網站的依據。",
    "AfterLinkDescription": "「網站」）並提供有關我們提供服務方式的重要資訊。透過存取本網站，即表示您同意受本條款的法律約束。若您不同意本條款，則不得使用本網站。本網站由 Payment Options Pte Ltd 擁有及營運（以下簡稱 Payment Options）。本條款中所指的「Payment Options」或「我們」指本網站的擁有人。本條款中所指的「您」指本網站的使用者或瀏覽者。",
    "DeclerationFirst": "1. 免責聲明",
    "DeclerationFirstDetails": "本網站及其內容僅供一般資訊用途，本網站或其內容均不構成法律、資料保護合規或其他專業意見。對於因依賴本網站所載資訊或資料而可能引致的任何損失，我們概不承擔任何責任。在適用法律允許的最大範圍內，我們對您或任何第三方存取或使用本網站及其內容所引起的任何事項概不負責或承擔任何責任。",
    "DeclerationSecond": "2. 版權及商標",
    "DeclerationSecondDetails": "本網站、網站內容、網站程式碼、域名，以及所有版權、商標、公司名稱及其他知識產權或相關權利，均由網站營運者及／或其授權方及／或內容提供者全權擁有，並受適用的本地及國際知識產權法律保護。除非獲得網站營運者明確許可，您不得以任何形式或方式複製、擷取、重製、演出、轉讓、出售、授權、修改、創作衍生作品、再發布、提交、編輯、發佈、傳送、公開展示、嵌入、分發或以其他方式使用本網站、網站內容或網站程式碼的全部或任何部分。本網站所包含的商標或標誌，未經 Payment Options 事先書面同意，不得以任何方式複製、發布、分發或使用。",
    "DeclerationThird": "3. 授權條款",
    "DeclerationThirdDetails": "網站營運者依據本條款授予您非專屬、不可轉讓及有限的權利與授權，以存取及使用本網站及網站內容，前提是您必須完全遵守本條款。您同意不得干擾或破壞本網站的正常運作，亦不得違反任何適用法律要求。",
    "DeclerationFourth": "4. 適用法律及司法管轄權",
    "DeclerationFourthDetails": "本條款受適用法律管轄。",
    "DeclerationFifth": "5. 變更事項",
    "DeclerationFifthDetails": "Payment Options 可隨時依其自行酌情權，全部或部分變更、修改、新增或移除本網站、網站內容及／或本條款。本條款之任何變更於發布後立即生效。您同意定期查閱本條款，以了解任何更新或變更。",
    "DeclerationSixth": "6. 網站導航資訊",
    "DeclerationSixthDetails": "Payment Options 使用常見的資訊收集工具（例如 Cookies）來收集您瀏覽本公司網站時的資訊（以下稱「網站導航資訊」）。本節說明網站可能收集的網站導航資訊類型，以及該等資訊的使用方式。",
    "SixthSubDetailsContainer": {
      "SixthSubDetailOne": "6.1 Cookies",
      "SixthSubDetailOneDescription": "Payment Options 使用 Cookies 以使網站互動更簡便及更具意義。當您瀏覽本網站時，Payment Options 的伺服器會向您的電腦傳送 Cookies。該等 Cookies 不會識別您的個人身份，只會識別您的網頁瀏覽器。除非您透過開立帳戶或填寫網頁表格（例如「聯絡我」）向 Payment Options 提供身份資料，否則您在公司系統中仍屬匿名。Payment Options 使用兩種類型的 Cookies：基於會話（Session-based）及持續性（Persistent-based）。會話 Cookies 僅在單次瀏覽期間存在，當您關閉瀏覽器或關機後即會消失。持續性 Cookies 在您關閉瀏覽器或關機後仍會保留於您的裝置中。若您選擇識別身份，Payment Options 會使用包含加密資訊的會話 Cookies，以唯一識別您的身份。每次登入服務時，系統會在瀏覽器中放置一個含加密唯一識別碼的會話 Cookies，以識別您的帳戶並處理線上交易及請求。使用服務時必須啟用會話 Cookies。Payment Options 使用的持續性 Cookies 只能由本公司讀取，用以識別曾經訪問網站的瀏覽器。當您購買服務或提供個人資料時，系統會分配唯一識別碼並與持續性 Cookies 連結。本公司對持續性 Cookies 中儲存資訊的安全性及保密性非常謹慎，例如不會在其中儲存帳號或密碼。若停用瀏覽器 Cookies，您仍可瀏覽網站，但將無法正常使用相關服務。Payment Options 可能會將會話及持續性 Cookies 的資訊，與經匿名化的客戶個人資料結合，用於向您提供有關 Payment Options 及其服務的資訊。",
      "SixthSubDetailTwo": "6.2 Flash Cookies",
      "SixthSubDetailTwoDescription": "Payment Options 可能使用本機共享物件（亦稱 Flash Cookies），以儲存您的偏好設定，或根據您在本網站的瀏覽內容來展示資訊，以個人化您的使用體驗。與 Payment Options 合作以提供特定功能或根據您的網頁瀏覽行為投放廣告的第三方，也可能使用 Flash Cookies 來收集及儲存相關資訊。",
      "SixthSubDetailThree": "6.3 IP 位址",
      "SixthSubDetailThreeDescription": "當您瀏覽本公司網站時，我們會收集您的網際網路協定位址（Internet Protocol，「IP」）以追蹤及彙總非個人資料。例如，Payment Options 會使用 IP 位址來監測客戶及訪客瀏覽本網站的地區來源。",
      "SixthSubDetailFour": "6.4 第三方 Cookies",
      "SixthSubDetailFourDescription": "不時，Payment Options 會委託第三方追蹤及分析訪客使用網站的統計數據與流量資訊。提供予第三方的資料不包括個人資料，但在公司取得該資訊後，這些資料可能會與個人資料重新關聯。",
      "SixthSubDetailFive": "6.5 連結至其他網站",
      "SixthSubDetailFiveDescription": "本公司網站可能包含其他有關網站的連結。當您使用這些連結離開本網站後，請注意我們無法控制該等第三方網站。因此，我們無法對您在瀏覽該等第三方網站時所提供的任何個人資料之私隱保護承擔責任。在向第三方網站披露任何個人資料前，您應謹慎行事，並先查閱該等第三方網站的隱私政策。"
    },
    "DeclerationSeven": "7. 聯絡方式",
    "DeclerationSevenOneDetails": "如需有關 Payment Options 網站及所提供服務的任何資訊，請聯絡我們：",
    "DeclerationSevenTwoDetails": "",
    "DeclerationEight": "8. 語言",
    "DeclerationEightDetails": "如本《使用條款》出現任何爭議，應以英文版本為準。本《使用條款》的英文版本在各方面均具約束力，並在與任何翻譯版本不一致時優先適用。本《使用條款》中的任何內容均不會限制您在適用法律下所享有的權利。"
  },
  "PrivacyPolicyHeading": "隱私政策",
  "ResellerAccount": {
    "breadcrumbs": {
      "Home": "首頁"
    },
    "tabs": {
      "Account": "合作夥伴帳戶",
      "Statements": "佣金報表"
    },
    "button": {
      "CREATE_ACCOUNT": "建立帳戶"
    },
    "fields": {
      "RefferalCode": "推薦碼"
    },
    "columnDefs": {
      "Action": "操作",
      "ResellerName": "合作夥伴名稱",
      "ContactPerson": "聯絡人",
      "Email": "電子郵件地址",
      "Date": "建立日期",
      "ReferredMerchants": "被推薦商戶",
      "STATUS": "狀態",
      "Country": "國家",
      "Products": "產品"
    },
    "StatusTypes": {
      "ACTIVE": "啟用",
      "CLOSED": "停用"
    },
    "TypeOfThirdParty": {
      "EXTSALS": "外部銷售代理",
      "RESELLER": "合作夥伴",
      "REFERRAL": "推薦人",
      "INDIVIDUAL": "個人",
      "OTHER": "其他"
    }
  },
  "ResellerDetails": {
    "breadcrumbs": {
      "Home": "首頁",
      "Partner": "合作夥伴",
      "Partner Details": "合作夥伴詳情"
    },
    "AllDetails": {
      "label": "合作夥伴詳情",
      "PersonalDetails": {
        "Partner Name": "合作夥伴名稱",
        "Address": "地址",
        "City": "城市",
        "Country": "國家"
      },
      "ContactDetails": {
        "Contact Details": "聯絡資料",
        "First Name": "名字",
        "Middle Name": "中間名",
        "Last Name": "姓氏",
        "Telephone Number": "電話號碼",
        "Email": "電子郵件地址"
      },
      "ReferralDetails": {
        "Referral Details": "推薦詳情",
        "Referral Code": "推薦碼",
        "Referral Link": "推薦連結"
      },
      "ReferredMerchants": {
        "Referral Merchants": "被推薦商戶"
      },
      "ResellerCommissionRates": {
        "label": "轉售商佣金比例",
        "columnDefs": {
          "MdrToMerchant": "商戶MDR",
          "Commission": "佣金"
        }
      }
    },
    "SendReferralLinkViaEmail": {
      "Create Email": "建立電子郵件",
      "Description Text": "請填寫表單以透過電子郵件發送您的推薦連結",
      "Email Address": "電子郵件地址",
      "Company Name": "公司名稱",
      "Contact Person Name": "聯絡人姓名",
      "Message": "訊息",
      "Referral Link": "推薦連結",
      "Send": "發送",
      "Standard MDR Rate": "標準MDR費率",
      "Micro MDR Rate": "小額MDR費率",
      "Min Value": "數值必須大於0",
      "Max Value": "數值必須小於或等於100",
      "Language": "選擇語言"
    },
    "CreateEmai": "建立電子郵件",
    "MERCHANT": "商戶",
    "THIRDPARTY": "第三方",
    "Merchant": "商戶",
    "Partner": "合作夥伴",
    "MerchantRegistration": "商戶註冊",
    "PartnerRegistration": "合作夥伴註冊",
    "Onboarding": "上線流程"
  },
  "Onfido_Message": {
    "UPDATE_KYC": {
      "Title_Update_KYC": "更新KYC",
      "POPUP_TEXT": "<p>Click on <strong>&quot;START VERIFICATION &quot;</strong> to Initiate Your KYC</p><p>OR Copy Below Link to Share</p>",
      "VERIFY_YOUR_IDENTITY": "驗證您的身份",
      "BTN_CANCEL": "取消",
      "BTN_START_KYC": "開始KYC"
    },
    "KYC_Processing_STATUS": {
      "Thank You": "謝謝",
      "Completed": "您的KYC已成功完成",
      "Processing": "您的KYC驗證正在處理中",
      "Review": "您的KYC驗證正在審核中",
      "Failed": "您的KYC驗證失敗",
      "update": "您的電腦可能需要幾秒鐘更新",
      "Continue to Stakeholders": "繼續至利益相關者"
    },
    "Document_List": "文件清單",
    "Document_Name": "文件名稱",
    "Download": "下載",
    "Document_Type": "文件類型",
    "Document_Side": "文件頁面",
    "Uploaded_At": "上傳時間",
    "Document_Refresh": "重新整理文件清單",
    "Complete_Your_KYC": "完成您的KYC",
    "Retry_Your_KYC": "重新嘗試KYC",
    "Prompt_Message": {
      "requiredKYC": "所有利益相關者的KYC狀態必須為已完成",
      "Tooltip": "所有利益相關者的KYC狀態必須為已完成"
    },
    "KYC_STATUS": {
      "Pending": "待處理",
      "Completed": "已完成",
      "Rejected": "已拒絕",
      "Processing": "處理中",
      "Review": "審核中",
      "Manual KYC required": "需手動KYC"
    }
  },
  "MFA": {
    "SETUP_DEVICE": "設置裝置",
    "SUBMIT_BUTTON": "提交"
  },
  "RISK_RULES": {
    "Action": "操作",
    "Create Rule": "建立規則",
    "UpdatedAt": "更新日期",
    "CreatedAt": "建立日期",
    "Assignments": "層級",
    "Conditions": "條件",
    "IsActive": "狀態",
    "RuleType": "規則類型",
    "Name": "規則名稱",
    "Updated": "已更新",
    "Created": "已建立",
    "LevelDASMID": "層級 DAS商戶編號",
    "LevelMerchant": "層級商戶",
    "LevelAcquirer": "層級收單機構",
    "LevelEntity": "層級實體",
    "Description": "描述",
    "Rule Description": "規則描述",
    "Duration Unit": "持續時間單位",
    "Duration Value": "持續時間值",
    "Velocity Limit": "成功付款次數限制",
    "Timezone": "時區",
    "Duration": "時間範圍",
    "Add Condition": "新增條件",
    "Please Click On Add Button to Add Conditions": "請點擊新增按鈕以加入條件",
    "Add Level": "新增層級",
    "Please Click On Add Button to Add Assignments": "請點擊新增按鈕以加入指派",
    "Level Value": "層級值",
    "Level Type": "層級類型",
    "File Upload": "檔案上傳",
    "Value": "值",
    "Field": "欄位",
    "Aggregate": "匯總",
    "Operator": "運算子",
    "No items": "無項目",
    "Whitelist": "白名單",
    "Blacklist": "黑名單",
    "Type to Search": "輸入以搜尋",
    "Risk Rule Details": "風險規則詳情",
    "Column_Def": {
      "Assignments": "指派",
      "Conditions": "條件"
    },
    "Popup_Content": {
      "Confirm Rule Deletion": "確認刪除規則",
      "Are you sure?": "是否確定？",
      "Do you really want to delete": "是否確定要刪除",
      "This process can not be undone.": "此操作無法復原"
    }
  },
  "HashCard": {
    "Add Hash Card": "新增雜湊卡",
    "Edit Hash Card": "編輯雜湊卡",
    "Export to Excel": "匯出Excel",
    "Current Year Only": "匯出Excel（僅限今年）",
    "Previous Comments": "先前備註",
    "Hash Card Details": "雜湊卡詳情",
    "Column_Def": {
      "Hash Card Number": "雜湊卡號",
      "Status": "狀態",
      "Created Date": "建立日期",
      "Created By": "建立者",
      "Updated Date": "更新日期",
      "Updated By": "更新者"
    },
    "Form_Fields": {
      "Hash Card Number": "雜湊卡號",
      "Status": "狀態",
      "Comments": "備註"
    },
    "ApprovePopup": {
      "titleAdd": "新增雜湊卡",
      "titleEdit": "更新雜湊卡",
      "heading": "是否確定？",
      "contentAdd": "是否確定要新增雜湊卡號？",
      "contentEdit": "是否確定要更新雜湊卡狀態？",
      "button": {
        "cancel": "取消",
        "submit": "提交"
      },
      "Validation": {
        "ExactLength": "雜湊卡號必須為32個字元",
        "MaxLength": "最多128個字元"
      }
    }
  },
  "Transaction_Xray": {
    "Transaction X-Ray": "交易追蹤分析",
    "API Response": "API回應",
    "Please Select any service for the Api requests and responses": "請選擇任一服務以查看API請求與回應",
    "Request": "請求",
    "Processor": "處理方",
    "Acquirer": "收單機構"
  },
  "User_Settings": {
    "Select File Format": "選擇報表格式",
    "default": "預設",
    "Select Date Format": "選擇日期格式",
    "Select Currency": "選擇匯總貨幣",
    "No previously selected list found": "尚未找到先前選擇的清單",
    "Column Preference": "欄位偏好設定",
    "Report Preference": "報表偏好設定",
    "Add Custom Preference List": "新增自訂偏好清單",
    "Add Report Preference List": "新增報表偏好清單",
    "Preference List error message": "名稱已存在，請輸入唯一名稱",
    "Custom Preference List": "自訂偏好清單",
    "Custom Report Preference List": "選擇報表偏好清單",
    "Edit Column Preference List": "編輯報表偏好清單",
    "Do you really want to update the custom report preference list?": "是否確定要更新報表偏好清單？",
    "Add Statement Preference List": "新增對帳單偏好清單",
    "Add Statement Preference": "新增對帳單偏好設定",
    "Delete Statement Preference List": "刪除對帳單偏好清單",
    "Edit Statement Preference List": "編輯對帳單偏好清單",
    "Do you really want to update the statement preference list?": "是否確定要更新對帳單偏好清單？",
    "Select Preferred Statement List": "選擇偏好對帳單清單",
    "Custom Statement Preference List": "選擇對帳單偏好清單",
    "Add Transaction Preference List": "新增交易偏好清單",
    "Add Transaction Preference": "新增交易偏好清單",
    "Transaction Preference": "交易偏好清單",
    "Statement Preference": "對帳單偏好清單",
    "Select Preferred Transaction List": "選擇偏好交易清單",
    "Custom Transaction Preference List": "選擇交易偏好清單",
    "Select Preferred List": "選擇偏好清單",
    "Select Preferred Report List": "選擇偏好報表清單",
    "Enter List Name": "輸入清單名稱",
    "Delete Preference List": "刪除偏好清單",
    "Delete Transaction Preference List": "刪除交易偏好清單",
    "Delete Report Preference List": "刪除報表偏好清單",
    "Edit Transaction Preference List": "編輯交易偏好清單",
    "Are you sure?": "是否確定？",
    "Download Started": "下載已開始",
    "Do you really want to delete this record? This process can not be undone": "是否確定要刪除此清單？此操作無法復原",
    "Do you really want to update the transaction preference list?": "是否確定要更新交易偏好清單？",
    "Email Notification": "電子郵件通知",
    "Email Notification Settings": "電子郵件通知設定",
    "Email Notification Settings Description": "為主要聯絡人選擇／取消選擇電子郵件通知",
    "Default list applied": "已套用預設清單",
    "Dispute Preference List": "爭議偏好清單",
    "Delete Dispute Preference List": "刪除爭議偏好清單",
    "Edit Dispute Preference List": "編輯爭議偏好清單",
    "Do you really want to update the dispute preference list?": "是否確定要更新爭議偏好清單？",
    "Custom Dispute Preference List": "選擇爭議偏好清單",
    "Add Dispute Preference List": "新增爭議偏好清單",
    "tabs": {
      "Report Format": "下載報表格式",
      "Date Format": "日期格式",
      "Date Report Format": "報表與日期格式",
      "Email Notification": "電子郵件通知",
      "Report Preference": "報表偏好設定"
    },
    "notifications": {
      "Chargeback": "退單",
      "Statement": "對帳單",
      "Emergency Holiday": "緊急假期",
      "Monthly Public Holiday": "每月公眾假期"
    },
    "dateFormats": {
      "DATE_TIME_AM_PM": "日 月 年，hh:mm:ss 上午／下午（例如：21 十一月 2024，2:04:28 下午）",
      "DATE_TIME_DMY": "日 月 年，HH:mm:ss（例如：21 十一月 2024，14:04:28）",
      "DATE_TIME_YMD": "年／月／日 HH:mm:ss（例如：2024／11／21 14:04:28）"
    },
    "fileFormat": {
      "EXCEL": "Excel",
      "CSV": "CSV"
    },
    "buttons": {
      "Save": "儲存",
      "Add": "新增"
    }
  },
  "applicationApprovalLevel": {
    "0": "",
    "1": "唯讀",
    "10": "輸入員",
    "20": "經理",
    "30": "部門主管",
    "40": "董事總經理",
    "50": "集團主管",
    "60": "集團董事總經理"
  },
  "DasPay_Receipts":{
    "tx": "交易編號",
    "Payment": "付款方式",
    "Total": "總計",
    "MID": "MID",
    "TID": "終端機編號",
    "Batch": "批次號",
    "Trace": "追蹤號碼",
    "RRN": "檢索參考號碼",
    "ApprovalCode": "授權碼",
    "AdditionalInformation": "附加資訊",
    "TransactionId": "交易編號",
    "STATE": "狀態",
    "DateTime": "日期時間",
    "ATC": "應用交易計數器",
    "TVR": "終端驗證結果",
    "AppName": "應用程式名稱",
    "TSI": "交易狀態資訊",
    "AID": "AID",
    "TC": "TC",
    "DigitalSignature": "數位簽章",
    "SignedAt": "簽署地點",
    "ShareWithOthers": "與他人分享",
    "Email": "電子郵件",
    "Share": "分享",
    "PrintReceipt": "列印收據",
    "TransactionType": "交易類型"
  },
  "PresetFilter": {
    "Select Preset": "選擇預設",
    "Update": "更新",
    "Delete": "刪除",
    "Save": "儲存",
    "Enter Name": "輸入名稱",
    "Update Name": "更新名稱",
    "Cancel": "取消",
    "Add Preset": "新增預設",
    "Update Preset": "更新預設",
    "Confirm Delete": "刪除預設篩選",
    "Are you sure you want to delete?": "確定要刪除此預設篩選嗎？此操作無法復原。",
    "Name Already Exists": "已存在相同名稱的預設篩選。"
  },
  "Report Days": "報表日期",
  "Weekly": "每週",
  "ScheduleReport": {
    "Add": "新增排程報表",
    "Edit": "編輯排程報表",
    "Previous Comments": "先前備註",
    "Weekdays": {
      "Sunday": "星期日",
      "Monday": "星期一",
      "Tuesday": "星期二",
      "Wednesday": "星期三",
      "Thursday": "星期四",
      "Friday": "星期五",
      "Saturday": "星期六"
    },
    "Column_Def": {
      "Name": "排程名稱",
      "Status": "狀態",
      "Report Name": "報表名稱",
      "Reporting Timezone": "報表時區",
      "Reporting Period": "報表期間",
      "Created By": "建立者",
      "Updated Date": "更新日期",
      "Updated By": "更新者",
      "Comments": "備註",
      "Report Preference": "報表偏好設定"
    },
    "Form_Fields": {
      "Name": "排程名稱",
      "Status": "狀態",
      "Report Name": "報表名稱",
      "Reporting Timezone": "報表時區",
      "Reporting Period": "報表期間",
      "Reporting Preference": "報表偏好設定",
      "Preset Filter": "預設篩選條件",
      "Include Sensitive Columns": "包含敏感欄位",
      "Include Whitelist Transactions": "包含白名單交易",
      "Report Format": "報表格式",
      "Reporting Time": "報表時間",
      "Report Day": "報表日期",
      "Comments": "備註"
    },
    "ReportName": {
      "Transactions": "交易"
    },
    "ReportingPeriod": {
      "Today": "今日",
      "Yesterday": "昨日",
      "Weekly": "結算每週",
      "Month to Date": "本月至今",
      "Month Start to Yesterday": "本月開始至昨日",
      "Previous Month": "上個月",
      "Last 30 Days": "最近30天",
      "Last 7 Days": "最近7天",
      "Years to Date": "年初至今"
    },
    "Validation":
    {
      "DuplicateName": "已有同名排程報表，請提供不同的名稱。"
    }
  },
};
export default common;
